export default {
  "messages": {
    "payment_terms": "Conditions de paiement :",
    "primary_contact": "Contact principal:",
    "outstanding_invoices": "Factures impayées",
    "invoice": "Facture n°",
    "bill_date": "Date de facture fournisseur",
    "due_date": "Date d’échéance",
    "days_past_due": "Jours passés attendus",
    "balance_due": "Solde dû",
    "status": "Statut",
    "actions": "Actions",
    "draft": "projet de projet",
    "view": "Afficher",
    "no_outstanding_posted_bills_for_this_supplier": "Pas de factures affichées impayées pour ce fournisseur.",
    "close": "Fermer",
    "pay_selected_bills": "Payer certains factures",
    "payment_date": "Date de paiement",
    "payment_method": "Mode de paiement",
    "select_method": "Sélectionner la méthode",
    "bank_account": "Compte bancaire",
    "select_bank_account": "Sélectionnez le compte bancaire",
    "bank_account_required_for_bank_payments": "Compte bancaire requis pour les paiements bancaires.",
    "reference_memo": "Référence / Mémoire",
    "pay_full_balances": "Payer les soldes complets",
    "supplier": "Fournisseur",
    "amount_to_pay": "Montant à payer",
    "no_bills_selected": "Aucune facture fournisseur sélectionnée.",
    "total_to_pay": "Total à payer",
    "cancel": "Annuler",
    "bill_details": "facture",
    "loading_bill_details": "Charger les détails de la facture...",
    "description": "Description",
    "qty": "Qté",
    "unit_price": "Prix unitaire",
    "amount": "Montant",
    "no_line_items_recorded": "Aucun élément de ligne n ' a été enregistré.",
    "reference": "Référence",
    "method": "Méthode",
    "allocated": "Affecté",
    "no_allocations_recorded": "Aucune allocation n'a été enregistrée.",
    "no_bill_found": "Aucun facture n'est trouvé.",
    "vendor": "Vendeur",
    "search_suppliers": "Les fournisseurs de recherche...",
    "loading_suppliers": "Charger les fournisseurs...",
    "no_suppliers_found": "Aucun fournisseur n'a été trouvé.",
    "vendor_is_required": "Le vendeur est requis.",
    "vendor_invoice": "Facture du vendeur",
    "invoice_number_is_required": "Le numéro de facture est requis.",
    "show_all_account_types": "Afficher tous les types de compte",
    "loading_accounts": "Chargement des comptes...",
    "loading_dimensions": "Dimensions de chargement...",
    "loading_tax_codes": "Charger les codes fiscaux...",
    "tax_codes_failed_to_load_defaulting_to_no_tax": "Les codes fiscaux n'ont pas été chargés.",
    "tax_code": "Code fiscal",
    "gl_account": "Compte du grand livre",
    "dimension": "Dimension",
    "no_tax": "Pas d'impôt",
    "tax": "Taxe",
    "select_account": "Sélectionnez le compte",
    "no_dimension": "Aucune dimension",
    "add_at_least_one_line_with_an_amount": "Ajouter au moins une ligne avec un montant.",
    "add_line": "Ajouter la ligne",
    "total": "Total",
    "notes": "Notes",
    "optional_notes": "Notes facultatives",
    "saving": "Enregistrement…",
    "record_ap_payment": "Enregistrement du paiement AP",
    "payment_amount": "Montant du paiement",
    "paid_date": "Date de la paye",
    "apply": "Appliquer",
    "allocate": "Affecter",
    "draft_2": "Brouillon",
    "allocated_total": "Total total",
    "unapplied_amount": "Montant non appliqué",
    "recording": "Enregistrement...",
    "record_payment": "Paiements",
    "from": "De",
    "to": "To",
    "generate": "Génération",
    "opening_balance": "Solde ouvert",
    "closing_balance": "Solde de clôture",
    "bill": "facture",
    "no_bills_found_for_this_period": "Aucun facture n'a été trouvé pour cette période.",
    "no_payments_found_for_this_period": "Aucun paiement n'a été trouvé pour cette période.",
    "select_a_date_range_to_generate_a_statement": "Sélectionnez une plage de date pour générer une déclaration.",
    "employee": "Employé",
    "unassigned": "Non attribué",
    "retry": "Réessayer",
    "generating": "Generating...",
    "generated": "Générée",
    "sending": "Envoi…",
    "privana_assist": "Privana Aide",
    "warning": "avertissement",
    "employees": "Employés",
    "rate": "Taux",
    "calendar": "Calendrier",
    "team_member": "Membre de l ' équipe",
    "creating": "Créer...",
    "saving_2": "Enregistrement…",
    "cancel_close": "Annuler / Fermer",
    "save_changes": "Sauvegarder les changements",
    "profile": "Profil",
    "pending": "pendant l ' attente",
    "currency": "Monnaie",
    "tax_code_2": "Code fiscal",
    "audit_trail": "Journal d’audit",
    "system": "Système",
    "account": "Compte",
    "debit": "Débit",
    "credit": "Crédit",
    "preview": "Aperçu",
    "status_filter": "Filtre à statut",
    "all_statuses": "Tous les statuts",
    "submit": "Soumettre",
    "approve": "Approfondissement",
    "reject": "Rejet",
    "save_draft": "Échec",
    "loading": "Chargement…",
    "adjustments": "Ajustements",
    "working": "Travailler...",
    "posted": "Comptabilisé",
    "next_step": "Prochaine étape",
    "publishing": "La publication...",
    "hide": "C'est ça.",
    "audit_trail_2": "Schéma de vérification",
    "needs_review": "Examen des besoins",
    "configured": "Configurer",
    "default": "Par défaut",
    "edit": "Modifier",
    "active": "actif",
    "archived": "Archivé",
    "manual": "Manuel",
    "priority": "Priorité:",
    "review": "Examen",
    "suppliers": "Fournisseurs",
    "payroll": "Solde",
    "statement": "État",
    "void": "Annulé",
    "date": "Date",
    "manage": "Gérer",
    "payment_amount_2": "Montant du paiement",
    "select_gl_account": "Sélectionnez le compte GL",
    "set_as_default": "Définir par défaut",
    "name": "Nom",
    "save": "Enregistrer",
    "bank_reconciliation": "Réconciliation bancaire",
    "refresh": "Actualiser",
    "all_status": "Tous les statuts",
    "unmatched": "Inégalé",
    "reviewed_unmatched": "Révisé (sans objet)",
    "matched": "Associés",
    "disputed": "Différend",
    "all": "Tous",
    "reviewed": "Révisé",
    "unreviewed": "Non examiné",
    "bank_reconciliation_settings": "Modalités de rapprochement des banques",
    "edit_bank_accounts": "Modifier les comptes bancaires",
    "upload_statement_csv": "Énoncé de charge ( CSV )",
    "matched_transactions": "Transactions correspondantes",
    "automatch_rate": "Taux d ' automatch",
    "reconciliation_session": "Session de réconciliation",
    "not_ready": "Pas prêt.",
    "reviewed_unmatched_2": "Révisé, sans égal",
    "statement_period": "Période couverte par le rapport",
    "staff": "Personnel",
    "bank_transactions": "Opérations bancaires",
    "mark_reviewed": "Note révisée",
    "mark_unreviewed": "Marque non revue",
    "select_all_transactions": "Sélectionnez toutes les transactions",
    "match_confidence": "Confiance de Match",
    "find_match": "Trouver le Match",
    "upload_statement_csv_2": "État de téléchargement CSV",
    "choose_csv_file": "Choisir le fichier CSV",
    "first_row_is_header": "La première rangée est en tête",
    "strip_currency_symbols": "Symboles de devises",
    "parsing_csv": "Analyse du CSV…",
    "date_column": "Colonne de date *",
    "select_column": "Sélectionnez la colonne",
    "description_column": "Description de la colonne *",
    "amount_signed": "Montant (signé)",
    "debit_column": "Colonne de débit",
    "credit_column": "Chiffre de crédit",
    "reference_column": "Colonne de référence",
    "date_format": "Format de date",
    "select_format": "Sélectionnez le format",
    "running_balance_column": "Chiffre de la balance",
    "direction": "Direction",
    "date_range": "Période",
    "total_inflows": "Total des entrées",
    "total_outflows": "Total des sorties",
    "force_import_duplicates": "Doublons d ' importation de la force",
    "continue": "Continuer",
    "import": "Importation",
    "view_details": "Voir détails",
    "actual": "Effectif effectif",
    "budget": "Budget",
    "difference": "Différence",
    "department": "Département",
    "variance": "Écart",
    "chart_of_accounts": "Graphique de compte",
    "manage_account_codes_used_in_the_general_ledger": "Gérer les codes de compte utilisés dans le grand livre.",
    "back_to_general_ledger": "Retour au Général Ledger",
    "new_account": "Nouveau compte",
    "search_by_code_or_name": "Recherche par code ou nom",
    "code": "Code",
    "type": "Type",
    "no_accounts_found": "Aucun compte trouvé.",
    "activate": "Activation",
    "deactivate": "Désactiver",
    "define_the_account_code_and_defaults_for_this_gl_account": "Définir le code de compte et les défauts pour ce compte GL.",
    "account_code": "Code de compte",
    "account_name": "Nom du compte",
    "subtype": "Sous-type",
    "optional": "Facultatif",
    "inactive_accounts_are_hidden_by_default": "Les comptes inactifs sont cachés par défaut.",
    "manager": "Responsable",
    "create": "Créer",
    "update": "Mise à jour",
    "credit_amount": "Montant du crédit",
    "reason": "Raison",
    "refund": "Remboursement",
    "billing_adjustment": "Ajustement de la facturation",
    "courtesy_credit": "Crédit de courtoisie",
    "billing_error": "Erreur de facturation",
    "promotional_credit": "Crédit promotionnel",
    "detailed_description_of_the_credit": "Description détaillée du crédit...",
    "issue_credit": "Question du crédit",
    "dimensions": "Dimensions",
    "manage_reporting_dimensions_for_revenue_and_expenses": "Gérer les montants de rapports pour les recettes et les dépenses.",
    "new_dimension": "Nouvelle dimension",
    "no_dimensions_found": "Pas de dimensions trouvées.",
    "define_the_code_and_name_used_for_reporting_dimensions": "Définir le code et le nom utilisés pour les dimensions de déclaration.",
    "type_optional": "Type (facultatif)",
    "inactive_dimensions_are_hidden_by_default": "Les dimensions inactives sont cachées par défaut.",
    "create_report": "Créer un rapport",
    "report_name": "Nom du rapport",
    "report_type": "Type de rapport",
    "profit_loss": "Compte de résultat",
    "balance_sheet": "Fiche d ' équilibre",
    "trial_balance": "Solde du procès",
    "ap_aging": "Balance âgée fournisseurs",
    "ar_aging": "Balance âgée clients",
    "budget_vs_actual": "Budget c)",
    "format": "Format",
    "select_budget": "Sélectionnez le budget",
    "budget_version": "Version budgétaire",
    "select_version": "Sélectionnez la version",
    "date_range_2": "Plage de dates",
    "start_date": "Date de début",
    "end_date": "Date de fin",
    "granularity": "Granularité",
    "category": "Catégorie",
    "schedule_this_report": "Calendrier du rapport",
    "frequency": "Fréquence",
    "daily": "Quotidien",
    "weekly": "Semaine",
    "quarterly": "Trimestre",
    "delivery": "Livraison",
    "privana_inbox": "Privana Boîte de réception",
    "email": "E-mail",
    "save_report": "Rapport sauvegardé",
    "saved_scheduled_reports": "Rapports sauvegardés \" Annexes",
    "next_run": "Prochaine étape",
    "run_now": "Cours maintenant.",
    "download": "Télécharger",
    "no_data_available_for_the_selected_range": "Aucune donnée disponible pour la gamme sélectionnée.",
    "no_rows_returned_for_this_report_scope": "Aucune ligne n'a été retournée pour ce rapport.",
    "no_eligible_allocations_found": "Aucune allocation admissible n'a été trouvée.",
    "select": "Sélectionner",
    "counterparty": "Contre-partite",
    "match": "Match",
    "match_full": "Match complet",
    "over_allocated": "Montant réparti",
    "recommended": "Recommandation recommandée",
    "member": "Membre",
    "no_match_items_selected": "Aucun élément de correspondance sélectionné.",
    "clear_match": "Effacer le match",
    "save_match": "Enregistrez le match",
    "close_checklist": "Fermer Checklist",
    "no_tasks_configured": "Pas de tâches configurées.",
    "staff_2": "du personnel",
    "save_notes": "Enregistrez des notes",
    "view_period_events": "Voir la période des événements",
    "no_events_recorded_for_this_period_yet": "Il n ' y a pas encore d ' événements enregistrés pour cette période.",
    "period_actions": "Mesures à prendre",
    "this_period_cannot_be_closed_yet": "Cette période ne peut pas encore être fermée.",
    "close_reason_optional": "Justification (facultatif)",
    "close_month": "Fermer le mois",
    "lock_reason_optional": "Motif de verrouillage (facultatif)",
    "required_tasks_incomplete": "Effectifs nécessaires incomplètes",
    "complete_required_tasks_or_provide_an_override_reason_to_lock": "Remplir les tâches requises ou fournir une raison de remplacement pour verrouiller cette période.",
    "override_reason_required_to_lock": "Raison d'override (obligatoire à verrouiller)",
    "override_lock": "Remplacer et verrouiller",
    "unlock_reason_required": "Raison de déverrouillage (obligatoire)",
    "reopen_reason_required": "Réouverture de la raison (obligatoire)",
    "close_pack_snapshot": "Fermer la fenêtre",
    "no_snapshots_have_been_run": "Aucun instantané n'a été lancé.",
    "view_report": "Voir le rapport",
    "no_activity_recorded_for_this_period": "Aucune activité enregistrée pour cette période.",
    "this_trial_balance_contains_no_posted_journal_activity_for_the": "Ce bilan d'essai ne contient pas d'activité de journal affichée pour la période choisie.",
    "total_debits": "Total des débits",
    "total_credits": "Total des crédits",
    "periods": "Périodes",
    "monitor_closelock_status_by_fiscal_period": "Surveiller l'état de fermeture/déverrouillage par exercice.",
    "checklist": "Liste de contrôle",
    "closed": "Fermé",
    "locked": "Verrouillés",
    "loading_periods": "Des périodes de chargement...",
    "no_periods_exist_for_this_year": "Aucune période n'existe pour cette année.",
    "blocked_by_earlier_periods": "Bloqués par des périodes antérieures",
    "general_ledger_settings": "Paramètres généraux Ledger",
    "monthend_configuration": "Configuration du mois-End",
    "general_ledger": "Général Ledger",
    "search_by_account_memo": "Recherche par compte, memo...",
    "close_periods_permission_required": "Délais de congé requis",
    "memo": "Mémo",
    "loading_entries": "Chargement des entrées...",
    "no_general_ledger_entries_found": "Aucune entrée du grand livre n'a été trouvée.",
    "view_periods": "Périodes de vision",
    "loading_invoice": "Chargement Invoice...",
    "revenue_was_posted_by_the_operational_source_transactions_before_invoicing": "Les revenus ont été affichés par les opérations de source opérationnelle avant la facturation.",
    "gl_posted_via_source_transactions": "GL posté via les transactions de source",
    "posted_to_gl": "Posté à GL",
    "post_to_gl": "Poste à GL",
    "message": "—",
    "billed_to": "Effectué pour :",
    "issue_date": "Date de délivrance:",
    "due_date_2": "Date d ' échéance:",
    "quantity": "Quantité",
    "search_gl_accounts": "Rechercher des comptes GL...",
    "no_gl_account": "Aucun compte GL",
    "select_dimension": "Sélectionnez la dimension",
    "search_dimensions": "Les dimensions de recherche...",
    "loading_chart_of_accounts": "Chargement du graphique des comptes...",
    "subtotal": "Total partiel :",
    "tax_2": "Taxe :",
    "total_2": "Total :",
    "payments": "Paiements :",
    "balance_due_2": "Solde dû :",
    "tax_codes_required": "Codes fiscaux requis",
    "these_taxable_invoice_lines_do_not_have_a_tax_code": "Ces lignes de facture imposables n'ont pas de code fiscal sélectionné.",
    "invoice_line": "Ligne de facturation",
    "one_or_more_taxable_invoice_lines_need_a_tax_code": "Une ou plusieurs lignes de facture imposables ont besoin d'un code fiscal avant l'affichage.",
    "review_invoice_lines": "Examen des lignes de facturation",
    "tax_code_gl_mapping_required": "Code fiscal GL mapping required",
    "this_invoice_cannot_be_posted_to_the_general_ledger_because": "Cette facture ne peut pas être affichée au livre général parce que ces codes fiscaux manquent un compte de sortie VAT GL. Aller aux paramètres du club → Comptabilité → Codes fiscaux pour définir le compte de sortie VAT GL.",
    "line": "ligne",
    "lines": "lignes",
    "one_or_more_taxable_invoice_lines_use_tax_codes_without": "Une ou plusieurs lignes de facture taxables utilisent des codes fiscaux sans un compte de VAT GL de sortie.",
    "fix_tax_code_mappings": "Fixer les cartes des codes fiscaux",
    "accounting_settings_required": "Paramètres de comptabilité requis",
    "to_post_this_invoice_complete_the_missing_accounting_defaults": "Pour afficher cette facture, remplissez les défauts comptables manquants.",
    "accounting_settings_are_incomplete": "Les paramètres comptables sont incomplets.",
    "not_now": "Pas maintenant.",
    "configure_accounting_settings": "Configurer Paramètres comptables",
    "accounting_settings": "Paramètres comptables",
    "set_the_default_gl_accounts_used_when_posting_invoices": "Définir les comptes GL par défaut utilisés lors de l'affichage des factures.",
    "ar_control_account": "Compte de contrôle AR",
    "select_an_account": "Sélectionnez un compte",
    "required_to_post_invoices": "Requis pour poster des factures.",
    "default_revenue_account": "Compte du revenu par défaut",
    "required_when_invoice_lines_are_missing_gl_accounts": "Requis lorsque les lignes de facture sont des comptes GL manquants.",
    "vat_control_account_optional": "VAT Compte de contrôle (optionnel)",
    "required_when_vat_is_applied": "Requis lorsque VAT est appliqué.",
    "create_manual_invoice": "Créer une facture manuelle",
    "search_member_name_or": "Nom du membre de recherche ou #",
    "issue_date_2": "Date de publication",
    "amounts_are": "Les montants sont",
    "exclusive_of_tax": "Exclusivité fiscale",
    "inclusive_of_tax": "Y compris l ' impôt",
    "choose_how_unit_prices_are_entered_on_this_invoice": "Choisissez comment les prix unitaires sont inscrits sur cette facture.",
    "line_items": "Éléments de ligne",
    "loading_categories": "Catégories de chargement...",
    "price": "Prix",
    "select_tax_code": "Sélectionnez Code fiscal",
    "tax_exempt": "Exemption fiscale",
    "tax_codes_ignored_when_no_tax_is_selected": "Les codes fiscaux ignorés lorsque “Pas de taxe” est sélectionné.",
    "not_effective_for_issue_date": "Pas efficace pour la date d'émission.",
    "select_category": "Sélectionnez la catégorie",
    "no_category": "Pas de catégorie",
    "add_item": "Addition",
    "internal_notes_or_comments_for_the_member": "Notes internes ou commentaires pour le membre...",
    "save_draft_invoice": "Facture d ' urgence",
    "club_name": "Nom du club",
    "club_address": "Adresse du club",
    "invoice_2": "Facture",
    "bill_to": "Facturer à",
    "subtotal_2": "Sous-total",
    "amount_due": "Montant dû",
    "invoice_preview": "Aperçu de la facture",
    "member_invoicing": "De facturation",
    "search_member_or_invoice": "Membre de recherche ou facture #",
    "paid_credited": "Payés / crédités",
    "no_invoices_found_for_this_club": "Pas de factures trouvées pour ce club.",
    "transactions": "Opérations",
    "payment": "Paiement",
    "pos_sale": "POS Vente",
    "issued": "Délivré",
    "refunded": "Remboursé",
    "auto_allocate": "Auto allocation",
    "status_2": "État :",
    "reason_2": "Raison :",
    "yes": "Oui",
    "no": "Non",
    "record_member_payment": "Enregistrement du paiement des membres",
    "unable_to_resolve_a_member_account": "Incapable de régler un compte membre.",
    "resolving_member_account": "Résoudre le compte membre...",
    "received_date": "Date de réception",
    "use_pos_cash_float": "Utilisez le flotteur de trésorerie POS",
    "apply_to_invoices": "Appliquer sur les factures",
    "less_allocated": "Moins alloués",
    "remaining_unapplied": "Remaining unapplique",
    "allocate_later_leave_as_credit": "Affecter plus tard (laisser en crédit)",
    "open_balance": "Solde ouvert",
    "allocation": "Affectation",
    "no_open_invoices_to_allocate": "Pas de factures ouvertes à allouer.",
    "club_logo": "Logo club",
    "unit": "Unité",
    "loading_events": "Chargement des événements...",
    "search_staff": "Le personnel de recherche...",
    "type_at_least_2_characters_to_search": "Saisissez au moins 2 caractères pour rechercher.",
    "searching": "Recherche…",
    "no_staff_found": "Pas de personnel trouvé.",
    "order": "Ordre",
    "any": "quelconque",
    "location": "Lieu",
    "new": "Nouveau",
    "credit_card": "Carte de crédit",
    "cash": "Encaisse",
    "tax_rate": "Taux d ' impôt (%)",
    "date_2": "Date:",
    "other": "Autre",
    "bank_transfer": "Virement bancaire",
    "check": "Vérifie",
    "autopay": "Paiement automatique",
    "reference_number": "Numéro de référence",
    "check_number_transaction_id_etc": "Numéro de contrôle, numéro de transaction, etc.",
    "additional_payment_notes": "Des notes de paiement supplémentaires...",
    "pending_2": "En attente",
    "member_name": "Nom du membre",
    "net": "Montant net",
    "record_receivable_payment": "Enregistrement du paiement perçu",
    "debtor": "Débiteur:",
    "unlabelled_debtor": "Débiteur non-étiqueté",
    "description_2": "Description:",
    "outstanding": "En suspens :",
    "previous": "Précédent",
    "next": "Suivant",
    "outstanding_2": "Impayé",
    "paid": "Payé",
    "source": "Source :",
    "confirm": "Confirmer",
    "recipient": "Bénéficiaire",
    "pause": "Pause",
    "resume": "Consommation",
    "membership_type": "Type de membre",
    "member_2": "Membre",
    "group": "Groupe",
    "groups": "Groupes",
    "item": "Article",
    "items": "Points",
    "scheduled": "programmées",
    "card": "Carte",
    "open": "ouvert",
    "year": "Année",
    "select_member": "Sélectionnez un membre",
    "loading_members": "Chargement des membres...",
    "annual": "Annuelle",
    "payment_terms_2": "Conditions de paiement",
    "label": "Étiquette",
    "effective_from": "Efficace à partir de",
    "select_tax_code_2": "Sélectionnez le code fiscal",
    "no_tax_code": "Pas de code fiscal",
    "yearend_assistant": "Assistante pour l ' exercice biennal",
    "payroll_trend": "Tendance de la paie",
    "payroll_sections": "Sections de la paie",
    "loading_payroll_data": "Chargement des données de paye...",
    "payroll_data_could_not_be_loaded": "Les données sur les états de paie ne pouvaient pas être chargées.",
    "no_payroll_records_yet_defaults_are_ready_for_configuration": "Aucun enregistrement de paie pour le moment. Les valeurs par défaut sont prêtes à être configurées.",
    "payroll_documents": "Documents de paie",
    "payroll_setup_wizard": "Système de paiement wizard",
    "current_payroll_cycle": "Cycle de paie actuel",
    "journal_preview": "Aperçu du Journal",
    "current_payroll_run": "Courant de paie courant",
    "review_payroll": "Examen de la paie",
    "payroll_command_centre": "Centre de commandement des états de paie",
    "no_current_payroll_run": "Pas d'exercice de la paie courante",
    "create_the_next_payroll_run_to_review_employees_timesheets_blockers": "Créer la prochaine série de états de paie pour examiner les employés, les feuilles de temps, les bloqueurs, les approbations, les entrées statutaires et la comptabilité dans un espace de travail guidé.",
    "create_next_payroll_run": "Créer la prochaine course de la paie",
    "payroll_progress": "Progrès des états de paie",
    "payroll_readiness": "Préparation des états de paie",
    "ready": "Prêt",
    "open_details_and_actions": "Ouvrir les détails et les actions",
    "privana_assist_will_show_next_actions_when_backend_readiness_checks": "Privana Assist montrera les prochaines actions lorsque les vérifications de la préparation des backends trouveront quelque chose à examiner.",
    "no_payroll_trend_data_yet": "Pas de données sur la tendance de la paie",
    "department_split_by_gross_pay": "Répartition par département par rémunération brute",
    "no_department_weighting_yet": "Pas de poids de département pour le moment",
    "payroll_blockers": "Blocs de paie",
    "open_payroll_run": "Ouvrez la paie",
    "no_blockers_found_this_readiness_tile_is_clear": "Aucun blocage détecté. Cette carte de préparation ne présente aucun problème.",
    "manage_staff_pay_readiness_with_employeefirst_cards": "Gérer l'état de préparation des employés avec les premières cartes.",
    "search_employees": "Employés de recherche",
    "add_employee": "Ajouter l'employé",
    "payroll_employee_actions": "Actions des employés de la paye",
    "departments": "Ministères",
    "bank": "✓ Banque",
    "tax_3": "✓ Fiscalité",
    "pension": "pension ✓",
    "no_employees_found": "Aucun employé trouvé",
    "archive": "Archiver",
    "drop_employees_here": "Laissez les employés ici.",
    "done": "Terminé",
    "people_operations": "Opérations humaines",
    "organise_payroll_by_department": "Organiser la paie par département",
    "drag_employee_cards_into_teams_or_use_accessible_move_selectors": "Faites glisser les cartes des employés en équipe ou utilisez des sélectionneurs de mouvements accessibles.",
    "loading_departments": "Chargement des départements...",
    "search_department_employees": "Employés du ministère de la Recherche",
    "search_people_role_department": "Rechercher des gens, rôle, département",
    "new_department_name": "Nouveau nom de département",
    "new_department": "Nouveau département",
    "department_colour": "Couleur du département",
    "staff_link": "Lien de personnel",
    "staff_member": "Membre du personnel",
    "search_staff_2": "Personnel de recherche",
    "search_by_name_email_job_title_or_department": "Recherche par nom, email, titre d'emploi ou ministère",
    "clear": "Effacer",
    "employment_details": "Détails de l ' emploi",
    "pay_setup": "Système de paiement",
    "payroll_calculation_rules_for_contractors_will_be_configured_later_this": "Les règles de calcul des états de paie pour les entrepreneurs seront configurées plus tard; cette configuration de l'employé ne stocke que le taux par défaut.",
    "readiness_setup": "Configuration de la lecture",
    "payment_details": "Détails de paiement",
    "save_payment_details_first_then_mark_them_verified_once_checked": "Enregistrer les détails de paiement d'abord, puis les marquer vérifiées une fois vérifiées.",
    "update_verification": "Vérification des mises à jour",
    "no_active_payment_details_saved": "Aucun détail de paiement actif enregistré.",
    "enter_full_details_once_existing_sensitive_values_are_never_prefilled": "Entrez tous les détails une fois. Les valeurs sensibles existantes ne sont jamais pré-remplies lors du remplacement.",
    "cancel_payment_edit": "Annuler la commande Modifier",
    "discard_edits": "Supprimer les éditions",
    "edit_profile": "Modifier le profil",
    "mark_on_hold": "Marque On Hold",
    "mark_active": "Marque active",
    "payroll_profile_review": "Examen du profil de la paie",
    "edit_mode": "Modifier Mode",
    "view_mode": "Mode de vue",
    "loading_profile_detail": "Charger le détail du profil...",
    "pay_rate_details": "Détails de la paye et du taux",
    "effective_from_2": "Efficace à partir de",
    "effective_to": "Efficacité",
    "active_rate": "Taux actif",
    "tax_ni_readiness": "Taxe / NI Readiness",
    "ni_number_last4_only": "NI numéro last4 seulement",
    "privana_stores_ni_reference_last4_only_full_ni_numbers_are": "Privana magasins NI référence last4 seulement. Les numéros NI complets ne sont pas stockés ici.",
    "pension_2": "Pension",
    "provider": "Fournisseur",
    "scheme_reference": "Référence au régime",
    "employee_contribution_rate": "Taux de cotisation des employés",
    "employer_contribution_rate": "Taux de cotisation des employeurs",
    "employer_cost_setup": "Ensemble des coûts de l ' employeur",
    "employer_pension_rate": "Taux de pension des employeurs",
    "fixed_employer_contribution_override": "Remboursement de la contribution de l'employeur fixe",
    "manual_employer_adjustment_override": "Remboursement manuel de l ' employeur",
    "manual_adjustment_reason": "Justification manuelle",
    "no_audit_history_yet": "Pas encore d'historique de vérification.",
    "close_modal": "Fermer modal",
    "finance_preview": "Aperçu financier",
    "finance_preview_ready": "Prévisualisation des finances",
    "this_payroll_stays_approved_until_it_is_posted_to_accounting": "Cette paie reste approuvée jusqu'à ce qu'elle soit affichée à la comptabilité.",
    "posting_this_payroll_will": "L'affichage de cette paie sera:",
    "link_this_payroll_run_to_a_general_ledger_journal": "Lien de cette liste de paie à un journal General Ledger",
    "create_outstanding_payroll_hmrc_pension_and_other_payable_obligations": "Créer des états de paie en souffrance, HMRC, pension et autres obligations payables",
    "hmrc_payroll_liability_components": "Composants de responsabilité salariale HMRC",
    "memo_mapping_key": "Mémoire / clé de mappage",
    "prepare_finance_preview_after_approval": "Préparer l'aperçu financier après approbation.",
    "payroll_calendar_filter": "Filtre de calendrier des états de paie",
    "all_calendars": "Tous les calendriers",
    "department_filter": "Filtre de direction",
    "department_id": "Département id",
    "period_filter": "Filtre",
    "all_payroll_periods": "Toutes les périodes de paie",
    "search_timesheets": "Chercher des feuilles de temps",
    "search_employee": "Employé de recherche",
    "new_timesheet": "Nouveau timesheet",
    "import_timesheets": "Importer des feuilles de temps",
    "timesheets": "Feuilles horaires",
    "loading_timesheets": "Chargement des feuilles de temps...",
    "open_2": "Ouvrir",
    "reopen": "Réouverture",
    "timesheet_lines": "Lignes de feuille de temps",
    "remove_line": "Supprimer la ligne",
    "create_timesheet": "Créer Timesheet",
    "timesheets_are_created_against_payroll_periods_generated_from_payroll_calendar": "Les feuilles de temps sont créées contre les périodes de paye générées par les règles du calendrier des états de paie.",
    "no_open_payroll_periods_exist_for_this_calendar_go_to": "Aucun délai de paye ouvert n'existe pour ce calendrier. Aller aux paramètres de paye → Calendriers de paye et cliquez sur Périodes de Génération.",
    "import_drafts": "Projets d ' importation",
    "all_periods": "Toutes les périodes",
    "search_run_name": "Nom de la cour de recherche",
    "new_payroll_run": "Nouvelle piste de paie",
    "loading_payroll_runs": "Chargement des états de paie...",
    "resolve_blockers_before_approval": "Régler les bloqueurs avant l ' homologation",
    "no_payroll_runs_yet": "Il n'y a pas de salaire.",
    "statutory_source": "Source légale",
    "statutory_payroll_inputs": "Entrées législatives de la paye",
    "enter_the_providersupplied_statutory_values_for_each_employee_in_this": "Entrez les valeurs statutaires fournies par le fournisseur pour chaque employé de cette fonction de paie.",
    "privana_uses_these_employeelevel_values_to_calculate_net_pay_hmrc": "Privana utilise ces valeurs au niveau des employés pour calculer la rémunération nette, les passifs HMRC, le dédouanement des états de paie, les documents et les fiches de paie futures.",
    "pension_values_come_from_privana_pension_settings_only_paye_employee": "Les valeurs de pension proviennent de Privana paramètres de pension. Seuls les PAYE, les employés NI et les employeurs NI sont entrés ici.",
    "payroll_was_recalculated_after_statutory_inputs_were_saved_review_and": "La paie a été recalculée après l ' enregistrement des contributions statutaires. Revoir et réintégrer les valeurs légales.",
    "previous_statutory_values_are_stale_and_are_not_being_used": "Les valeurs statutaires antérieures sont obsolètes et ne sont pas utilisées.",
    "optional_sourcereference": "Source/référence facultative",
    "optional_reference_eg_payroll_provider_report_name_or_accountant_email": "Référence facultative, p.ex. nom du fournisseur de états de paie ou courriel du comptable.",
    "import_csv_coming_soon": "Importer CSV — Prochainement",
    "review_required": "Examen requis",
    "postedlocked_state_statutory_inputs_are_readonly_postedlocked_runs_show_readonly": "État posté/déverrouillé: les entrées statutaires sont lues seulement. Les séries postées/déverrouillées montrent les lignes en lecture seule.",
    "save_statutory_inputs": "Sauvegarder les contributions statutaires",
    "reset_unsaved_changes": "Réinitialiser les changements non enregistrés",
    "create_payroll_run": "Créer Payroll Run",
    "payroll_runs_collect_fixed_salary_profiles_approved_timesheets_and_hybrid": "Payroll Runs recueille des profils de salaire fixes, des feuilles de temps approuvées et des rajustements hybrides pour la période de paye choisie.",
    "include_fixed_salary_profiles": "Inclure les profils de salaires fixes",
    "include_timesheetdriven_employees": "Inclure les employés axés sur les feuilles de temps",
    "include_hybrid_profiles": "Comprend les profils hybrides",
    "roll_back_stage": "Rouleau arrière",
    "recalculate_payroll": "Recalculer les états de paie",
    "posted_to_accounting": "Posté à la comptabilité",
    "fix_mappings": "Cartographies fixes",
    "multiple_payroll_journals_were_detected_for_this_payroll_run_review": "Plusieurs revues payantes ont été détectées pour cette course aux états de paie. Examen avant paiement.",
    "approval_blockers": "Homologation \" bloquants",
    "opencreate_timesheet": "Ouvrir/Create Timesheet",
    "no_blockers_found_payroll_can_move_to_the_next_available": "Aucun bloqueur n'a été trouvé. Payroll peut passer à la prochaine étape disponible.",
    "publish_payslips_to_staff_portal": "Publier des fiches de paie sur le portail du personnel ?",
    "this_will_make_individual_payslips_available_only_to_staff_included": "Cela permettra de mettre les paylips individuels à la disposition du personnel inclus dans cette course de la paie.",
    "each_staff_member_will_only_be_able_to_view_and": "Chaque membre du personnel ne pourra visionner et télécharger sa propre fiche.",
    "employee_breakdown": "Répartition des employés",
    "no_employee_lines_have_been_calculated_yet": "Aucune ligne d'employé n'a encore été calculée.",
    "payroll_liabilities": "Passif au titre des états de paie",
    "approvals_pending": "Approbations en attente",
    "timesheets_waiting": "Horaires en attente",
    "payroll_runs_waiting": "Payrolls en attente",
    "this_item_needs_a_backendlinked_action_before_it_can_be": "Cet article a besoin d'une action backend-linked avant qu'il puisse être ouvert ici.",
    "approvals_clear": "Homologations claires",
    "payroll_liabilities_and_payment_obligations_created_from_payroll_are_shown": "Les passifs de paye et les obligations de paiement créées à partir des états de paie sont indiqués ici. Seuls les articles n'ont pas créé de paiements ni dépensé d'argent.",
    "no_payroll_liabilities_yet": "Aucun passif au titre de la paie",
    "loading_payroll_settings": "Chargement des paramètres de paye...",
    "payroll_calendars": "Calendriers des états de paie",
    "please_retry": "S'il vous plaît, retry.",
    "add_calendar": "Ajouter le calendrier",
    "payroll_calendars_generate_payroll_periods_timesheets_and_payroll_runs_then": "Les calendriers des états de paie génèrent des périodes de paye. Les feuilles de temps et les états de paie utilisent ensuite ces périodes générées.",
    "loading_payroll_calendars": "Chargement des calendriers de paie...",
    "unable_to_load_payroll_calendars": "Impossible de charger les calendriers des états de paie.",
    "no_payroll_calendars_yet_create_one_to_define_pay_cycles": "Pas encore de calendrier de paye. Créez un pour définir les cycles de paye.",
    "generate_periods": "Générer des périodes",
    "set_default": "Par défaut",
    "weekly_2": "hebdomadaire",
    "fortnightly": "Quinzaine",
    "monthly": "mensuel",
    "quarterly_2": "trimestriellement",
    "paused": "pause",
    "is_default": "Est par défaut",
    "next_payroll_periods": "Prochaines périodes de paie",
    "save_calendar_to_preview_generated_periods": "Enregistrer le calendrier pour prévisualiser les périodes générées.",
    "pay_rules": "Règles de paye",
    "timesheet_rules": "Règles de la feuille de temps",
    "payroll_setup_policy_centre": "Réglage des états de paie et centre de politique",
    "payroll_jurisdiction": "Compétence sur les états de paie",
    "unable_to_determine_payroll_jurisdiction_automatically_please_check_your_club": "ρ Impossible de déterminer la compétence de la paye automatiquement. S'il vous plaît vérifier votre adresse de club dans les paramètres de Club.",
    "refresh_detection": "Détection de réfresh",
    "open_club_settings": "Paramètres du club ouvert",
    "advanced_payroll_settings": "Réglages avancés sur les états de paie",
    "for_payroll_specialists_accountants_and_privana_support_these_fields_expose": "Pour les spécialistes des états de paie, les comptables et le soutien de Privana. Ces champs exposent les modes de calcul internes, les seuils, les taux, les clés de cartographie, les paramètres de compétence et les rajustements de coûts des employeurs avancés.",
    "auto_enrolment_enabled": "Nombre d ' inscriptions automatiques",
    "overtime_enabled": "Heures supplémentaires activées",
    "custom": "Personnalisé",
    "standard_hourly_rate": "Taux horaire standard",
    "time_and_a_half_15x": "Temps et demi (1,5x)",
    "double_time_20x": "Temps double (2.0x)",
    "reset_to_suggested_setting": "Réinitialiser le réglage proposé",
    "advanced_employer_cost_adjustments": "Ajustements de coûts avancés de l'employeur",
    "accountantlevel_employer_cost_overrides_collapsed_inside_advanced_payroll_settings_for": "Remboursement des coûts de l'employeur au niveau comptable. Colchu à l'intérieur des paramètres de paie avancés pour les utilisateurs du club de tous les jours.",
    "per_run": "Par course",
    "monthly_2": "mensuel",
    "annual_prorated": "Rapport annuel",
    "save_payroll_policies": "Sauvegarder les politiques de paye",
    "privana_assist_controls": "Privana Contrôles d'aide",
    "permissions_preview": "Permissions Aperçu",
    "role_assignment_will_use_privana_module_permissions_this_preview_does": "L'assignation de rôle utilisera les permissions de module Privana. Cet aperçu ne change pas encore les autorisations.",
    "loading_todays_accounting_queue": "Charger la file comptable d’aujourd’hui...",
    "today_workspace": "Aujourd'hui l'espace de travail",
    "accounting_today": "Comptabilité — Aujourd ' hui",
    "financial_operations_overview_for_today": "Aperçu des opérations financières pour aujourd'hui.",
    "no_urgent_financial_actions_today": "Pas d'actions financières urgentes aujourd'hui.",
    "search_payee_source_or_description": "Chercher le destinataire, la source ou la description...",
    "pay_selected": "Paye choisie",
    "add_bill": "facture",
    "all_payables": "Tous les produits à payer",
    "tax_pension": "Taxe & Pension",
    "refunds": "Remboursements",
    "other_liabilities": "Autres passifs",
    "ap_ageing": "Balance âgée fournisseurs",
    "unified_payable_ledger": "Livre payable unifié",
    "source_type": "Type de source",
    "payee": "Bénéficiaire",
    "module": "Module",
    "gl_mapping": "Cartographie",
    "original_amount": "Montant initial",
    "outstanding_amount": "Montant exceptionnel",
    "due_date_run": "Date d'échéance / Run",
    "payment_status": "État des paiements",
    "loading_payables": "Chargement à payer...",
    "no_payables_found": "Aucun crédit n'est trouvé.",
    "view_source": "Voir Source",
    "recent_ap_payments": "Paiements AP récents",
    "unapplied": "Non appliquée",
    "loading_payments": "Chargement des paiements...",
    "no_payments_recorded": "Aucun paiement enregistré.",
    "current": "Actuel",
    "totals": "Total",
    "no_ageing_balances_to_display": "Pas de balances de vieillissement à afficher.",
    "manage_payment_allocations": "Gérer les allocations de paiement",
    "current_allocations": "Allocations actuelles",
    "unapply_selected": "Sélection malheureuse",
    "unapply_all": "Inapply all",
    "reallocate_across_bills": "Réaliser les factures",
    "no_open_bills_available_for_reallocation": "Aucune facture ouverte n'est disponible pour la réaffectation.",
    "reallocation_total": "Réaffectation totale",
    "apply_reallocation": "Appliquer la réaffectation",
    "refund_payment": "Remboursement",
    "refund_amount": "Montant remboursé",
    "refund_method": "Méthode de remboursement",
    "refund_date": "Date du remboursement",
    "bank_account_required_for_bank_refunds": "Compte bancaire requis pour les remboursements bancaires.",
    "issue_refund": "Remboursement de la question",
    "add_bank_account": "Ajouter un compte bancaire",
    "bank_name": "Nom de la banque",
    "eg_harbor_credit_union": "p. ex. Harbor Credit Union",
    "account_name_friendly_label": "Nom du compte (étiquette conviviale)",
    "eg_operating_checking": "e.g. Vérification d'exploitation",
    "account_number": "Numéro de compte",
    "enter_account_number": "Entrez le numéro de compte",
    "eg_usd": "Par exemple, USD",
    "linked_gl_account_required": "Compte GL lié (obligatoire)",
    "no_gl_accounts_available": "Aucun compte GL disponible.",
    "bank_accounts": "Comptes bancaires",
    "bank_2": "Banque",
    "linked_gl_account": "Compte GL lié",
    "no_bank_accounts_available": "Aucun compte bancaire n'est disponible.",
    "loading_bank_accounts": "Charger les comptes bancaires...",
    "search_transactions": "Opérations de recherche...",
    "income_vs_budget": "Recettes par rapport au budget",
    "actual_vs_budget": "Dépenses effectives et budget",
    "expenses_vs_budget": "Dépenses par rapport au budget",
    "income_trend": "Tendance des recettes",
    "expense_trend": "Tendance des dépenses",
    "monthly_performance": "Rendement mensuel",
    "period": "Période",
    "of_budget": "% du budget",
    "department_breakdown": "Répartition par département",
    "variance_2": "Variation %",
    "gl_accounts": "Comptes GL",
    "no_gl_detail_available": "Aucun détail GL n'est disponible.",
    "inactive": "Inactif",
    "eg_4000": "Par exemple 4000",
    "eg_membership_dues": "e.g. Sommes dues à l'adhésion",
    "cost_centers_departmental_accounting": "Centres de coûts & Comptabilité ministérielle",
    "track_spending_and_budgets_by_department_and_cost_center": "Suivre les dépenses et les budgets par département et centre de coûts",
    "new_cost_center": "Nouveau centre de coûts",
    "total_cost_centers": "Total des centres de coûts",
    "annual_budget": "Budget annuel",
    "ytd_spending": "YTD - Dépenses",
    "budget_variance": "Écart budgétaire",
    "department_spending_vs_budget": "Dépenses ministérielles et budget",
    "budget_utilization_by_department": "Utilisation du budget par le Ministère",
    "cost_centers": "Centres de coûts",
    "all_departments": "Tous les départements",
    "budget_utilization": "Budgétisation",
    "cost_center_name": "Nom du centre de coûts",
    "eg_fb001": "p.ex. FB001",
    "manager_name": "Nom du gestionnaire",
    "eg_department": "p.ex. département",
    "eg_fnb": "Par exemple, FNB",
    "eg_food_beverage": "p.ex. aliments et boissons",
    "fiscal_year": "Année financière",
    "customize_invoice": "Personnaliser la facture",
    "edit_invoicespecific_presentation_settings_only": "Modifier les paramètres de présentation spécifiques à la facture seulement.",
    "billing_email_optional": "Courriel de facturation (facultatif)",
    "leave_blank_to_use_club_default_in_preview": "Laisser blanc pour utiliser par défaut club dans l'aperçu",
    "billing_phone_optional": "Téléphone de facturation (facultatif)",
    "accent_hex_color": "Couleur HEX Accent",
    "footer_note": "Note du pied",
    "eg_thank_you_for_your_business": "e.g., Merci pour votre entreprise!",
    "download_test_pdf": "Télécharger Test PDF",
    "paid_via_direct_payment": "Paid via Paiement direct",
    "unbilled": "Non facturé",
    "apply_credit": "Appliquer Crédit",
    "refund_credit": "Remboursement du crédit",
    "available_credit_notes": "Notes de crédit disponibles",
    "available_credit": "Crédit disponible",
    "current_balance": "Solde actuel",
    "open_invoices": "Factures ouvertes",
    "last_payment": "Dernier paiement",
    "statements": "Déclarations",
    "loading_transactions": "Chargement des transactions...",
    "billing_run": "Cycle de facturation",
    "balance": "Solde",
    "details": "Détails",
    "no_transactions_recorded": "Aucune transaction n'a été enregistrée.",
    "view_audit_trail": "Voir la piste d'audit",
    "reallocate": "Réaffecter",
    "refund_payment_2": "Remboursement",
    "view_credit_note": "Voir la note de crédit",
    "view_invoice": "Voir Invoice",
    "create_credit_note": "Créer une note de crédit",
    "no_open_invoices": "Aucune facture en cours.",
    "no_invoices_in_this_range": "Pas de facture dans cette gamme.",
    "no_payments_in_this_range": "Pas de paiements dans cette fourchette.",
    "select_a_date_range_to_view_a_statement": "Sélectionnez une plage de date pour afficher une déclaration.",
    "credit_payment": "Montant du crédit",
    "select_a_payment": "Sélectionnez un paiement",
    "no_open_invoices_available": "Pas de factures ouvertes disponibles.",
    "remaining_credit": "Crédit restant",
    "use_refund_payment_to_reverse_a_receipt_or_payment_allocation": "Utiliser Remboursement Paiement pour inverser une allocation de réception ou de paiement. Utiliser la note de crédit pour réduire une valeur de facture.",
    "select_invoice": "Sélectionnez la facture",
    "credit_note_detail": "Note de crédit Détail",
    "total_ar": "Total des créances clients",
    "inactive_accounts": "Comptes inactifs",
    "active_accounts": "Comptes actifs",
    "accounts_in_credit": "Comptes créditeurs",
    "search_members": "Rechercher des membres...",
    "filter_by_status": "Filtre par statut",
    "all_statuses_2": "Tous les statuts",
    "member_accounts": "Comptes Membres",
    "credit_limit": "Limite de crédit",
    "credit_balance": "Solde de crédit",
    "loading_member_accounts": "Charger les comptes membres...",
    "no_member_accounts_found": "Aucun compte membre n'a été trouvé.",
    "your_logo": "Votre Logo",
    "billed_to_2": "Facturé à",
    "loading_current_period": "Chargement de la période actuelle...",
    "no_periods_exist_for_this_fiscal_year_yet_generate_periods": "Il n'y a pas encore de période pour cet exercice. Générer des périodes pour commencer la fin du mois.",
    "go_to_periods": "Allez aux Périodes",
    "no_completed_months_to_close_yet": "Il n'y a pas encore de mois à terminer.",
    "select_a_period_to_continue_the_month_close_workflow": "Sélectionnez une période pour continuer le flux de travail de clôture du mois.",
    "loading_checklist": "Charger la liste de contrôle...",
    "action_blocked": "Action bloquée",
    "override_reason_required_to_closelock": "Raison de surcharge (obligatoire à fermer/verrouiller)",
    "clear_staff_selection": "Sélection du personnel",
    "configure_monthend_checklist_templates_exception_policies_and_locking_rules": "Configurer les modèles de liste de vérification de fin de mois, les politiques d'exception et les règles de verrouillage.",
    "you_have_viewonly_access_editing_is_disabled_for_this_configuration": "Vous n'avez accès qu'à la vue. L'édition est désactivée pour cette configuration.",
    "task_templates": "Modèles de tâches",
    "define_the_checklist_items_required_to_close_a_period": "Définir les éléments de la liste de vérification nécessaires pour fermer une période.",
    "add_task": "Ajouter la tâche",
    "task": "Tâche",
    "no_task_templates_configured": "Aucun modèle de tâche configuré.",
    "task_name": "Nom de la tâche",
    "exception_policies": "Politiques d'exception",
    "define_who_can_post_or_delete_entries_during_locked_periods": "Définir qui peut poster ou supprimer des entrées pendant des périodes verrouillées.",
    "add_policy": "Ajouter des politiques",
    "source_module": "Module Source",
    "optional_limit_this_exception_to_entries_created_by_a_specific": "Facultatif: limiter cette exception aux entrées créées par un module spécifique. Laisser comme N'importe s'appliquer à tous les modules.",
    "entry_class": "Classe entrée",
    "entry_class_describes_what_type_of_journal_entry_this_exception": "La classe d'entrée décrit le type d'entrée dans la revue que cette exception s'applique (normal, ajustage, renversement, year_end, comptabilité d'exercice). Laisser comme N'importe quoi s'appliquer à tous.",
    "allow_post": "Autoriser le poste",
    "allow_delete": "Supprimer",
    "no_exception_policies_configured": "Aucune politique d'exception configurée.",
    "locking_rules": "Règles de verrouillage",
    "locking_rules_configuration_coming_soon": "La configuration des règles de verrouillage arrive bientôt.",
    "todays_sales": "Les ventes d'aujourd'hui",
    "transactions_today": "Transactions Aujourd'hui",
    "avg_transaction": "Transaction avg",
    "refunds_today": "Remboursements aujourd'hui",
    "all_locations": "Tous les lieux",
    "new_sale": "Nouvelle vente",
    "point_of_sale_transactions": "Point de vente Transactions",
    "transaction_id": "ID de transaction",
    "datetime": "Date/heure",
    "refunds_returns": "Remboursements et retours",
    "refund_id": "Remboursement de l ' ID",
    "original_transaction": "Transaction originale",
    "member_optional": "Membre (optionnel)",
    "select_member_or_leave_blank_for_walkin": "Sélectionnez le membre ou laissez blanc pour l'itinérance",
    "debit_card": "Carte de débit",
    "gift_card": "Carte cadeau",
    "comp": "Offert",
    "items_2": "Articles",
    "item_name": "Nom d ' article",
    "tip_amount": "Montant de la caution",
    "transaction_notes": "Des notes de transaction...",
    "process_refund": "Remboursement du processus",
    "refund_amount_2": "Montant du remboursement",
    "refund_method_2": "Méthode de remboursement",
    "account_credit": "Crédits",
    "reason_for_refund": "Raison du remboursement",
    "customer_request": "Demande de service",
    "service_issue": "Questions relatives aux services",
    "cancellation": "Annulation",
    "error_correction": "Erreur Correction",
    "refund_reason_or_notes": "Remboursement de la raison ou des notes...",
    "total_processed": "Total transformé",
    "failed": "Échec",
    "processing_fees": "Frais de traitement",
    "search_payments": "Les paiements de recherche...",
    "completed": "Terminé",
    "invoice_optional": "Facture (optionnelle)",
    "select_invoice_to_pay": "Sélectionnez la facture à payer",
    "additional_notes": "Des notes supplémentaires...",
    "recent_payments": "Paiements récents",
    "payment_id": "Numéro de paiement",
    "fee": "Honoraires",
    "no_payments_found": "Aucun versement n ' a été constaté",
    "total_receivables": "Total des recettes",
    "outstanding_receivables": "Récevables exceptionnels",
    "nonmember_debtors": "Debtors non membres",
    "all_receivables": "Tous les reçus",
    "charges": "Charges",
    "billing_status": "État de la facturation",
    "no_charges_found": "Aucune charge n'a été trouvée.",
    "receivable_detail": "Montants à recevoir",
    "debtor_2": "Débiteurs",
    "original": "Original",
    "source_invoice": "Source \" Facture \"",
    "accounting_metadata": "Métadonnées comptables",
    "settlement_pos_gl_audit": "Règlement, vérification du POS & GL",
    "payment_records": "Comptes rendus des paiements",
    "payment_allocations": "Allocations de paiement",
    "taxvat_breakdown": "Tax/ VAT",
    "gl_journal_lines": "Lignes de journal GL",
    "invoice_line_items": "Articles de ligne de facturation",
    "go_to_source": "Aller à la source",
    "clear_search": "Effacer la recherche",
    "search_by_invoice_or_memberdebtor_name": "Recherche par facture # ou nom de membre/debtor...",
    "no_matching_invoices": "Pas de factures correspondantes.",
    "use_a_credit_note_to_reduce_the_invoice_value_after": "Utilisez une note de crédit pour réduire la valeur de facture après émission. Utilisez le remboursement Paiement uniquement pour retourner un paiement sans modifier la valeur de facture.",
    "billing_adjustment_2": "Ajustement de la facturation",
    "goodwillservice_issue": "En matière de bonne volonté/service",
    "event_cancellation": "Annulation de l ' événement",
    "membership_adjustment": "Ajustement de la composition",
    "gross_amount": "Montant brut",
    "post_credit_note_immediately": "Post credit note immédiatement",
    "enrolment_list": "Liste des inscriptions",
    "billing_runs": "Cycles de facturation",
    "recurring_billing_settings": "Paramètres de facturation récurrents",
    "billing_cutoff_day_of_month": "Journée de coupure de facturation du mois",
    "billing_runs_include_eligible_unbilled_items_up_to_and_including": "Les opérations de facturation comprennent des articles non facturés admissibles jusqu'à la journée de coupure choisie.",
    "autoemail_recurring_invoices": "Factures récurrentes auto-email",
    "invoices_generated_from_recurring_billing_are_emailed_to_members_at": "Les factures générées par la facturation récurrente sont envoyées par courriel aux membres à 9h00 dans le fuseau horaire local du club.",
    "generate_invoices": "Générer les factures",
    "send_invoice": "Envoyer la facture",
    "statement_total": "État total",
    "current_period": "Période actuelle",
    "this_will_generate_the_members_invoice_and_email_it_immediately": "Cela générera la facture du membre et l'emailera immédiatement.",
    "the_invoice_will_then_appear_in_invoicing_for": "La facture apparaîtra ensuite dans Facturation pour:",
    "payment_tracking": "suivi des paiements",
    "overdue_management": "gestion excessive",
    "future_account_administration": "future administration des comptes",
    "some_items_are_not_mapped_to_accounts": "Certains éléments ne sont pas cartographiés aux comptes",
    "unmapped_items_will_not_be_included_in_invoices_unless_you": "Les articles non plafonnés ne seront pas inclus dans les factures à moins que vous ne répariez leurs cartes comptables.",
    "go_to_gl_mapping": "Allez sur GL Mapping",
    "continue_anyway": "Continuez.",
    "membership_dues_enrollment": "Participation aux cotisations",
    "accountingonly_enrollment_and_operations_for_recurring_membership_dues": "Inscription comptable et opérations pour les cotisations récurrentes.",
    "enroll_member": "Membre de l ' inscription",
    "active_recurring_dues_enrollments": "Inscriptions actives de cotisations récurrentes",
    "enrollment": "Inscription",
    "enrolled": "Inscription",
    "not_enrolled": "Non inscrit",
    "membership_type_2": "Type d’adhésion",
    "enroll_selected": "S ' inscrire",
    "generate_invoices_for_selected": "Générer des factures pour certains",
    "next_run_date": "Prochaine étape",
    "latest_invoice": "Dernière facture",
    "recurring_status": "Statut récurrent",
    "generate_invoice_now": "Générer la facture maintenant",
    "run_date": "Date d ' entrée",
    "invoices": "Factures",
    "total_billed": "Total",
    "skipped_warnings": "Ignorés / Avertissements",
    "view_preview": "Vue d ' ensemble",
    "generate_run": "Générer des résultats",
    "view_invoices": "Voir les factures",
    "record_payments": "Enregistrement des paiements",
    "loading_billing_runs": "Chargement des courses de facturation...",
    "no_billing_runs_yet": "Pas encore de facturation.",
    "billing_run_detail": "Détail du cycle de facturation",
    "charge": "Charge",
    "generate_billing_run": "Générer la course de facturation ?",
    "this_will_create_draft_invoices_for_the_selected_recurring_billing": "Cela créera des projets de factures pour la période d'exécution de facturation récurrente choisie. Les projets de factures restent non postés dans le grand livre jusqu'à ce qu'ils soient finalisés ou affichés.",
    "statement_preview": "Énoncé",
    "loading_statement_preview": "Prévisualisation de la déclaration de chargement...",
    "dues": "Sommes dues",
    "billing_email": "E-mail de facturation",
    "ready_to_bill": "✓ Prêt au facture",
    "nothing_to_bill": "Rien à Bill",
    "current_statement": "État actuel",
    "future_billing": "Facturation future",
    "billing_history": "Histoire de la facturation",
    "preview_invoice": "Aperçu de la facture",
    "coming_soon": "Bientôt",
    "autopay_coming_soon": "Auto-Pay: Prochainement",
    "statement_preview_summary": "Résumé",
    "only_billable_outstanding_items_that_would_be_included_if_generated": "Seulement des articles impayables et exceptionnels qui seraient inclus si générés maintenant.",
    "no_charges_are_currently_scheduled_for_the_next_statement": "Aucune charge n ' est actuellement prévue pour la prochaine déclaration.",
    "charges_included": "Inclus",
    "paid_settled_voided_and_directly_settled_sales_are_excluded": "Les ventes payées, réglées, annulées et directement réglées sont exclues.",
    "projected": "Prévisions de dépenses",
    "charge_actions": "Mesures à prendre",
    "edit_charge_coming_soon": "Modifier Charge — Prochainement",
    "exclude_this_run": "Exclure cette course",
    "move_to_future_billing_run": "Déplacement vers l'avenir Billing Run",
    "make_complimentary_coming_soon": "Complimentaire — Prochainement",
    "split_billing_coming_soon": "Split Billing — Prochainement",
    "add_note_coming_soon": "Ajouter une note — Prochainement",
    "scheduled_2": "Planifié",
    "future_charge_actions": "Actions futures",
    "change_billing_run": "Changement de la facturation",
    "no_future_scheduled_charges_found": "Aucune charge prévue future n'a été trouvée.",
    "source_2": "Source",
    "no_previous_billing_periods_found": "Aucune période de facturation précédente n'a été trouvée.",
    "loading_invoice_preview": "Chargement de la facture avant-première...",
    "direct_debit": "Débit direct",
    "charge_source": "Source de charge",
    "source_type_2": "Type de source",
    "sale_number": "Numéro de vente",
    "choose_which_billing_run_this_charge_should_appear_in": "Choisissez dans quelle facturation cette charge devrait apparaître.",
    "current_billing_run": "Cour de facturation actuelle",
    "billing_runs_2": "Cycles de facturation",
    "custom_2": "Personnalisé...",
    "choose_a_later_billing_run": "Choisissez une course de facturation ultérieure",
    "month": "Mois",
    "custom_billing_month": "mois de facturation personnalisé",
    "custom_billing_year": "Année de facturation personnalisée",
    "enroll_member_in_membership_dues": "Membre inscrit aux cotisations syndicales",
    "dues_start_date": "Date de début des cotisations",
    "dues_amount": "Sommes dues",
    "choose_frequency": "Choix de la fréquence",
    "recurring_state": "État récurrent",
    "paused_2": "Pause",
    "autoemail_invoices": "factures auto-email",
    "enroll": "Inscription",
    "manage_revenue_payroll_and_future_accounting_mappings_used_by_privana": "Gérer les revenus, les états de paie et les futures cartes comptables utilisées par Privana moteurs d'affichage. Configurer les cartes d'activité opérationnelle dans le livre général.",
    "show_historical_mappings": "Afficher les mappages historiques",
    "add_mapping": "Ajouter Mapping",
    "revenue_mappings": "Cartographies de revenus",
    "existing_revenue_mapping_rules_used_by_invoice_and_receivables_posting": "Règles actuelles de cartographie des recettes utilisées par la facturation et l'affichage des créances.",
    "loading_gl_mappings": "Chargement des cartes GL...",
    "key": "Clé",
    "no_revenue_mappings_yet": "Il n'y a pas encore de cartes de revenus.",
    "payroll_journal_mappings": "Cartes de journal des états de paie",
    "payroll_posting_rules_used_when_payroll_journals_are_generated": "Les règles d'affichage des états de paie utilisées lors de la production des journaux de paie.",
    "mapping_key": "Clé de mappage",
    "debit_account": "Compte de débit",
    "credit_account": "Compte crédit",
    "effective_to_2": "Efficacité",
    "no_payroll_journal_mappings_yet_use_accounting_refresh_defaults_to": "Aucune correspondance de journal de paie pour le moment. Utilisez l’actualisation des valeurs par défaut de la comptabilité pour les rétablir.",
    "payroll_control_accounts": "Comptes de contrôle des états de paie",
    "payroll_liability_and_clearing_accounts_used_by_payroll_posting_and": "Comptes de passif et de compensation des états de paie utilisés par l'affichage des états de paie et le virement des produits de paye.",
    "account_purpose": "Objet du compte",
    "no_payroll_control_accounts_yet_use_accounting_refresh_defaults_to": "Pas encore de comptes de contrôle de la paie. Utilisez les défauts de frais comptables pour réparer les défauts.",
    "refresh_accounting_defaults": "Rafraîchir les défauts comptables ?",
    "this_creates_any_missing_default_accounts_tax_codes_dimensions_revenue": "Cela crée des comptes par défaut manquants, des codes fiscaux, des dimensions, des cartes de revenus et des cartes de paie pour les transactions futures seulement. Les factures historiques et les revues ne sont pas modifiées.",
    "preparing_your_clubs_accounting_defaults": "Préparer les défauts comptables de votre club",
    "were_checking_the_chart_of_accounts_tax_codes_dimensions_revenue": "Nous vérifions le graphique des comptes, les codes fiscaux, les dimensions, les cartes de revenus et les cartes des états de paie ainsi les frais futurs affichent proprement. Les factures historiques et les journaux sont laissés intacts.",
    "search_tax_codes": "Codes fiscaux de recherche...",
    "no_tax_codes_found": "Aucun code fiscal n'a été trouvé.",
    "no_fiscal_years_are_available_yet": "Aucun exercice n ' est encore disponible.",
    "select_fiscal_year": "Sélectionnez l'exercice",
    "select_a_fiscal_year_to_review_yearend_status": "Sélectionnez un exercice pour examiner l'état de fin d'exercice.",
    "loading_yearend_status": "Chargement du statut de fin d'année...",
    "some_modulespecific_checks_were_skipped_because_those_modules_are_not": "Certains contrôles spécifiques au module ont été ignorés parce que ces modules ne sont pas activés ou n'ont aucune activité pour ce club.",
    "close_fiscal_year": "Exercice budgétaire clos",
    "confirm_close": "Confirmer",
    "processing": "Traitement...",
    "submit_payment": "Soumission",
    "draft_bill": "facture",
    "edit_bill": "Modifier le facture",
    "create_bill": "Créer un facture",
    "save_bill": "Économiser",
    "people": "Personnes",
    "share": "Partager",
    "payroll_number": "Numéro de la paie",
    "employment_type": "Type d ' emploi",
    "job_title": "Titre du poste",
    "start_year": "Année de début",
    "start_month": "Commencez le mois",
    "start_day": "Jour de début",
    "pay_type": "Type de rémunération",
    "payroll_method": "Méthode de la paye",
    "payroll_calendar": "Calendrier des états de paie",
    "bank_readiness": "Préparation de la banque",
    "taxni_readiness": "Préparation fiscale/NI",
    "pension_status": "État des pensions",
    "payment_details_2": "Détails de paiement",
    "account_type": "Type de compte",
    "scheme": "Schéma",
    "account_holder": "Détenteur de compte",
    "sort_code": "Code de tri",
    "reference_last4": "Référence last4",
    "verification_status": "État de la vérification",
    "last_updated": "Dernière mise à jour",
    "set_verification_status": "État d ' avancement de la vérification",
    "current_rate": "Taux actuel",
    "payroll_status": "État de la paie",
    "readiness_status": "État de la lecture",
    "tax_status": "État de la fiscalité",
    "pension_status_2": "État des pensions",
    "last_paid": "Dernière Paid",
    "rate_wording": "Évaluer le libellé",
    "active_rate_status": "Statut de taux actif",
    "tax_and_ni_details": "Taxes et détails sur les ni",
    "tax_status_2": "État de l ' impôt",
    "ni_last4": "4 derniers caractères du numéro d’assurance nationale",
    "employee_contribution": "Contribution des employés",
    "employer_contribution": "Contribution de l ' employeur",
    "pension_enrolled_status": "État des pensions",
    "gb_employer_ni_status": "Employeur GB NI statut",
    "gross_pay": "Montant brut",
    "net_pay": "Solde net",
    "employer_costs": "Dépenses de l ' employeur",
    "total_payroll_cost": "Coût total des états de paie",
    "total_debits_2": "Total des débits",
    "total_credits_2": "Total des crédits",
    "payroll_period": "Période de paie",
    "sourcereference": "Source/référence",
    "saved_at": "enregistrée à",
    "saved_by": "enregistré par",
    "hmrc_total": "Total HMRC",
    "employee_ni": "Employé NI",
    "employer_ni": "Employeur NI",
    "source_reference": "Source / référence",
    "net_staff_payments": "Montant net des contributions du personnel",
    "total_cost_to_club": "Coût total pour le club",
    "payroll_calendar_2": "Calendrier des états de paie",
    "run_name": "Nom de course",
    "period_rule": "Règle",
    "generation_horizon_months": "Années de production",
    "pay_date_rule": "Règle de la date de paye",
    "day_of_month": "Jour du mois",
    "days_after_period_end": "Jours après la fin de la période",
    "approval_deadline_days": "Date limite d ' approbation",
    "timesheet_cutoff_rule": "Règle de coupure de la feuille de temps",
    "cutoff_days": "Jours d ' arrêt",
    "overtime_multiplier": "Multiplicateur des heures supplémentaires",
    "default_currency": "Monnaie par défaut",
    "timesheet_rounding_mode": "Mode d ' arrondissement de la feuille de temps",
    "calculation_source": "Source de calcul",
    "pension_provider": "Fournisseur de pensions",
    "employee_contribution_2": "Contribution des employés %",
    "employer_contribution_2": "Contribution de l'employeur %",
    "handled_by": "Géré par",
    "internal_calculation_mode": "Mode de calcul interne",
    "liability_mapping_key": "clef de la cartographie de la responsabilité",
    "expense_mapping_key": "clé de la cartographie des dépenses",
    "jurisdiction_key": "La clé de la compétence",
    "frequency_basis": "Fréquence",
    "variance_threshold_percent": "Taux d ' écart",
    "post": "Comptabiliser",
    "debit_gl_account": "Compte GL de débit",
    "credit_gl_account": "Crédit GL Compte",
    "balance_due_3": "Solde dû :",
    "issue_credit_memo": "Mémoire de crédit d'émission -",
    "save_gl_coding": "Enregistrer le codage glissant",
    "tax_amount": "Montant de la taxe",
    "account_2": "Compte :",
    "applied": "Appliquée:",
    "record_payment_2": "Paiement record -",
    "wire": "Filière",
    "partially_paid": "Partiellement payé",
    "overdue": "En retard",
    "posting_blocked": "Poste bloqué",
    "this_date_falls_in_a_locked_or_closed_period_change": "Cette date tombe dans une période verrouillée ou fermée. Changez la date ou demandez un déverrouillage.",
    "posting_failed": "L ' affectation a échoué",
    "failed_to_post_invoice_to_the_general_ledger": "Failed to post facture to the general ledger.",
    "failed_to_load_accounting_settings": "N'a pas chargé les paramètres comptables.",
    "unable_to_save_accounting_settings_check_the_account_selections_and": "Impossible d'enregistrer les paramètres comptables. Vérifiez les sélections de compte et essayez à nouveau.",
    "ar_control_account_not_set": "AR Compte de contrôle non réglé",
    "default_revenue_account_not_set": "Compte de recettes par défaut non réglé",
    "vat_control_account_not_set": "VAT compte de contrôle non réglé",
    "unable_to_save_line_gl_coding_please_try_again": "Impossible d'enregistrer la ligne de codage GL. Veuillez réessayer.",
    "one_or_more_selected_tax_codes_arent_effective_for_the": "Un ou plusieurs codes fiscaux sélectionnés ne sont pas efficaces pour la date d’émission de la facture. Mettre à jour la date d’émission ou choisir un autre code fiscal.",
    "some_tax_codes_were_not_effective_for_the_selected_issue": "Certains codes d'impôt n'étaient pas efficaces pour la date d'émission choisie et ont été supprimés.",
    "cannot_save_no_club_context": "Impossible de Enregistrer: Pas de contexte club.",
    "failed_to_save_invoice": "Failed to save facture.",
    "unable_to_record_payment": "Incapable d'enregistrer le paiement.",
    "finalized": "Final finalisé",
    "finalize_reconciliation": "Finalisation de la réconciliation",
    "detected_format": "Format détecté:",
    "save_account": "Compte",
    "save_dimension": "Sauvegarder Dimension",
    "report": "Rapport",
    "as_of": "Au",
    "confidence": "Confiance",
    "remaining_to_match": "Reste à correspondre:",
    "required_tasks": "Obligatoires",
    "required": "requis",
    "optional_2": "optionnel",
    "paye_income_tax": "Impôt sur le revenu du PAYE :",
    "employee_national_insurance": "Assurance nationale des employés :",
    "employer_national_insurance": "Assurance nationale de l'employeur:",
    "hmrc_total_2": "Total HMRC :",
    "add_adjustment_scaffold_is_ready_for_a_later_payroll_calculation": "Ajouter l'échafaudage d'ajustement est prêt pour un laissez-passer plus tard.",
    "finance_details": "détails financiers",
    "enabled": "activé",
    "cost_center": "Centre de coûts",
    "we_hit_a_snag_rendering_this_report_preview": "Nous avons frappé un snag rendant ce rapport prévisualiser.",
    "try_running_the_report_again_or_adjust_the_date_range": "Essayez d'exécuter le rapport à nouveau ou d'ajuster l'intervalle de dates. Si le problème persiste, le support de contact.",
    "fiscal_month": "Mois financier",
    "direct_payment_via_member_portal": "Paiement direct via le portail des membres",
    "month_close": "Mois Fermer",
    "pos_transaction": "Transaction en caisse",
    "transaction": "Transaction",
    "billable": "Facteur imprévu",
    "recurring_billing_only_activates_when_a_positive_dues_amount_and": "La facturation récurrente ne s'active que lorsqu'une quantité et une fréquence de dues positives sont fournies. Les défauts de type d'adhésion sont utilisés par le backend lorsque cela est disponible; sinon les valeurs saisies ici sont requises.",
    "accounting_refresh_defaults": "Défauts de réfrigération comptable",
    "save_mapping": "Enregistrer la correspondance",
    "all_types": "Tous les types",
    "asset": "Actif",
    "liability": "Responsabilité",
    "equity": "Équité",
    "revenue": "Chiffre d’affaires",
    "expense": "Dépense",
    "active_only": "Activer uniquement",
    "active_inactive": "Actif + Inactif",
    "selected_vendor": "Sélection de fournisseurs",
    "select_a_vendor": "Sélectionnez un vendeur",
    "supplier_statement": "État du fournisseur",
    "collect": "Collecte",
    "outstanding_revenue_requiring_attention": "Revenus exceptionnels nécessitant une attention particulière",
    "overdue_member_balances": "Solde des membres en retard",
    "review_balances": "Soldes d ' examen",
    "due_this_week": "Dûre cette semaine",
    "open_receivables": "Débiteurs ouverts",
    "credit_balances_unapplied_cash": "Soldes créditeurs et encaissements non affectés",
    "view_accounts": "Comptes créditeurs",
    "items_that_need_to_be_posted_into_the_books": "Les articles qui doivent être affichés dans les livres",
    "awaiting_posting": "Attendre l ' affichage",
    "open_queue": "Ouvrir la file",
    "invoices_awaiting_posting": "Factures en attente d ' affichage",
    "review_invoices": "Facteurs d ' examen",
    "ap_bills_awaiting_posting": "Factures fournisseurs en attente de comptabilisation",
    "review_bills": "factures d ' examen",
    "posting_exceptions": "Absence d ' affectation",
    "review_exceptions": "Exceptions d ' examen",
    "pay": "Solde",
    "supplier_obligations_coming_due": "Obligations du fournisseur à venir",
    "overdue_supplier_bills": "Facteurs de fournisseurs en retard",
    "review_overdue": "Examen attendu",
    "due_today": "Dû aujourd'hui",
    "open_due_today": "Ouvert aujourd'hui",
    "review_schedule": "Calendrier d ' examen",
    "reconcile": "Concilier",
    "bank_and_control_items_needing_review": "Questions bancaires et de contrôle nécessitant un examen",
    "unmatched_transactions": "Opérations inégalées",
    "reviewed_but_unmatched": "Révisée mais non satisfaite",
    "continue_review": "Poursuite de l ' examen",
    "bank_accounts_unreconciled_this_period": "Comptes bancaires non reconduits cette période",
    "close_controls": "Fermer / Commandes",
    "periodend_tasks_and_blockers": "Les tâches de fin d'exercice et les bloqueurs",
    "ar_posting_incomplete": "A/R affichage incomplet",
    "ap_posting_incomplete": "A/P affichage incomplet",
    "resolve_items": "Résoudre les articles",
    "bank_reconciliation_incomplete": "Réconciliation des banques incomplète",
    "open_reconciliation": "Réconcilier ouvert",
    "monthclose_blockers": "Blocs de mois-close",
    "view_blockers": "Voir les bloqueurs",
    "receivables_outstanding": "Sommes non acquittées",
    "supplier_bills_due": "factures du fournisseur due",
    "posting_issues": "Questions relatives à l ' affectation",
    "last_updated_time": "Dernière mise à jour {time}",
    "record_payment_for_member": "Paiement record pour {member}",
    "issue_credit_memo_for_member": "Publication de la note de crédit pour {member}",
    "invoice_number": "Facture {number}",
    "on_hold": "Attends.",
    "any_3": "N'importe quoi.",
    "all_categories": "Toutes les catégories",
    "invoiced": "Facturé",
    "all_departments_2": "Tous les départements",
    "awaiting_approval": "Attendant l ' approbation",
    "exceptions": "Exceptions",
    "accommodation": "Hébergement",
    "normal": "Normale",
    "warning_2": "Attention",
    "import_failed_2": "Importation échouée",
    "submit_for_approval": "Soumettre l ' homologation",
    "approval_status": "Statut d ' homologation",
    "error_2": "Erreur",
    "events": "Évènements",
    "facilities": "Installations",
    "golf": "Golf",
    "racquet": "Raquette",
    "please_try_again": "Veuillez réessayer.",
    "benefits": "Avantages",
    "bulk_update_failed": "Mise à jour en vrac échouée",
    "membership": "Adhésion",
    "accounting": "Comptabilité",
    "expenses": "Dépenses",
    "spa": "Spa",
    "fitness": "Fitness",
    "payables": "Soldes",
    "activities": "Activités",
    "pay_date": "Date de paye",
    "front_desk": "Réception",
    "club": "Club",
    "company": "Société",
    "your_changes_have_been_saved": "Vos changements ont été sauvegardés.",
    "display_name": "Nom d ' écran",
    "spa_wellness": "Spa et bien-être",
    "missing": "Portée disparue",
    "please_refresh_and_try_again": "S'il vous plaît rafraîchir et essayez à nouveau.",
    "download_pdf": "Télécharger PDF",
    "invalid_date": "Date invalide",
    "supplier_not_found": "Fournisseur non trouvé.",
    "unable_to_load_supplier_ageing_detail": "Incapable de charger le détail du vieillissement du fournisseur.",
    "cheque": "Chérie",
    "select_a_bank_account_for_bank_payments": "Sélectionnez un compte bancaire pour les paiements bancaires.",
    "fix_payment_amounts_before_submitting": "Fixer les montants de paiement avant de soumettre.",
    "batch_payment_recorded": "Paiement par lots enregistré.",
    "missing_accounting_defaults": "Manque de défauts comptables.",
    "set_ap_control_and_payment_accounts_before_posting": "Définir les comptes de contrôle AP et de paiement avant d'afficher.",
    "failed_to_pay_selected_bills": "Ne pas payer les factures sélectionnées.",
    "failed_to_save_bill": "Je n'ai pas réussi à Enregistrer la facture.",
    "enter_a_valid_payment_amount": "Entrez un montant de paiement valide.",
    "payment_amount_must_cover_allocations": "Le montant du paiement doit couvrir les allocations.",
    "fix_allocation_amounts_before_submitting": "Fixer les montants d'allocation avant de soumettre.",
    "failed_to_record_payment": "Je n'ai pas enregistré le paiement.",
    "no_open_bills_found": "Aucune facture fournisseur en cours trouvée.",
    "select_a_vendor_to_view_open_bills": "Sélectionnez un vendeur pour afficher les factures ouvertes.",
    "loading_4": "Chargement…",
    "gross_payroll": "Montant brut",
    "latest_payroll_total": "Dernier total des états de paie",
    "no_payroll_yet": "Pas de solde",
    "monthly_variance": "Variation mensuelle",
    "run_another_month_to_compare": "Exécutez un autre mois pour comparer",
    "higher_than_previous_month": "Plus élevé que le mois précédent",
    "lower_than_previous_month": "Moins que le mois précédent",
    "highest_department_weighting": "Poids le plus élevé du département",
    "add_departments_to_compare": "Ajouter les ministères à comparer",
    "not_required_for_run": "Non requis pour Run",
    "employee_did_not_work": "L'employé n'a pas travaillé.",
    "employee_will_be_paid_base_salary_only": "L'employé ne paiera que le salaire de base.",
    "employee_will_be_included_as_0_pay_only_after_you": "L'employé sera inclus dans le paiement de £0 seulement après que vous confirmez qu'il n'a pas travaillé.",
    "review_before_payroll_can_proceed": "L'examen avant la paie peut se poursuivre.",
    "dashboard": "Tableau de bord",
    "payroll_runs": "Cours de paie",
    "approvals": "Homologation",
    "liabilities": "Passif",
    "settings": "Paramètres",
    "annual_salary": "Salaire annuel",
    "gross_annual_salary_before_deductions": "Salaire annuel brut avant déductions.",
    "hourly_rate": "Taux horaire",
    "standard_hourly_rate_before_overtime": "Taux horaire standard avant les heures supplémentaires.",
    "casual_hourly_rate": "Tarif horaire occasionnel",
    "default_casual_hourly_rate": "Taux horaire par défaut.",
    "contractor_rate": "Taux d ' entrepreneur",
    "default_contractor_rate_confirm_whether_this_is_hourly_or_dayrate": "Taux d'entrepreneur par défaut. Confirmer si ce taux est horaire ou jour avant que le calcul des états de paie ne soit activé.",
    "awaiting_approval_2": "Approbation attendue",
    "approved_2": "Postes approuvés",
    "bacs_payment_file": "Fichier de paiement BACS",
    "nacha_payment_file": "Fichier de paiement NACHA",
    "sepa_payment_file": "Fichier de paiement SEPA",
    "bank_payment_file_csv": "Fichier de paiement bancaire CSV",
    "download_csv": "Télécharger CSV",
    "blocked_statutory_values_stale": "Bloqués : l ' impasse des valeurs statutaires",
    "blocked_employeelevel_statutory_values_required": "Bloqué : Valeurs légales requises au niveau des employés",
    "regenerate_pdf_required": "Régénérer PDF requis",
    "ready_to_generate": "Prêt à générer",
    "payroll_summary_report": "Rapport sommaire des états de paie",
    "grosstonet_summary_report": "Rapport de synthèse brut-réseau",
    "employee_breakdown_summary": "Résumé de la répartition des employés",
    "pension_contributions_summary": "Résumé des contributions aux pensions",
    "hmrc_summary_report": "Rapport sommaire de la Commission",
    "final_payslips": "Final paylips",
    "csv_summary_exports_and_printable_final_payslips_the_bank_payment": "CSV exportations sommaires et fiches de paiement finals imprimables. Le fichier de paiement bancaire est un artefact export/validation seulement et ne déplace jamais d'argent.",
    "generate_payroll_documents": "Générer les documents de paie",
    "blocked": "Bloqué",
    "not_generated_yet": "Pas encore généré",
    "generate_employeespecific_final_payslip_snapshots_before_publishing": "Générer des instantanés de paylip finals spécifiques aux employés avant de publier.",
    "send_via_portal": "Envoyer via le portail",
    "complete_once_to_make_payroll_clubready": "Complétez une fois pour faire le club de paie prêt.",
    "confirm_country": "Confirmer le pays",
    "choose_payroll_provider": "Choisissez Payroll Provider",
    "confirm_pension_provider": "Confirmer le fournisseur de pension",
    "verify_payroll_calendar": "Vérifier le calendrier des états de paie",
    "backenddriven_finance_control_workspace_for_the_active_payroll_run": "Espace de travail de contrôle financier pour la gestion active de la paie.",
    "current_run_name": "Nom d ' exécution courant",
    "pay_period": "Période de paye",
    "approval_deadline": "Date limite d ' homologation",
    "target_payment_date": "Date limite de paiement",
    "posting_readiness": "Préparation des postes",
    "recommendation_create_or_calculate_the_current_payroll_run_before_approval": "Recommandation : créer ou calculer le cycle de paie actuel avant l'approbation.",
    "insight_employee_readiness_timesheet_approvals_blockers_and_journal_preview_are": "Insight: la préparation des employés, les approbations de feuilles de temps, les bloqueurs et la prévisualisation de journal sont chargés des données de backend de payroll.",
    "plainenglish_checks_based_on_actual_payroll_data": "Vérifications Plain-anglais basées sur les données de paye réelles.",
    "payroll_mapping": "Cartographie des états de paie",
    "preview_only_balanced_journal_lines_appear_after_payroll_approvalpost_preview": "Prévisualisation seulement. Les lignes de journal équilibrées apparaissent après l'approbation des états de paie/première avant-poste.",
    "no_journal_preview_yet": "Pas de prévisualisation de journal",
    "create_or_calculate_a_payroll_run": "Créer ou calculer une course de paie",
    "employees_ready": "Employés prêts",
    "bank_details": "Détails de la banque",
    "tax_details": "Détails de la taxe",
    "approved_timesheets": "Feuilles de temps approuvées",
    "blockers": "Bloqueurs",
    "current_payroll": "État actuel des états de paie",
    "period_not_set": "Période non réglée",
    "gross_pay_2": "Solde brut",
    "net_preview": "Aperçu net",
    "employer_costs_2": "Coûts de l'employeur",
    "total_payroll_cost_2": "Total des frais de paye",
    "where_this_run_is_and_what_happens_next": "Où est cette course et ce qui se passe ensuite.",
    "backend_checks_that_determine_whether_payroll_can_move_forward": "Les vérifications de backend qui déterminent si la paie peut aller de l'avant.",
    "needs_attention_2": "Besoin d ' attention",
    "no_payroll_trend_data_yet_complete_your_first_payroll_run": "Pas encore de données de tendance de la paye. Complétez votre première course de la paye pour commencer à construire des aperçus de la paye.",
    "latest_payroll_weighting_by_employee_department_employer_costs_are_not": "Le dernier pondération des états de paie par le ministère des employés. Les coûts de l'employeur ne sont pas répartis entre les ministères en V1.",
    "calculate_payroll_with_employee_departments_to_unlock_department_weighting": "Calculer la masse salariale avec les ministères employés pour débloquer le poids du ministère.",
    "open_payroll_settings": "Réglages des états de paie ouverts",
    "open_statutory_payroll_inputs": "Entrées des états de paie",
    "open_employee_payroll_profile": "Ouvrir le profil de paye des employés",
    "readiness_details": "Détails de lecture",
    "review_this_payroll_readiness_item": "Révisez cet article de préparation aux états de paie.",
    "payroll_run": "Cycle de paie",
    "fixed_salary": "Traitement fixe",
    "timesheet_required": "Feuille de temps nécessaire",
    "salary_timesheet_adjustments": "Rajustements de la feuille de temps",
    "paid_from_the_profile_rate_without_requiring_a_timesheet": "Payé à partir du taux de profil sans avoir besoin d'une feuille de temps.",
    "paid_from_approved_timesheet_hours_for_each_payroll_period": "Payées à partir des heures approuvées pour chaque période de paie.",
    "base_salary_comes_from_the_profile_rate_timesheets_capture_overtimeadjustments": "Le salaire de base provient du taux de profil; les feuilles de temps capturent les heures supplémentaires et les ajustements.",
    "fixed_day_of_month": "Jour fixe du mois",
    "last_day_of_month": "Dernier jour du mois",
    "last_working_day_of_month": "Dernier jour ouvrable du mois",
    "last_monday_of_month": "Lundi dernier du mois",
    "last_tuesday_of_month": "Mardi dernier du mois",
    "last_wednesday_of_month": "Mercredi dernier du mois",
    "last_thursday_of_month": "Jeudi dernier du mois",
    "last_friday_of_month": "Vendredi dernier du mois",
    "missing_bank": "Banque manquante",
    "missing_tax": "Impôts manquants",
    "missing_pension": "Pension manquante",
    "unnamed_employee": "Employé non désigné",
    "view_employee": "Voir l'employé",
    "fix_details": "Fixer les détails",
    "add_an_employee_or_adjust_the_filters": "Ajouter un employé ou ajuster les filtres.",
    "could_not_load_departments": "Ne pourrait pas charger les départements",
    "could_not_move_employees_the_change_was_reverted": "Il n'a pas pu déplacer les employés. Le changement a été réversé.",
    "enter_a_department_name_first": "Entrez d'abord un nom de département.",
    "could_not_create_department": "Impossible de créer un département.",
    "move_people_here_to_remove_assignment": "Déplacez les gens ici pour supprimer l'affectation.",
    "drag_people_here_or_use_the_selector": "Faites glisser des gens ici ou utilisez le sélecteur.",
    "could_not_archive_department": "Impossible d'archiver.",
    "visual_payroll_team_management_avatarled_draganddrop_friendly_no_hierarchy": "Gestion de l'équipe de paye visuelle — conduite par avatar, facile à glisser-déposer, pas de hiérarchie.",
    "create_department": "Créer un département",
    "select_a_staff_member_before_creating_the_employee_setup": "Sélectionnez un membre du personnel avant de créer la configuration de l'employé.",
    "choose_a_pay_type": "Choisissez un type de paye.",
    "choose_a_payroll_status": "Choisissez un statut de paye.",
    "we_could_not_create_this_employee_payroll_setup_please_check": "Nous ne pouvions pas créer cette configuration de la paie de l'employé. Veuillez vérifier les détails et essayer de nouveau.",
    "create_employee": "Créer un employé",
    "start_with_a_staff_record_then_configure_pay_and_readiness": "Commencez par un dossier personnel, puis configurez les bases de la paye et de la préparation.",
    "no_calendar": "Aucun calendrier",
    "bank_payment_details_are_not_configured_for_this_club_jurisdiction": "Les détails de paiement bancaire ne sont pas encore configurés pour cette juridiction de club.",
    "account_holder_name": "Nom du titulaire du compte",
    "payment_reference_optional": "Référence de paiement (facultatif)",
    "routing_number": "Numéro de routage",
    "checking": "Vérification",
    "savings": "Soldes",
    "privana_stores_payroll_payment_details_encrypted_full_details_are_never": "Privana stocke les détails de paiement crypté. Les détails complets ne sont plus jamais affichés après l'enregistrement.",
    "replacement_reason": "Raison de remplacement",
    "replace_payment_details": "Remplacer les détails de paiement",
    "add_payment_details": "Ajouter les détails de paiement",
    "profile_detail_could_not_be_loaded": "Le détail du profil n'a pas pu être chargé.",
    "replacement_reason_is_required_when_replacing_payment_details": "Une raison de remplacement est requise pour remplacer les détails de paiement.",
    "payment_details_saved_review_the_refreshed_details_then_mark_them": "Détails de paiement enregistrés. Révisez les détails rafraîchis, puis notez-les vérifiés une fois vérifiés.",
    "payroll_profile_changes_saved": "Changements de profil de paye enregistrés.",
    "payment_verification_status_updated": "État de vérification des paiements mis à jour.",
    "payment_verification_status_could_not_be_updated": "L ' état de la vérification des paiements n ' a pas pu être mis à jour.",
    "status_could_not_be_updated": "Le statut ne peut pas être mis à jour.",
    "payroll_number_pending": "Numéro de la paie en attente",
    "no_active_rate": "Pas de taux actif",
    "not_paid_yet": "Pas encore payé",
    "no_amount_configured": "Aucun montant configuré",
    "active_3": "Actif",
    "not_active": "Non active",
    "amount_paid_according_to_the_selected_pay_type": "Montant payé selon le type de paye sélectionné.",
    "no_full_ni_number_stored": "Aucun numéro de NI complet stocké.",
    "employeespecific_employer_cost_overrides_are_stored_in_pension_metadata": "Les frais d'employeur spécifiques aux employés sont stockés dans les métadonnées de pension.",
    "audit_event_recorded": "Manifestation de vérification enregistrée.",
    "no_records_yet": "Pas encore d'enregistrement.",
    "hmrcpaye_liability": "Responsabilité HMRC/PAYE",
    "hmrc_payroll_liability": "Responsabilité en matière de paie HMRC",
    "journal_balanced": "Journal équilibré",
    "journal_not_balanced": "Revue n'est pas équilibrée",
    "employer_costs_currently_000": "Coûts de l'employeur actuellement 0,00 £",
    "mapping_needed": "Cartographie nécessaire",
    "could_not_load_timesheets": "Impossible de charger des feuilles de temps",
    "timesheet_action_failed": "L'action de la feuille de temps a échoué",
    "submitted_hours": "Heures de soumission",
    "approved_hours": "Heures approuvées",
    "overtime_hours": "Heures supplémentaires",
    "missing_timesheets": "Des feuilles de temps manquantes",
    "pending_approvals": "Approbations en attente",
    "approved_timesheets_are_the_operational_input_layer_for_timesheetdriven_and": "Les feuilles de temps approuvées sont la couche d'entrée opérationnelle pour les employés à base de feuilles de temps et hybrides.",
    "regular_hours": "Heures régulières",
    "overtime": "Heures supplémentaires",
    "holiday": "Vacances",
    "sick": "Malades",
    "total_hours": "Heures totales",
    "none": "Aucun",
    "could_not_load_timesheet": "Ne peut pas charger la feuille de temps",
    "could_not_save_draft": "Il ne peut pas Enregistrer le projet.",
    "action_failed_2": "L ' action a échoué",
    "timesheet": "Feuille de temps",
    "regular": "ordinaire",
    "no_adjustments_yet": "Pas encore d'ajustement.",
    "could_not_create_timesheet": "Impossible de créer une feuille de temps",
    "this_timesheet_records_overtime_holiday_sick_training_or_extra_payable": "Cette feuille de temps enregistre les heures supplémentaires, les vacances, les malades, la formation ou les heures supplémentaires à payer. Le salaire fixe demeure contrôlé par l'établissement de la rémunération de l'employé.",
    "this_timesheet_records_payable_hours_for_the_selected_payroll_period": "Cette feuille de temps enregistre les heures à payer pour la période de paye choisie.",
    "create_a_draft_timesheet_for_a_generated_payroll_period": "Créer une feuille de temps pour une période de paye générée.",
    "choose_employee": "Choisir un employé",
    "choose_payroll_period": "Choisissez la période de paye",
    "import_support_is_ready_for_csvtimeclock_integrations_this_pass_creates": "Le support d'importation est prêt pour les intégrations CSV /time-clock. Ce laissez-passer crée des feuilles de temps de paye seulement.",
    "approve_payroll": "Effectif de la paie",
    "prepare_finance_preview": "Prévisualisation des finances",
    "view_payroll": "Voir la liste de paie",
    "open_payroll": "À la solde ouvert",
    "could_not_load_payroll_runs": "Il ne pouvait pas charger les états de paie",
    "gross": "Montant brut",
    "net_preview_2": "Aperçu net",
    "ready_4": "✓ Prêt",
    "create_a_run_from_an_open_payroll_period_to_start": "Créer une course d'une période de paye ouverte pour commencer l'examen des états de paie guidé.",
    "not_supplied": "Non fourni",
    "recorded_user": "Enregistré utilisateur",
    "employeelevel_statutory_values_are_ready_for_payroll_documents_and_future": "Les valeurs statutaires des employés sont prêtes pour les documents de paie et les fiches de paie futures.",
    "legacy_providersupplied_statutory_values_are_held_at_run_level_and": "Les valeurs statutaires fournies par le fournisseur de l'héritage sont maintenues au niveau de l'exécution et ne sont pas des paylipes des employés.",
    "missing_paye": "Solde manquant",
    "missing_employee_ni": "Employé disparu NI",
    "missing_employer_ni": "Employeur manquant NI",
    "net_pay_below_zero": "Solde net inférieur à zéro",
    "unsaved_changes_reset": "Changements non enregistrés réinitialiser.",
    "postedlocked_payroll_runs_are_readonly": "Les états de paie postés/bloqués sont lus seulement.",
    "complete_paye_employee_ni_and_employer_ni_for_every_employee": "Terminé PAYE, Employé NI et Employeur NI pour chaque employé avant d'épargner.",
    "employee_statutory_payroll_inputs_saved": "Entrées des états de paie des employés enregistrées.",
    "payroll_rows_changed_refreshing_this_run_please_review_and_save": "Les lignes de paie ont changé. Rafraîchissement de cette course — veuillez revoir et économiser de nouveau.",
    "could_not_save_statutory_payroll_inputs": "Il ne pourrait pas économiser les intrants des états de paie.",
    "paye_income_tax_2": "Impôt sur le revenu",
    "employee_national_insurance_2": "Assurance nationale",
    "employer_national_insurance_2": "Employeur Assurance nationale",
    "employee_pension": "Pension des employés",
    "other_employee_deductions": "Autres déductions des employés",
    "net_pay_2": "Solde net",
    "total_employer_cost": "Coût total de l ' employeur",
    "invalid": "Invalide",
    "missing_inputs": "Entrées manquantes",
    "complete_3": "Complet",
    "could_not_create_payroll_run": "Ça ne pourrait pas créer de paie.",
    "create_a_payroll_run_from_a_generated_payroll_period": "Créer une liste de paie à partir d'une période de paye générée.",
    "choose_calendar": "Choisir le calendrier",
    "choose_open_generated_period": "Choisissez une période ouverte",
    "resolve_blockers": "Résoudre les bloqueurs",
    "fix_payroll_blockers_before_submitting": "Fixer les bloqueurs de paie avant de soumettre.",
    "enter_statutory_payroll_inputs": "Entrer les intrants des états de paie légaux",
    "enter_providersupplied_paye_employee_ni_and_employer_ni_for_each": "Saisissez le PAI fourni par le fournisseur, l'employé NI et l'Employeur NI pour chaque employé avant l'approbation.",
    "calculate_payroll": "Calcul des états de paie",
    "approve_payroll_2": "Effectif de la paie",
    "resolve_blockers_before_approval_2": "Résoudre les bloqueurs avant l'approbation.",
    "prepare_finance_preview_2": "Prévisions de financement",
    "post_payroll_to_accounting": "Rémunération des postes à la comptabilité",
    "journal_not_balanced_review_the_finance_preview_before_posting": "Revue non équilibrée. Réviser l'aperçu financier avant l'affichage.",
    "record_payroll_payment": "Enregistrement des paiements de paye",
    "lock_payroll": "Paie de la serrure",
    "payroll_complete": "Paie complète",
    "this_payroll_run_is_complete": "Cette course de paie est terminée.",
    "could_not_load_payroll_run": "Il ne peut pas charger la paie.",
    "enter_statutory_payroll_inputs_before_continuing": "Entrez les intrants des états de paie avant de continuer.",
    "payroll_has_already_been_posted_and_cannot_be_rolled_back": "La paie a déjà été postée et ne peut pas être roulée.",
    "payroll_finance_mappings_need_attention": "Les cartes des finances des états de paie ont besoin d'attention.",
    "post_payroll_to_accounting_before_payment": "Post paye à la comptabilité avant le paiement.",
    "complete_finance_posting_payables_and_staff_payment_before_locking_payroll": "Postes financiers complets, à payer et à payer avant le verrouillage des états de paie.",
    "this_payroll_run_is_not_ready_for_that_step": "Cette course de paie n'est pas prête pour cette étape.",
    "payroll_finance_preview_is_not_balanced_yet": "L'aperçu financier de la paie n'est pas encore équilibré.",
    "this_payroll_run_is_locked": "Cette course de paie est bloquée.",
    "payroll_run_updated": "États de paie mis à jour.",
    "payroll_summary_reports_generated": "Rapports sommaires des états de paie générés.",
    "nowork_exception_recorded": "Aucune exception de travail enregistrée.",
    "timesheetnotrequired_acknowledgement_recorded": "Reconnaissance non-obligatoire enregistrée.",
    "load_the_payroll_run_before_generating_reports": "Chargez la paie avant de produire des rapports.",
    "payroll_run_2": "Cycle de paie",
    "follow_the_guided_payroll_lifecycle_from_review_through_accounting_posting": "Suivez le cycle de vie de la paye guidé de l'examen par l'affichage comptable, les exigibles, le paiement et la serrure.",
    "review_this_item_before_moving_payroll_forward": "Examiner ce point avant d'avancer les états de paie.",
    "open_payroll_settings_and_fix_finance_mappings": "Ouvrir les paramètres de la paie et fixer les cartes de financement.",
    "open_the_related_employee_timesheet_or_deduction_totals_and_update": "Ouvrez l'employé, la feuille de temps ou les totaux de retenue et mettez à jour les renseignements manquants.",
    "confirm_staff_portal_publishing_for_this_payroll_run": "Confirmer la publication du portail du personnel pour cette course de la paie.",
    "publish_payslips": "Publiez des fiches pays",
    "employee_breakdown_uses_saved_employeelevel_statutory_inputs_ready_for_payslip": "La répartition des employés utilise des intrants statutaires enregistrés au niveau des employés. Les valeurs des moyens de Payslip sont capturées; les documents de paylip générés apparaissent dans les Documents de paye.",
    "legacy_runlevel_statutory_values_are_not_employee_payslips_final_payslips": "Les valeurs légales au niveau de la relève ne sont pas des paylipes des employés. Les fiches de paie finales exigent des valeurs statutaires des employés.",
    "pay_type_2": "Type de paiement",
    "base_pay": "Solde de base",
    "regular_hours_2": "Heures normales",
    "overtime_hours_2": "Heures supplémentaires",
    "overtime_pay": "Indemnités supplémentaires",
    "deductions": "Déductions",
    "runlevel_only": "Niveau de piste seulement",
    "included_in_run_summary": "Inclus dans le résumé de l'exercice",
    "see_run_totals": "Voir les totaux de course",
    "no_work_this_period": "Pas de travail pour cette période",
    "runlevel_statutory_values": "Valeurs statutaires",
    "show": "Montrez",
    "payable_created": "Payable créé",
    "no_payment_preview_yet": "Pas encore de prévisualisation de paiement.",
    "approval": "Homologation",
    "payroll_approval_required": "Approbation de la paie requise",
    "finance_admin": "Finance / administrateur",
    "no_due_date": "Sans échéance",
    "no_linked_item_is_available_yet": "Aucun article lié n'est encore disponible.",
    "open_the_linked_payroll_item": "Ouvrez l'élément de paye lié.",
    "open_linked_item": "Ouvrez l'objet lié",
    "no_action_available": "Pas d ' action disponible",
    "no_payroll_approvals_or_blocker_reviews_are_waiting": "Aucune approbation de paie ni aucun avis de blocage n'attendent.",
    "payroll_clearing": "Liquidation des états de paie",
    "benefits_and_other": "Avantages et autres",
    "payroll_obligation": "Obligation au titre de la paie",
    "create_payment_coming_soon": "Créer un paiement à venir",
    "preview_only": "Aperçu uniquement",
    "create_and_calculate_a_payroll_run_to_see_payroll_liability": "Créer et calculer une course de paie pour voir les prévisualisations de la responsabilité de la paie.",
    "no_rounding": "Pas de ronde",
    "round_to_nearest_5_minutes": "Tour à 5 minutes le plus proche",
    "round_to_nearest_15_minutes": "Tour à 15 minutes le plus proche",
    "round_up_to_nearest_15_minutes": "Rond jusqu'à 15 minutes les plus proches",
    "settings_saved": "Les paramètres sont enregistrés.",
    "unable_to_save_settings": "Impossible de sauvegarder les paramètres.",
    "payroll_policies_saved": "Les politiques de paye sont sauvegardées.",
    "unable_to_save_payroll_policies": "Incapable d'épargner les politiques de paie.",
    "unable_to_refresh_payroll_rule_defaults": "Incapable de rafraîchir la règle de payroll par défaut.",
    "provider_supplied": "Fourni",
    "privana_records_statutory_payroll_outputs_supplied_by_your_accountant_payroll": "Privana enregistre les produits de la paie fournis par votre comptable, votre bureau de paie ou votre logiciel de paie.",
    "connected_payroll_engine": "Moteur de paie connecté",
    "coming_soon_privana_will_receive_statutory_outputs_from_a_connected": "Bientôt — Privana recevra les sorties légales d'un moteur de paie connecté.",
    "checked_manually": "Vérifié manuellement",
    "checked_by_a_person_before_approval": "Consulté par une personne avant l'approbation.",
    "privana_calculates": "Privana Calculs",
    "privana_calculates_this_when_configured": "Privana calcule cela lors de la configuration.",
    "handled_outside_privana": "Manipulé à l'extérieur Privana",
    "handled_outside_privana_final_totals_are_entered_manually": "Handled outside Privana ; les totaux finals sont entrés manuellement.",
    "not_used": "Non utilisé",
    "disabled": "Handicapés.",
    "provider_supplied_values_are_entered_during_payroll_run_review": "Fournisseur fourni — les valeurs sont entrées lors de l'examen des états de paie.",
    "statutory_values_change_every_payroll_run_so_they_are_entered": "Les valeurs légales changent tous les états de paie, de sorte qu'ils sont inscrits sur l'écran d'examen des états de paie, et non dans les paramètres.",
    "employer_pension_contributions": "Contributions des pensions de l ' employeur",
    "clubfunded_workplace_pension_cost": "Coût de pension de travail financé par le club.",
    "set_the_employer_pension_rate_privana_should_calculate_from_eligible": "Définir le taux de pension de l'employeur Privana devrait calculer à partir de la rémunération brute admissible.",
    "fixed_employer_contributions": "Contributions de l'employeur fixes",
    "flat_employer_contribution_per_run_when_your_club_uses_one": "Contribution de l'employeur plat par run lorsque votre club en utilise un.",
    "use_only_for_fixed_club_employer_costs_that_should_be": "Utiliser seulement pour les coûts fixes de l'employeur de club qui devraient être ajoutés à chaque course de paie.",
    "manual_employer_cost_adjustments": "Ajustement des coûts manuels de l'employeur",
    "auditable_manual_employer_cost_adjustment": "Rajustement des coûts manuels vérifiables de l'employeur.",
    "use_for_reviewed_employer_costs_that_are_not_statutory_deductions": "Utilisation pour les frais d'employeur révisés qui ne sont pas des déductions légales ou des pensions.",
    "workplace_pension_scheme": "Régime de retraite en milieu de travail",
    "provider_employee_contribution_club_contribution_and_autoenrolment_settings": "Fournisseur, cotisation des employés, cotisation du club et auto-inscription.",
    "set_the_provider_and_contribution_percentages_your_club_uses_for": "Définir le fournisseur et les pourcentages de contribution que votre club utilise pour l'auto-inscription.",
    "additional_pay_for_approved_overtime_hours": "Une rémunération supplémentaire pour les heures supplémentaires approuvées.",
    "use_the_multiplier_your_club_applies_when_approved_hours_are": "Utilisez le multiplicateur que votre club applique lorsque les heures approuvées sont effectuées au-delà des heures normales.",
    "holiday_pay": "Paye de vacances",
    "paid_annual_leave": "Congé annuel payé.",
    "choose_how_holiday_pay_is_handled_for_your_club_staff": "Choisissez comment la paye de vacances est gérée pour le personnel de votre club.",
    "sick_pay": "Indemnités",
    "pay_for_approved_sickness_absence": "Payez pour l'absence de maladie approuvée.",
    "choose_statutory_sick_pay_your_club_policy_or_manual_review": "Choisissez une rémunération maladie légale, une politique de votre club ou un examen manuel.",
    "private_healthcare_car_allowances_and_other_benefits": "Santé privée, indemnités de voiture et autres prestations.",
    "turn_this_on_only_if_your_club_tracks_employee_benefits": "Tournez-le seulement si votre club suit les avantages sociaux des employés dans la paie.",
    "statutory_payroll": "Effectif législatif",
    "pension_benefits": "Pensions et prestations",
    "pay_policies": "Politiques de paye",
    "customised": "Personnalisé",
    "using_defaults": "Utilisation de Par défauts",
    "disabled_2": "Désactivé",
    "enabled_2": "Activé",
    "united_kingdom": "Royaume-Uni",
    "united_states": "armement États-Unis",
    "european_payroll_region": "Région des états de paie européens",
    "payroll_jurisdiction_not_set": "Compétence de la paye non définie",
    "united_kingdom_payroll_rules": "Royaume uni règles de paie",
    "united_states_payroll_rules": "Etats unis règles de la paie",
    "european_payroll_rules": "Règles de paie européennes",
    "payroll_rules": "Règles de paye",
    "payroll_calendar_saved": "Calendrier des états de paie enregistré.",
    "unable_to_save_payroll_calendar": "Impossible d'enregistrer le calendrier des états de paie.",
    "payroll_periods_generated_open_generated_periods_were_refreshed_locked_paid": "Périodes de paie générées. Des périodes ouvertes ont été rafraîchies; des périodes verrouillées, payées et fermées ont été conservées.",
    "payroll_calendar_updated": "Calendrier des états de paie mis à jour.",
    "payroll_calendar_action_failed": "L'action du calendrier des états de paie a échoué.",
    "unable_to_load_payroll_settings": "Impossible de charger les réglages de la paie.",
    "payroll_calendars_define_how_privana_creates_payroll_periods_approval_deadlines": "Les calendriers des états de paie définissent la façon dont Privana crée des périodes de paye, des délais d'approbation, des coupures de feuille de temps et des dates de paye.",
    "cycle_anchor_date": "Date d ' ancrage",
    "first_period_anchor_preview_from": "Ancrage de première période / aperçu de",
    "period_dates": "Dates d ' expiration",
    "timesheet_cutoff": "Découpe de la feuille de temps",
    "save_calendar": "Sauvegarder le calendrier",
    "store_clublevel_policy_defaults_for_future_payroll_calculations": "Stocker des défauts de politique au niveau du club pour les calculs futurs des états de paie.",
    "holiday_pay_enabled": "Indemnité de vacances",
    "sick_pay_enabled": "Indemnisation des malades",
    "sick_pay_requires_manager_review": "Sick pay nécessite l'examen du gestionnaire",
    "save_pay_rules": "Enregistrer les règles de paye",
    "timesheet_rounding_controls_how_clockinout_times_are_normalised_before_payroll": "Le tour de la feuille de temps contrôle la façon dont les heures d'horloge sont normalisées avant l'examen des états de paie.",
    "save_timesheet_rules": "Enregistrer les règles de la feuille de temps",
    "plainenglish_club_payroll_choices_privana_keeps_technical_engine_settings_tucked": "Choix de la paye du club de plain-anglais. Privana maintient les réglages techniques du moteur supprimés à moins que le support n'en ait besoin.",
    "confirm_pension_scheme_defaults_and_staff_benefits_your_club_tracks": "Confirmer les défauts de régime de retraite et les avantages du personnel vos titres de club.",
    "set_how_your_club_handles_overtime_holiday_pay_and_sickness": "Définir comment votre club gère les heures supplémentaires, la paye de vacances et l'absence de maladie.",
    "coming_soon_privana_does_not_currently_connect_to_payroll_engines": " (À venir bientôt. Privana ne se connecte pas actuellement aux moteurs de paie pour les calculs légaux.)",
    "benefits_enabled": "Avantages activés",
    "included_in_salary": "Inclus dans les traitements",
    "timesheet_based": "Timesheet basé sur",
    "statutory_sick_pay": "Indemnité légale de maladie",
    "club_policy": "Politique du Club",
    "these_controls_determine_which_payroll_checks_privana_assist_will_surface": "Ces contrôles déterminent quels chèques de paye Privana Assist va surface pendant l'examen des états de paie.",
    "variance_alerts": "Alertes de variation",
    "missing_data_checks": "Contrôles de données manquants",
    "duplicate_payment_detection": "Détection de paiement en double",
    "payroll_readiness_summary": "Résumé de l ' état de préparation des états de paie",
    "save_privana_assist_controls": "Sauvegarder Privana Commandes d'assistance",
    "production_role_model_for_payroll_access": "Modèle de rôle de production pour l'accès aux états de paie.",
    "payroll_admin": "Administrateur de la paie",
    "manage_payroll_settings": "Gérer les paramètres de paye",
    "create_payroll_runs": "Créer des courses de paie",
    "edit_employees": "Éditer les employés",
    "payroll_approver": "Approuvant les états de paie",
    "approve_payroll_runs": "Les états de paie approvisionnés",
    "approve_payroll_liabilities": "Passif à la masse salariale",
    "view_journal_previews": "Voir les aperçus de la revue",
    "department_manager": "Gestionnaire du ministère",
    "approve_timesheets": "Approuve timesheets",
    "review_overtime": "Examen des heures supplémentaires",
    "view_department_payroll_summaries": "Voir les résumés des états de paie du ministère",
    "read_only_2": "Lire seulement",
    "view_payroll_dashboard": "Voir le tableau de bord de la paie",
    "view_payroll_reports": "Voir les rapports de paie",
    "no_editing_rights": "Pas de droits de modification",
    "needs_finance": "Besoins financiers",
    "verified": "Vérifié",
    "high": "Élevé",
    "medium": "Moyen",
    "ap_payment_recorded": "Paiement de l ' AP enregistré.",
    "12month_gross_payroll_with_monthly_variance": "Solde brut de 12 mois avec écart mensuel.",
    "a_department_with_this_name_already_exists": "Un département avec ce nom existe déjà.",
    "supplier_bill": "Fournisseur Bill",
    "part_paid": "Partie payée",
    "ready_for_payment": "Prêt pour le paiement",
    "club_context_is_missing_select_a_club_to_view_payables": "Le contexte du club est absent. Sélectionnez un club pour voir les créditeurs.",
    "unable_to_load_accounts_payable_data": "Incapable de charger des données à payer.",
    "source_navigation_unavailable_for_this_payable": "Source navigation non disponible pour ce crédit.",
    "add_at_least_one_bill_line_before_posting": "Ajouter au moins une ligne de facture avant d'afficher.",
    "unable_to_post_bill": "Incapable d'afficher la facture.",
    "unable_to_void_bill": "Incapable d'annuler la facture.",
    "allocations_unapplied": "Allocations non appliquées.",
    "unable_to_unapply_allocations": "Incapable d'allocations inapplicables.",
    "allocations_reallocated": "Allocations réaffectées.",
    "unable_to_reallocate_payment": "Incapable de réaffecter le paiement.",
    "enter_a_valid_refund_amount": "Entrez un montant de remboursement valide.",
    "refund_exceeds_available_amount": "Le remboursement dépasse le montant disponible.",
    "select_a_bank_account_for_bank_refunds": "Sélectionnez un compte bancaire pour les remboursements bancaires.",
    "refund_recorded": "Remboursement enregistré.",
    "configure_ap_control_and_payment_accounts_before_refunding": "Configurer les comptes de contrôle AP et de paiement avant le remboursement.",
    "unable_to_refund_payment": "Incapable de rembourser le paiement.",
    "total_payables": "Total des produits de paie",
    "outstanding_payables": "Soldes non acquittés",
    "due_this_month": "J'ai attendu ce mois",
    "supplier_payables": "Fournisseur Payables",
    "payroll_liabilities_2": "Passif de la masse salariale",
    "accounts_payable": "Comptes créditeurs",
    "posting": "L'affichage...",
    "enter": "Entrez.",
    "missing_information": "Renseignements manquants",
    "please_complete_all_required_fields_before_saving": "Veuillez remplir tous les champs requis avant d'enregistrer.",
    "bank_account_added": "Compte bancaire ajouté",
    "the_bank_account_is_ready_for_reconciliation": "Le compte bancaire est prêt pour la réconciliation.",
    "failed_to_add_bank_account": "N'a pas ajouté de compte bancaire",
    "please_try_again_or_contact_support": "Veuillez réessayer ou contacter le support.",
    "loading_gl_accounts": "Chargement des comptes GL...",
    "save_bank_account": "Enregistrer un compte bancaire",
    "failed_to_load_bank_accounts": "N ' a pas été chargé des comptes bancaires",
    "bank_account_updated": "Compte bancaire mis à jour",
    "failed_to_update_bank_account": "N'a pas mis à jour le compte bancaire",
    "default_account_updated": "Compte par défaut mis à jour",
    "this_bank_account_is_now_the_default": "Ce compte bancaire est maintenant le défaut.",
    "failed_to_update_default": "A échoué à mettre à jour par défaut",
    "no_gl_accounts": "Aucun compte GL",
    "update_failed": "Mise à jour échouée",
    "unable_to_update_review_status": "Incapable de mettre à jour l ' état de l ' examen.",
    "marked_reviewed": "Examiné",
    "marked_unreviewed": "Marqué non examiné",
    "unable_to_update_review_status_for_selected_transactions": "Impossible de mettre à jour l'état d'examen de certaines transactions.",
    "missing_reconciliation_scope": "La portée manquante de la réconciliation",
    "refresh_summary_to_load_statement_scope_before_finalizing": "Rafraîchissez le résumé pour charger la portée de l'énoncé avant la finalisation.",
    "reconciliation_finalized": "Réconciliation achevée",
    "this_account_period_is_now_marked_complete": "Cette période de compte est maintenant marquée complète.",
    "unable_to_finalize": "Incapable de finaliser",
    "resolve_all_unmatched_queues_before_finalizing": "Résoudre toutes les files inégalées avant de finaliser.",
    "ready_to_finalize": "Prêt à finaliser",
    "mark_unreviewed_2": "Marque non revue",
    "mark_reviewed_2": "Note révisée",
    "no_transactions_yet_upload_a_statement_to_get_started": "Aucune transaction pour le moment. Importez un relevé pour commencer.",
    "select_a_bank_account_to_view_transactions": "Sélectionnez un compte bancaire pour afficher les transactions.",
    "no_bank_accounts_yet_use_the_settings_menu_to_add": "Aucun compte bancaire pour le moment. Utilisez le menu des paramètres pour en ajouter un.",
    "autodetect": "Détecter automatiquement",
    "date_column_is_required": "La colonne de date est requise.",
    "description_column_is_required": "La colonne de description est requise.",
    "provide_either_an_amount_column_or_a_debitcredit_column": "Fournissez une colonne Amount ou une colonne Debit/Credit.",
    "statement_imported": "État importé",
    "unable_to_import_statement": "Incapable d'importer une déclaration.",
    "back": "Retour",
    "importing": "Importer...",
    "remaining": "Restants",
    "income": "Recettes",
    "income_ytd": "Recettes (YTD)",
    "expenses_ytd": "Dépenses (YTD)",
    "unable_to_load_chart_of_accounts": "Impossible de charger la carte des comptes.",
    "account_code_and_name_are_required": "Le code et le nom du compte sont requis.",
    "unable_to_save_account_changes": "Incapable d'enregistrer les changements de compte.",
    "unable_to_update_account_status": "Impossible de mettre à jour l'état du compte.",
    "edit_account": "Editer un compte",
    "unable_to_load_dimensions": "Impossible à charger les dimensions.",
    "dimension_code_and_name_are_required": "Le code de dimension et le nom sont requis.",
    "that_dimension_code_already_exists_choose_a_unique_code": "Ce code de dimension existe déjà. Choisissez un code unique.",
    "unable_to_save_dimension_changes": "Incapable de sauvegarder les changements de dimension.",
    "unable_to_update_dimension_status": "Impossible de mettre à jour l'état de la dimension.",
    "edit_dimension": "Modifier la dimension",
    "operating": "Fonctionnement",
    "capex": "CapEx",
    "this_fiscal_year": "Année financière",
    "custom_range": "Gamme personnalisée",
    "unable_to_load_reports": "Incapable de charger des rapports",
    "missing_fields": "Champs manquants",
    "please_enter_a_report_name_and_type": "Veuillez saisir un nom et un type de rapport.",
    "budget_required": "Budget nécessaire",
    "select_a_budget_to_run_budget_vs_actual": "Sélectionnez un budget pour exécuter Budget vs Actual.",
    "budget_version_required": "Version budgétaire requise",
    "select_a_budget_version_to_run_budget_vs_actual": "Sélectionnez une version budgétaire pour exécuter Budget vs Actual.",
    "unable_to_save_report": "Incapable d ' enregistrer un rapport",
    "are_you_sure_you_want_to_delete_this_report": "Êtes-vous sûr de vouloir supprimer ce rapport?",
    "unable_to_delete_report": "Incapable de supprimer le rapport",
    "gl_account_code": "Code de compte GL",
    "gl_account_name": "Nom du compte GL",
    "ytd_budget": "Budget yTD",
    "ytd_actual": "Réalisé depuis le début de l’année",
    "ytd_variance": "Écart yTD",
    "ytd_variance_2": "Écart yTD %",
    "pdf_export_not_available_yet_use_csv": "PDF export pas encore disponible. Utiliser CSV .",
    "xlsx_export_coming_soon_for_budget_vs_actual": "Exportation XLSX prochainement pour Budget vs Actual",
    "unable_to_download_report": "Incapable de télécharger le rapport",
    "unable_to_run_report": "Incapable d ' exécuter le rapport",
    "ondemand": "À la demande",
    "failed_to_load_matches": "N'a pas réussi à charger des matchs",
    "unable_to_load_matching_candidates_please_try_again": "Incapable de charger des candidats. Veuillez réessayer.",
    "no_remaining_balance": "Aucun solde restant",
    "reduce_another_match_amount_before_selecting_this_allocation": "Réduire un autre montant de match avant de sélectionner cette allocation.",
    "match_saved": "Match enregistré",
    "bank_transaction_matching_updated": "Opération bancaire assortie mise à jour.",
    "failed_to_save_match": "N'a pas réussi à enregistrer le match",
    "unable_to_update_bank_transaction_match_items": "Impossible de mettre à jour les éléments de correspondance bancaire.",
    "match_cleared": "Assortiment réglé",
    "match_items_removed_for_this_transaction": "Éléments de correspondance supprimés pour cette transaction.",
    "failed_to_clear_match": "N ' ont pas été clairs.",
    "unable_to_clear_match_items_for_this_transaction": "Incapable de préciser les éléments de correspondance pour cette transaction.",
    "bank_transaction": "Opérations bancaires",
    "unknown_period": "Période inconnue",
    "trial_balance_snapshot": "Snapshot de Trial Balance",
    "snapshot": "Instantané",
    "unknown": "Inconnu",
    "unassigned_account": "Compte non affecté",
    "unable_to_update_task": "Incapable de mettre à jour la tâche",
    "notes_saved": "Notes sauvegardées",
    "unable_to_save_notes": "Incapable d'enregistrer des notes",
    "period_closed": "Période clôturée",
    "close_blocked_by_earlier_periods": "Fermer bloqué par des périodes antérieures",
    "close_failed": "Étrangement échoué",
    "unable_to_close_the_period_please_try_again": "Incapable de fermer la période. Veuillez réessayer.",
    "period_locked": "Période verrouillée",
    "complete_required_tasks_or_add_an_override_reason": "Remplir les tâches requises ou ajouter une raison de remplacement.",
    "lock_failed": "Verrouillage échoué",
    "unable_to_lock_the_period_please_try_again": "Incapable de verrouiller la période. Veuillez réessayer.",
    "period_unlocked": "Période débloquée",
    "unlock_failed": "Le déverrouillage a échoué",
    "unable_to_unlock_the_period_please_try_again": "Incapable de déverrouiller la période. Veuillez réessayer.",
    "period_reopened": "Période rouverte",
    "reopen_failed": "Réouverture échouée",
    "unable_to_reopen_the_period_please_try_again": "Incapable de rouvrir la période. Veuillez réessayer.",
    "snapshot_queued": "Snapshot filed",
    "close_pack_snapshot_is_running": "Fermer le snapshot de pack est en cours.",
    "snapshot_failed": "Instantané a échoué",
    "optional_tasks": "Fonctions facultatives",
    "no_updates_yet": "Pas de mises à jour",
    "lock_month": "Mois de verrouillage",
    "unlock_period": "Période de déverrouillage",
    "reopen_period": "Période de réouverture",
    "run_snapshot": "Lancez-vous !",
    "balanced": "Solde",
    "out_of_balance": "Solde",
    "periods_generated": "Périodes générées",
    "unable_to_generate_periods": "Incapable de générer des périodes.",
    "unable_to_generate_periods_2": "Impossible de générer des périodes",
    "unable_to_load_snapshot": "Incapable de charger un snapshot",
    "current_period_is_locked_unlock_to_continue_closing": "La période actuelle est verrouillée. Libérez-vous pour continuer à fermer.",
    "loading_years": "Les années de chargement...",
    "generate_periods_for_selected_year": "Effectuer des périodes pour une année choisie",
    "unable_to_load_periods": "Incapables aux périodes de charge",
    "please_refresh_to_try_again": "S'il vous plaît rafraîchir pour essayer à nouveau.",
    "created": "Créé",
    "edit_invoice": "Modification de la facture",
    "failed_to_load_layout_settings": "N'a pas chargé les réglages de mise en page.",
    "billing_email_must_be_blank_or_a_valid_email_address": "Le courriel de facturation doit être vierge ou une adresse courriel valide.",
    "accent_color_must_be_a_valid_hex_color": "La couleur Accent doit être une couleur HEX valide.",
    "footer_note_must_be_1000_characters_or_fewer": "La note de bas de page doit être de 1000 caractères ou moins.",
    "layout_saved_successfully": "Layout s'est enregistré avec succès!",
    "failed_to_save_layout": "N'a pas réussi à Enregistrer la mise en page.",
    "save_layout": "Sauvegardez la mise en page",
    "received": "Reçus",
    "paid_via_direct_payment_2": "Paid via Paiement Direct",
    "included_in_billing_run": "Inclus dans Billing Run",
    "fully_applied": "Entièrement appliquée",
    "partially_applied": "Partiellement appliquée",
    "enter_allocation_amounts": "Entrez les montants d'allocation.",
    "allocations_exceed_available_credit": "Les allocations dépassent le crédit disponible.",
    "credit_allocated": "Crédit alloué.",
    "unable_to_allocate_credit": "Impossible d'attribuer du crédit.",
    "credit_refund_recorded": "Remboursement de crédit enregistré.",
    "refund_payment_recorded": "Remboursement enregistré.",
    "configure_ar_control_and_payment_accounts_before_refunding": "Configurer les comptes de contrôle et de paiement AR avant le remboursement.",
    "credit_refund_not_allowed": "Remboursement de crédit non autorisé.",
    "refund_not_allowed": "Remboursement non autorisé.",
    "cannot_refund_a_refund_payment": "Ne peut pas rembourser un remboursement.",
    "unable_to_record_refund": "Impossible d'enregistrer le remboursement.",
    "source_navigation_unavailable": "Source navigation non disponible",
    "enter_a_valid_credit_amount": "Entrez un montant de crédit valide.",
    "credit_applied": "Crédit appliqué.",
    "unable_to_apply_credit": "Incapable d'appliquer le crédit.",
    "credit_note": "Note de crédit",
    "on_account": "Compte",
    "allocated_payment": "Paiements alloués",
    "linked_pos_sale": "Vente liée de SPFO",
    "see_pos_transaction_detail": "Voir détail des transactions POS",
    "unapplying": "Inapplicable...",
    "unapply": "Sans objet",
    "open_originating_source": "Ouvrir la source d'origine",
    "source_resolution_unavailable": "Résolution de la source non disponible",
    "view_statement": "État des résultats",
    "reallocate_payment": "Réaliser le paiement",
    "refund_credit_2": "Crédits remboursés",
    "submit_refund_payment": "Remboursement",
    "no_available_credit_to_apply": "Aucun crédit disponible pour présenter une demande",
    "no_open_invoices_to_apply_credit_to": "Pas de factures ouvertes pour appliquer le crédit",
    "apply_available_member_credit": "Appliquer le crédit de membre disponible",
    "unable_to_load_current_period": "Incapable de charger la période courante",
    "unable_to_load_close_checklist": "Impossible de charger la liste de contrôle à proximité",
    "unable_to_close_period": "Incapable de fermer la période.",
    "unable_to_close_period_2": "Incapable d ' une période rapprochée",
    "unable_to_lock_period": "Incapable de verrouillage.",
    "unable_to_lock_period_2": "Incapable de verrouiller la période",
    "unable_to_unlock_period": "Incapable de déverrouiller la période",
    "unable_to_reopen_period": "Incapable de rouvrir la période",
    "select_period": "Période de sélection",
    "complete_required_tasks_or_provide_an_override_reason": "Remplir les tâches requises ou fournir une raison de remplacement.",
    "required_tasks_must_be_completed_override_not_permitted": "Les tâches requises doivent être accomplies (l'override n'est pas permis).",
    "close_period": "Période de clôture",
    "lock_period": "Période de verrouillage",
    "adjusting": "Ajustement",
    "reversal": "Réversal",
    "year_end": "Année",
    "accrual": "Accrualités",
    "member_accounts_receivable": "Comptes Membres débiteurs",
    "billing_recurring_billing": "Facturation / facturation récurrente",
    "staff_selected": "Personnel sélectionné",
    "you_dont_have_permission_to_perform_this_action": "Vous n'avez pas la permission d'exécuter cette action.",
    "endpoint_not_deployed_route_missing": "Endpoint non déployé / route manquante.",
    "server_error_check_logs": "Erreur de serveur — vérifiez les registres.",
    "failed_to_load_monthend_tasks": "Ne pas charger des tâches de fin de mois",
    "unable_to_load_tasks": "Impossible de charger des tâches",
    "failed_to_load_monthend_exceptions": "Ne pas charger des exceptions de fin de mois",
    "unable_to_load_exceptions": "Incapable de charger des exceptions",
    "delete_this_task_template": "Supprimer ce modèle de tâche?",
    "delete_this_exception_policy": "Supprimer cette politique d'exception?",
    "task_name_is_required": "Le nom de la tâche est requis",
    "task_templates_saved": "Modèles de tâches sauvegardés",
    "failed_to_save_task_templates": "N'a pas réussi à enregistrer des modèles de tâches",
    "unable_to_save_task_templates": "Impossible d'enregistrer des modèles de tâches",
    "reason_is_required_for_exceptions": "La raison est requise pour les exceptions",
    "exception_policies_saved": "Politiques d'exception enregistrées",
    "failed_to_save_exception_policies": "L'absence de politiques d'exception",
    "unable_to_save_exception_policies": "Incapable d'enregistrer des politiques d'exception",
    "walkin": "Marche-in",
    "unposted": "Non comptabilisé",
    "review_post": "Review \" Post",
    "voided": "Annulés",
    "fix_repost": "Fix \" Repost",
    "view_issue": "Point de vue",
    "this_receivable_is_sourcemanaged_and_must_be_corrected_from_its": "Cette créance est gérée par la source et doit être corrigée de son flux de travail ou de son processus d'affichage.",
    "guest": "Invité",
    "adhoc": "Ad-hoc",
    "unable_to_resolve_this_golf_booking_source": "Impossible de résoudre cette source de réservation de golf.",
    "unable_to_resolve_this_racquet_booking_source": "Impossible de résoudre cette source de réservation Racquet.",
    "unable_to_resolve_this_spa_booking_source": "Incapable de résoudre cette source de réservation de Spa.",
    "unable_to_resolve_this_fitness_booking_source": "Impossible de résoudre cette source de réservation de fitness.",
    "unable_to_resolve_this_event_source": "Impossible de résoudre cette source d'événement.",
    "unable_to_resolve_this_room_reservation_source": "Incapable de résoudre cette source de réservation de chambre.",
    "source_navigation_is_not_available_for_this_charge_yet": "La navigation de source n'est pas encore disponible pour cette charge.",
    "this_receivable_is_sourcemanaged_and_cannot_be_manually_posted_here": "Cette créance est gérée par la source et ne peut pas être affichée manuellement ici.",
    "unable_to_post_receivable": "Incapable d'afficher une créance.",
    "unable_to_create_credit_note": "Incapable de créer une note de crédit.",
    "debtor_type": "Type de débiteur",
    "billing_run_2": "Facturation / Cycle",
    "open_invoice_detail": "Ouvrir le détail de la facture",
    "invoice_not_yet_generated": "Facture non encore générée",
    "void_allocation": "Affectation des voix",
    "choose_open_member_invoice": "Choisissez une facture de membre ouverte...",
    "save_draft_post_credit_note": "Enregistrer le projet / post note de crédit",
    "unable_to_enroll_member": "Incapable d'enrôler le membre",
    "golf_green_fees": "Frais de golf vert",
    "golf_addons_caddie_hire": "Golf add-ons / caddie location",
    "unmapped_charge": "Frais non plafonnés",
    "member_account": "Compte Membre",
    "will_be_generated_during_next_billing_run": "Il sera généré au cours de la prochaine course de facturation",
    "deferred_from_earlier_billing": "Reporté à la facturation antérieure",
    "move_back_to_this_statement": "Retour à cette déclaration",
    "next_billing_run": "Prochaine course de facturation",
    "future_billing_run": "Fuite future de facturation",
    "no_billable_items_are_currently_available_for_invoicing": "Aucun article facturable n'est actuellement disponible pour facturation.",
    "unable_to_preview_invoice": "Impossible de prévisualiser la facture",
    "download_failed": "Télécharger échoué",
    "unable_to_generate_and_download_invoice": "Incapable de générer et télécharger la facture",
    "unable_to_generate_and_send_invoice": "Incapable de générer et d'envoyer une facture",
    "invoice_generated_successfully_but_the_email_could_not_be_delivered": "Invoice générée avec succès, mais l'e-mail n'a pas pu être livré.",
    "the_invoice_is_available_in_invoicing": "La facture est disponible en facturation.",
    "invoice_generated_and_emailed_successfully": "Facture générée et envoyée par courriel avec succès.",
    "unable_to_generate_club_run": "Incapable de générer une course de club",
    "choose_a_valid_current_or_future_billing_run": "Choisissez un courant valide ou une future course de facturation.",
    "billing_run_updated": "Billing est mis à jour.",
    "unable_to_update_billing_run": "Incapable de mettre à jour le courant de facturation",
    "unable_to_update_charge": "Impossible de mettre à jour la charge",
    "unable_to_load_dues_enrollments": "Incapable de charger les frais d ' inscription",
    "billing_run_generated": "Billing run générée.",
    "unable_to_generate_recurring_billing_run": "Incapable de générer une course de facturation récurrente",
    "unable_to_run_bulk_action": "Incapable d'exécuter une action en vrac",
    "recurring_billing_cannot_be_activated_until_a_dues_amount_greater_2": "La facturation récurrente ne peut être activée tant qu'un montant de cotisations supérieur à zéro n'est pas entré.",
    "choose_a_monthly_quarterly_or_annual_frequency_before_enrolling_this": "Choisissez une fréquence mensuelle, trimestrielle ou annuelle avant d'inscrire ce membre.",
    "unable_to_generate_invoice": "Incapable de générer une facture",
    "unable_to_load_statement_preview_please_try_again": "Incapable de charger la prévisualisation de la déclaration. Veuillez réessayer.",
    "unable_to_record_payments": "Incapable d ' enregistrer les paiements",
    "unable_to_save_settings_2": "Incapable de sauvegarder les paramètres",
    "current_period_2": "Période en cours",
    "sending_2": "Envoi…",
    "generate_send": "Générer & Envoyer",
    "generate_club_run": "Générer le club run",
    "current_run": "Courant courant",
    "resolve_gl_mapping_warnings_before_generating_this_run": "Résoudre les avertissements de cartographie GL avant de générer cette course.",
    "membership_dues": "Frais d ' admission",
    "draft_invoice": "Projet de facture",
    "line_item": "Point de ligne",
    "confirm_generate": "Confirmer Génération",
    "generate_download": "Generate & Télécharger",
    "primary_charge": "Charge primaire",
    "save_billing_run": "Enregistrer Billing Run",
    "chart_of_accounts_verified": "Graphique des comptes vérifiés",
    "tax_codes_verified": "Codes fiscaux vérifiés",
    "dimensions_verified": "Dimensions vérifiées",
    "revenue_mappings_verified": "Cartographies des recettes vérifiées",
    "payroll_mappings_verified": "Cartographies des états de paie vérifiées",
    "label_is_required": "L'étiquette est requise.",
    "label_must_include_letters_or_numbers": "L'étiquette doit inclure des lettres ou des numéros.",
    "that_label_creates_a_duplicate_key_try_a_slightly_different": "Cette étiquette crée une clé en double. Essayez une étiquette légèrement différente.",
    "unable_to_save_the_revenue_mapping": "Incapable d'enregistrer la cartographie des revenus.",
    "unable_to_save_the_payroll_mapping": "Incapable d'enregistrer la cartographie des états de paie.",
    "unable_to_apply_regional_accounting_defaults": "Incapable d'appliquer des défauts comptables régionaux.",
    "accounting_defaults_refreshed": "Défauts comptables actualisés.",
    "payroll_defaults_refreshed": "Par défaut de paye rafraîchie.",
    "historical": "Historique",
    "final_checks_are_taking_a_moment": "Les vérifications finales prennent un moment...",
    "finalising_accounting_defaults_and_mappings": "Finaliser les défauts comptables et les mappages...",
    "edit_gl_mapping": "Modifier GL Mapping",
    "new_gl_mapping": "Nouvelle cartographie GL",
    "unable_to_load_yearend_assistant": "Incapable de charger l ' assistant d ' exercices",
    "unable_to_load_fiscal_years_right_now_please_refresh_and": "Impossible de charger les exercices en ce moment. S'il vous plaît rafraîchir et essayez à nouveau.",
    "yearend_is_blocked": "La fin de l'année est bloquée",
    "resolve_all_blocker_checks_before_closing_this_fiscal_year": "Résoudre tous les chèques de blocage avant la clôture de l'exercice.",
    "unable_to_close_fiscal_year": "Incapable de clôturer l'exercice",
    "please_review_blockers_and_try_again": "Veuillez revoir les bloqueurs et essayez à nouveau.",
    "billing_period": "Période de facturation",
    "not_billable": "Pas facturé",
    "recurring": "Récurrents",
    "recurring_billing_run": "Cour de facturation récurrente",
    "direct_payment": "Paiement direct",
    "not_billable_voidedcancelled": "Non facturée : annulée/annulée",
    "need_to_collect": "Nécessité de recueillir",
    "blocked_missing_revenue_mapping": "Bloqué : cartographie des revenus manquante",
    "manual_invoice": "Facture manuelle",
    "recurring_run": "Course récurrente",
    "payroll_method_2": "Méthode de la paie:",
    "impact": "Incidence :",
    "period_2": "Période :",
    "timesheet_cutoff_2": "Découpe de feuille de temps:",
    "approval_deadline_2": "Date limite d ' approbation :",
    "pay_date_2": "Date de paye :",
    "employee_2": "Employé :",
    "method_2": "Méthode:",
    "receivable": "Recevable:",
    "payment_2": "Paiement :",
    "allocations": "Allocations :",
    "gl_journal": "Journal comptable :",
    "pos_sale_2": "Vente de POS :",
    "taxvat": "Tax/ VAT :",
    "inventory_movement": "Mouvement des stocks :",
    "credit_note_2": "Note de crédit #:",
    "amount_2": "Montant :",
    "invoice_3": "Facture:",
    "posted_2": "Posté:",
    "posted_at": "Posté à:",
    "created_by": "Créé par :",
    "source_ref": "Réf. source :",
    "gl_mapping_2": "Mappage gl :",
    "payment_source": "Source de paiement :",
    "payment_reference": "Référence de paiement :",
    "issued_due": "Délivré / attendu:",
    "revenue_gl_account": "Revenu Compte GL :",
    "receivables_control": "Contrôle des résultats:",
    "cashbankcard_clearing": "Liquidation de trésorerie/banc/bardage de carte:",
    "tax_code_3": "Code fiscal :",
    "tax_rate_2": "Taux d'imposition:",
    "vattax_amount": "VAT /Tax Montant:",
    "vat_payable_gl": "Compte de TVA à payer :",
    "dimension_2": "Dimension:",
    "allocation_status": "État de l ' allocation :",
    "created_posted": "Créé / Publié:",
    "gl_journalbatch": "Journal/lot comptable :",
    "pos_payment": "POS Paiement:",
    "voidrefundreversal": "Null/remboursement/reversal:",
    "skipped_items": "Produits saturés:",
    "warnings": "Avertissement :",
    "panel": "Panneau",
    "balance_due_value0": "Solde dû : {value0}",
    "value0_avatar": "avatar de {value0}",
    "value0_employees_value1": "{value0} employés • {value1} %",
    "move_this_payroll_run_back_to_value0": "Déplacez cette paie de retour à {value0}",
    "step_value0": "Étape {value0}",
    "value0_stage_value1_pay_date_value2": "{value0} étape • {value1} • Date de paye: {value2}",
    "affected_value0": "Affecté : {value0}",
    "recommended_fix_value0": "Correction recommandée : {value0}",
    "move_value0_department": "Déplacer {value0}.",
    "warning_value0_active_current_rates_overlap_payroll_runs_use_the": "Avertissement : {value0} se chevauchent les taux de courants actifs. Les états de paie utilisent le taux effectif le plus récent; épargner un nouveau taux actif fermera les chevauchements plus anciens.",
    "user_value0": "Utilisateur: {value0}",
    "record_payroll_wage_expense_for_value0": "Dépenses salariales enregistrées pour {value0}",
    "create_payroll_clearing_liability_for_net_staff_payments_of_value0": "Créer une responsabilité de compensation des états de paie pour les paiements nets de personnel {value0}",
    "paye_income_tax_value0": "Impôt sur le revenu du PAYE : {value0}",
    "employee_national_insurance_value0": "Assurance nationale des employés: {value0}",
    "employer_national_insurance_value0": "Assurance nationale de l'employeur : {value0}",
    "hmrc_total_value0": "Total de hMRC: {value0}",
    "privana_assist_value0": "Privana Aide: {value0}",
    "value0_adjustment_rows_available": "{value0} lignes de réglage disponibles.",
    "value0_pay_date_value1": "{value0} • Date de paye: {value1}",
    "value0_of_value1_employees_complete": "{value0} de {value1} employés terminés",
    "value0_pay_value1": "{value0} • Payer {value1}",
    "journal_count_value0": "Compte du Journal: {value0}",
    "primary_journal_value0": "Revue primaire: {value0}",
    "duplicates_value0": "Duplicata: {value0}",
    "value0_new_eligible_employee_is_not_included_yet_recalculate_payroll": "{value0} nouvel employé admissible n'est pas encore inclus. Recalculer la masse salariale pour les inclure.",
    "fix_action_value0": "Action fixe: {value0}",
    "owner_value0_due_value1": "Propriétaire: {value0} • Dû: {value1}",
    "due_value0_source_value1": "Dû: {value0} • Source: {value1}",
    "value0_detected_automatically_from_your_club_address": "{value0} détecté automatiquement depuis l'adresse de votre club.",
    "last_refreshed_value0": "Dernière mise à jour: {value0}",
    "value0_enabled": "{value0} activé",
    "minimum_earnings_threshold_value0": "Obtention minimale ( {value0} )",
    "remaining_capacity_value0": "Capacité restante: {value0}",
    "amount_must_be_between_0_and_value0": "Le montant doit être compris entre 0 et {value0} .",
    "finalized_value0_by_value1": "Finalisé {value0} par {value1} .",
    "value0_selected": "Sélectionnés : {value0}",
    "select_transaction_value0": "Sélectionnez la transaction {value0}",
    "ref_value0": "Réf: {value0}",
    "detected_format_value0": "Format détecté: {value0}",
    "value0_more": " (+ {value0} plus)",
    "previewing_value0_of_value1_rows": "Prévisualisation {value0} de {value1} rangs.",
    "step_value0_of_4": "Étape {value0} de 4",
    "actual_value0": "Effectif : {value0}",
    "budget_value0": "Budget : {value0}",
    "difference_value0": "Différence : {value0}",
    "version_vvalue0": "Version v {value0}",
    "value0_value1_to_value2": "{value0} · {value1} à {value2}",
    "value0_rows": "{value0} rangs",
    "as_of_value0": "Au {value0}",
    "confidence_value0": "Confiance {value0} %",
    "status_value0": "Statut: {value0}",
    "remaining_to_match_value0": "Reste à correspondre: {value0}",
    "required_tasks_value0value1_complete": "Les tâches requises {value0} / {value1} complètent.",
    "optional_value0value1": "Facultatif {value0} / {value1}",
    "updated_value0_by_value1": "Mis à jour {value0} par {value1}",
    "staff_value0": "Personnel {value0}",
    "reason_value0": "Raison: {value0}",
    "by_value0": "Par {value0}",
    "close_value0_first": "Fermez {value0} en premier.",
    "manage_value0": "Gérer {value0}",
    "generated_value0_value1": "Générée {value0} {value1}",
    "fyvalue0": "FY {value0}",
    "fiscal_month_value0": "Mois financier {value0}",
    "value0value1_required": "{value0} / {value1} requis",
    "value0value1_optional": "{value0} / {value1} optionnel",
    "sort_by_value0": "Trier par {value0}",
    "invoice_value0": "Invoice # {value0}",
    "value0_logo": "logo {value0}",
    "tax_amount_value0_at_value1": "Tax amount {value0} at {value1} .",
    "missing_output_vat_gl_account_used_by_value0_invoice_value1": "Produit manquant VAT GL Compte — utilisé par la facture {value0} {value1} .",
    "lines_value0": "Lignes: {value0}",
    "direct_payment_via_member_portalvalue0": "Paiement direct via le portail membre {value0}",
    "account_details_value0": "Détails du compte: {value0}",
    "unapplied_credit_available_value0": "Crédit non appliqué disponible: {value0}",
    "unapply_credit_value0_value1": "Crédit inapplicable {value0} ( {value1} )",
    "max_refundable_value0": "Remboursable maximum: {value0}",
    "account_value0": "Compte: {value0}",
    "applied_value0": "Appliquée: {value0}",
    "value0_date_value1_due_value2": "# {value0} · Date {value1} · Due {value2}",
    "showing_value0value1_of_value2": "Affichage {value0} – {value1} de {value2}",
    "value0_value1_payment_value2": "{value0} · {value1} · paiement {value2}",
    "value0_value1_vat_value2_gross_value3": "{value0} · {value1} · VAT {value2} · Brut {value3}",
    "value0_value1_dr_value2_cr_value3": "{value0} · {value1} · Dr {value2} · Cr {value3}",
    "generate_issued_invoices_for_value0_selected_members_with_active_recurring": "Générer des factures émises pour {value0} membres sélectionnés avec des modèles récurrents actifs? Cela ne s'affichera pas au GL.",
    "will_bill_value0_mapped_items": "Billet: {value0} article(s) cartographié(s).",
    "will_skip_value0_unmapped_items": "Will skip: {value0} article(s) non cartographié(s).",
    "key_value0": "(clé: {value0} )",
    "club_run_complete_value0_generated_value1_failed": "Club run complete: {value0} générée, {value1} échoué.",
    "of_value0_members": "de {value0} membres",
    "period_value0_outstanding_value1": "Période : {value0} · Extérieur : {value1}",
    "value0_lines": "{value0} lignes",
    "value0_value1_lines": "{value0} · {value1} lignes",
    "statement_preview_value0": "Aperçu de la déclaration: {value0}",
    "projected_for_value0": "Projeté pour {value0}",
    "outstanding_value0": "En attente {value0}",
    "value0_scheduled": "Planifiés : {value0}",
    "billing_period_value0value1": "Période de facturation: {value0} {value1}",
    "total_billed_value0": "Total facturé : {value0}",
    "paid_value0": "Payé: {value0}",
    "outstanding_value0_2": "En attente: {value0}",
    "invoices_value0": "Factures: {value0}",
    "this_will_create_payments_for_open_invoices_totalling_value0": "Cela créera des paiements pour les factures ouvertes totalisant {value0} .",
    "sale_value0": "Vente {value0}",
    "membership_type_value0": "Type d'adhésion: {value0} . ",
    "key_value0_2": "Clé: {value0}",
    "count_value0": "Compte: {value0}",
    "blockers_value0": "Bloqueurs: {value0}",
    "warnings_value0": "Avertissements: {value0}",
    "passed_value0": "Passé : {value0}",
    "confidence_value0_2": "Confiance: {value0}",
    "value0_passed_checks": "{value0} chèques passés",
    "value0_skipped_checks": "{value0} chèques sautés",
    "close_fyvalue0": "Fermer FY {value0} ?",
    "receivables": "Récevables",
    "all_fiscal_periods_are_locked": "Tous les exercices sont immobilisés",
    "all_accounting_periods_in_the_fiscal_year_must_be_locked": "Toutes les périodes comptables de l'exercice financier doivent être fermées avant la fin de l'exercice.",
    "period_control": "Période de contrôle",
    "no_draft_invoices": "Aucun projet de facture",
    "draft_or_unposted_invoices_in_the_fiscal_year_must_be": "Les factures présentées ou non au cours de l'exercice doivent être affichées ou annulées.",
    "transaction_completeness": "Complètement des transactions",
    "no_draft_ap_bills": "Aucun facture sur l ' AP",
    "draft_ap_bills_in_the_fiscal_year_must_be_posted": "Les factures sur l'AP au cours de l'exercice doivent être affichés ou annulés.",
    "no_draft_journals": "Aucun projet de revues",
    "journal_entries_in_draftunposted_status_must_be_posted_before_yearend": "Les inscriptions dans le projet de statut/non posté doivent être affichées avant la fin de l ' année.",
    "journals_are_balanced": "Les journaux sont équilibrés",
    "total_debits_and_credits_must_match_for_each_journal_entry": "Les débits et crédits totaux doivent correspondre à chaque entrée de journal au cours de l'exercice.",
    "control_accounts_configured": "Comptes de contrôle configurés",
    "required_controldefault_accounts_in_accounting_settings_must_be_configured": "Les comptes de contrôle/défaut requis dans les paramètres comptables doivent être configurés.",
    "configuration": "Configuration",
    "applicable_revenue_mappings_configured": "Cartographies de recettes appropriées configurées",
    "applicable_active_revenue_mappings_must_have_required_gl_accounts": "Les cartes de revenus actives appropriées doivent avoir besoin de comptes GL.",
    "bank_reconciliations_complete": "Réconciliations bancaires terminées",
    "active_bank_accounts_should_be_reconciled_through_fiscal_year_end": "Les comptes bancaires actifs devraient être réconciliés à la fin de l'exercice.",
    "banking_cash": "Banques \" Encaisse",
    "receivables_reviewed": "Récevables examinés",
    "open_receivables_overdue_as_of_fiscal_year_end_should_be": "Les créances ouvertes en retard à la fin de l'exercice devraient être examinées.",
    "review_items": "Points d ' examen",
    "ap_aging_reviewed": "Examen du vieillissement des AP",
    "overdue_ap_bills_as_of_fiscal_year_end_should_be": "Les factures sur l'AP en retard à la fin de l'exercice devraient être examinés.",
    "unapplied_payments_reviewed": "Paiements non appliqués examinés",
    "member_payments_with_unapplied_amounts_should_be_reviewed": "Les paiements des membres avec des montants non appliqués devraient être examinés.",
    "clearing_accounts_reviewed": "Révision des comptes",
    "clearing_account_balances_should_be_zeroed_at_fiscal_year_end": "Les soldes des comptes de compensation devraient être éliminés à la fin de l'exercice.",
    "club_operations": "Opérations au Club",
    "not_applicable_for_this_clubmodule_configuration": "Sans objet pour cette configuration club/module.",
    "all_fiscal_year_periods_must_be_locked": "Tous les exercices financiers doivent être verrouillés.",
    "review_periods": "Périodes d ' examen",
    "all_fiscal_year_periods_are_locked": "Toutes les périodes de l'exercice sont fermées.",
    "no_draft_or_unposted_invoices_remain": "Il n ' y a pas de factures imprévues ou non.",
    "no_draft_or_unposted_ap_bills_remain": "Il n ' y a pas de facture ou de factures sur l ' AP non soumis.",
    "review_ap": "Examen de l ' AP",
    "no_draft_or_unposted_journals_remain": "Il n ' y a pas encore de revues rédigées ou non.",
    "review_gl": "Examen GL",
    "journals_tables_are_unavailable_in_this_environment": "Les tableaux des revues ne sont pas disponibles dans cet environnement.",
    "value0_journal_entries_are_unbalanced": "{value0} entrées de journal sont déséquilibrées.",
    "all_journals_are_balanced": "Tous les journaux sont équilibrés.",
    "accounting_settings_table_unavailable": "Tableau des paramètres de comptabilité non disponible.",
    "missing_control_account_mappings_value0": "Cartographies de compte de contrôle manquantes: {value0} .",
    "accounting_settings_2": "Paramètres comptables",
    "required_control_accounts_are_configured": "Les comptes de contrôle requis sont configurés.",
    "value0_applicable_revenue_mappings_are_missing_gl_accounts": "{value0} cartes de revenus applicables sont des comptes GL manquants.",
    "revenue_mappings_2": "Cartographies des recettes",
    "applicable_revenue_mappings_are_configured": "Les cartes de revenus applicables sont configurées.",
    "bank_reconciliation_readiness_source_is_not_implemented_yet": "La source de préparation à la réconciliation bancaire n ' est pas encore mise en œuvre.",
    "invoices_table_unavailable": "Table des factures non disponible.",
    "value0_receivables_are_overdue_as_of_fiscal_year_end": "{value0} débiteurs sont en retard à la fin de l'exercice.",
    "no_overdue_receivables_as_of_fiscal_year_end": "Aucune créance excessive à la fin de l'exercice.",
    "ap_bills_table_unavailable": "Table de factures AP non disponible.",
    "value0_ap_bills_are_overdue_as_of_fiscal_year_end": "{value0} Les factures sur l'AP sont en retard à la fin de l'exercice.",
    "no_overdue_ap_bills_as_of_fiscal_year_end": "Aucun facture sur l'AP en retard à la fin de l'exercice.",
    "payments_table_unavailable": "Tableau des paiements indisponible.",
    "value0_unapplied_member_payments_remain": "{value0} les paiements des membres non appliqués demeurent.",
    "no_unapplied_member_payments_remain": "Il n'y a pas de paiements non appliqués pour les membres.",
    "clearing_account_balance_helper_is_not_available": "Il n ' est pas disponible d ' aide à la balance des comptes.",
    "value0_readiness_source_is_not_implemented_yet": "{value0} source de préparation n'est pas encore mise en œuvre.",
    "value0_source_table_is_unavailable": "{value0} table source n'est pas disponible.",
    "value0_value1_records_need_posting_or_settlement_review": "{value0} {value1} les dossiers ont besoin d'être postés ou d'un examen de règlement.",
    "open_module": "Module ouvert",
    "value0_revenue_appears_settled_for_the_fiscal_year": "{value0} recettes semblent être réglées pour l'exercice.",
    "value0_table_unavailable": "{value0} table non disponible.",
    "value0_records_are_still_draft_or_unposted": "{value0} documents sont toujours rédigés ou non postés.",
    "check_skipped_because_supporting_tables_are_unavailable_in_this_environment": "Vérifier skipped parce que les tables de soutien ne sont pas disponibles dans cet environnement.",
    "paid_value0_bills_updated_value1": "Paid {value0} · factures mis à jour: {value1}",
    "allocated_value0_unapplied_value1": "Allocated {value0} · Non appliquée {value1}",
    "value0_must_be_a_positive_number": "{value0} doit être un nombre positif.",
    "value0_transactionvalue1_updated": "Opérations à jour: {value0} .",
    "imported_value0_rows_skipped_value1_duplicates": "Importé {value0} rangs. Skipped {value1} duplicata.",
    "value0_has_been_closed": "{value0} a été fermé.",
    "value0_has_been_locked": "{value0} a été verrouillé.",
    "maximum_refundable_amount_is_value0": "Le montant maximal remboursable est de {value0} .",
    "unable_to_resolve_this_value0_booking_source": "Impossible de résoudre cette source de réservation {value0}.",
    "fiscal_year_value0_closed": "Exercice budgétaire {value0} clos",
    "employment_details_could_not_be_saved": "Les détails sur l'emploi n'ont pas pu être sauvegardés.",
    "pay_and_rate_details_could_not_be_saved": "Les détails de la paye et des tarifs ne peuvent pas être enregistrés.",
    "payment_details_could_not_be_saved": "Les détails de paiement ne peuvent pas être sauvegardés.",
    "tax_ni_readiness_could_not_be_saved": "Taxe / NI la préparation ne peut pas être enregistrée.",
    "pension_details_could_not_be_saved": "Les détails de la pension ne peuvent pas être sauvegardés.",
    "action_failed": "L'action a échoué.",
    "confirmed": "confirmé",
    "loading_2": "chargement",
    "images_must_be_5_mb_or_less": "Les images doivent être de 5 Mo ou moins.",
    "tennis": "Tennis",
    "padel": "Padel",
    "pickleball": "Pickle-ball",
    "squash": "Squash",
    "closed_2": "fermé",
    "club_member": "Membre du Club",
    "staff_member_3": "Fonctionnaire",
    "created_2": "créé",
    "units": "Unités",
    "posted_3": "comptabilisé",
    "void_2": "Non classé",
    "error": "erreur",
    "queued": "filed",
    "matched_2": "assortis",
    "approved": "approuvés",
    "complete": "complet",
    "processing_2": "traitement",
    "ready_2": "prêt",
    "too_large": "trop grand.",
    "uncategorized": "Non classé",
    "primary_contact_2": "Contacts primaires",
    "contract": "Contrat",
    "s": "s",
    "original_2": "original",
    "reset": "réinitialiser",
    "unknown_time": "temps inconnu",
    "voicemail": "Vocalmail",
    "polo": "Polo",
    "facilities_2": "installations",
    "weddings": "Mariages",
    "off": "Dégagez.",
    "apply_uk_tax_defaults": "Appliquer les défauts d'impôt britanniques",
    "unknown_2": "inconnu",
    "edit_2": "modifier",
    "view_2": "vue",
    "extension": "Extension",
    "unable_to_save_business_hours": "Incapable d'économiser des heures d'ouverture",
    "unable_to_load_hold_audio": "Impossible de charger l'audio",
    "recording_policy": "Politique d'enregistrement",
    "ivr": "IVR",
    "ring_all": "Rends-toi.",
    "untitled_ivr": "SVI sans titre",
    "untitled_queue": "File d’attente sans titre",
    "queue": "File",
    "value_2": "valeur",
    "answered": "répondu",
    "name_is_required": "Le nom est requis",
    "booked": "réservé",
    "removed": "enlevés",
    "unchanged": "inchangé",
    "unable_to_resolve_attendee_pricing": "Incapable de régler le prix des participants.",
    "guest_name_is_required_2": "Le nom de l'invité est requis.",
    "guest_email_is_required": "Un courriel d'invité est requis.",
    "guest_phone_is_required": "Le téléphone d'invité est requis.",
    "for": "Pour",
    "weddings_2": "mariages",
    "expires": "Expire le",
    "guest_4": "invité",
    "rooms": "chambres",
    "hotel_rooms": "Hôtel / Chambres",
    "front_desk_checkin_kiosk": "Kiosque d'arrivée de Front Desk",
    "selected_room": "chambre sélectionnée",
    "gross_payroll_amount": "Montant brut de la masse salariale : {amount}",
    "variance_vs_previous_month_amount": "Variance vs le mois précédent: {amount}",
    "department_name": "Département : {name}",
    "employee_count_count": "Compte d'employés : {count}",
    "percentage_of_payroll_percent": "Pourcentage de la masse salariale: {percent} %",
    "imported_draft_timesheets_count": "Feuilles de temps importées : {count} .",
    "payslips_portal_publish_complete_published_published_existing_already_published_skipped": "Le portail Payslips publie complet: {published} publié, {existing} déjà publié, {skipped} ignoré parce qu'aucun individu PDF n'est disponible.",
    "move_this_payroll_run_back_to_stage_finance_previews_may": "Déplacer cette liste de paie remonter à {stage} ? Les prévisualisations financières peuvent être effacées.",
    "payroll_defaults_refreshed_jurisdiction_jurisdiction_created_created_updated_updated_preserved": "Payroll defaults refreshed. Compétence: {jurisdiction} . Création: {created} ; mise à jour: {updated} ; conservé: {preserved} ; réinitialisation: {reset} . Les personnalisations sont conservées à moins que la règle sélectionnée ne soit réinitialisée.",
    "x_days_after_period_end": "X jours après la fin de la période",
    "resolve_open_blockers_before_posting_to_accounting": "Résoudre les bloqueurs ouverts avant d'afficher la comptabilité.",
    "vat_gl_mappings_verified": "VAT GL mappings vérifiés",
    "preview_only_2": "aperçu seulement",
    "current_period_3": "Exercice courant"
  },
  "paymentMethods": {
    "cash": "Encaisse",
    "card": "Carte",
    "bank_transfer": "Virement bancaire",
    "check": "Chérie",
    "ach": "ACH",
    "wire": "Transfert de Wire",
    "other": "Autre",
    "apple_pay": "Paye des pommes",
    "google_pay": "Google Pay"
  },
  "errors": {
    "invalid_amount": "Entrez un montant supérieur à zéro.",
    "invalid_payment_amount": "Entrez un montant de paiement valide supérieur à zéro.",
    "invalid_payment_method": "Sélectionnez un mode de paiement pris en charge.",
    "invalid_payload": "Vérifiez le club sélectionné et la comptabilité, puis essayez à nouveau.",
    "forbidden": "Vous n'avez pas la permission d'effectuer cette action comptable.",
    "club_not_found": "Le club sélectionné n'a pas été trouvé. Sélectionnez à nouveau le club.",
    "receivable_not_found": "Cette créance n'est pas disponible. Rafraîchissez l'historique du compte avant la rentrée.",
    "usage_charge_not_invoiced": "Cette charge n'a pas encore été facturée. Elle sera payable une fois que le courant de facturation générera une facture.",
    "allocation_exceeds_balance": "L ' allocation dépasse le solde en souffrance. Rafraîchissez l'équilibre et réduisez l'affectation.",
    "allocation_exceeds_payment": "Les allocations dépassent le montant du paiement. Réduire les allocations avant de continuer.",
    "allocation_exceeds_credit": "Les allocations dépassent le crédit disponible. Rafraîchissez le solde créditeur et réduisez les allocations.",
    "allocation_exceeds_outstanding": "L'allocation dépasse le montant en souffrance. Rafraîchissez le solde et réduisez l'allocation.",
    "request": "Demande: {id}",
    "invalid_club_code": "Vérifiez le club sélectionné et la comptabilité, puis essayez à nouveau.",
    "bank_transactions_import_failed": "La déclaration n'a pas pu être importée. Examiner la cartographie du fichier et de la colonne avant la rentrée.",
    "bank_import_preset_fetch_failed": "Le préréglage de l'importation bancaire n'est pas disponible. Réinitialiser ou revoir la cartographie de la colonne manuellement.",
    "bank_import_preset_save_failed": "Le préréglage de l'importation bancaire n'est pas disponible. Réinitialiser ou revoir la cartographie de la colonne manuellement.",
    "supplier_not_found": "Sélectionnez un fournisseur disponible avant de continuer.",
    "invalid_supplier": "Sélectionnez un fournisseur disponible avant de continuer.",
    "accounting_ap_payments_fetch_failed": "Les paiements des fournisseurs ne pouvaient pas être chargés. Rafraîchissez la liste de paiement.",
    "accounting_supplier_statement_failed": "L'énoncé du fournisseur n'a pas pu être généré. Révisez les dates et la rentrée sélectionnées.",
    "accounting_ap_bills_fetch_failed": "Les factures des fournisseurs ne pouvaient pas être chargées. Rafraîchissez la liste avant de prendre d'autres mesures.",
    "accounting_ap_ageing_fetch_failed": "Le vieillissement du fournisseur n'a pas pu être chargé. Rafraîchissez le rapport de vieillissement.",
    "accounting_ap_ageing_detail_failed": "Le vieillissement du fournisseur n'a pas pu être chargé. Rafraîchissez le rapport de vieillissement.",
    "ap_bill_missing_lines": "Ajouter au moins une ligne de facture valide avant l'affichage.",
    "invalid_bill_lines": "Ajouter au moins une ligne de facture valide avant l'affichage.",
    "ap_bill_create_failed": "Le facture sur les fournisseurs n'a pas pu être créé. Examinez les champs et vérifiez un facture existant avant la rentrée.",
    "accounting_ap_bill_create_failed": "Le facture sur les fournisseurs n'a pas pu être créé. Examinez les champs et vérifiez un facture existant avant la rentrée.",
    "ap_bill_not_found": "Une ou plusieurs factures de fournisseurs ne sont pas disponibles. Rafraîchissez la liste et sélectionnez-les à nouveau.",
    "ap_bills_not_found": "Une ou plusieurs factures de fournisseurs ne sont pas disponibles. Rafraîchissez la liste et sélectionnez-les à nouveau.",
    "invalid_bill_ids": "Une ou plusieurs factures de fournisseurs ne sont pas disponibles. Rafraîchissez la liste et sélectionnez-les à nouveau.",
    "ap_bill_locked": "Ce facture ne peut être modifié dans son état actuel. Revoir son historique d'affichage et de paiement.",
    "invalid_bill_status": "Ce facture ne peut être modifié dans son état actuel. Revoir son historique d'affichage et de paiement.",
    "accounting_ap_bill_fetch_failed": "La facture du fournisseur n'a pas pu être chargée. Rafraîchissez les détails de la facture.",
    "ap_bill_void_failed": "La facture du fournisseur n'a pas pu être annulée. Examiner ses allocations et l'état d'affichage.",
    "ap_payment_create_failed": "Le paiement du fournisseur n'a pas pu être enregistré. Vérifiez les paiements existants avant la rentrée.",
    "no_outstanding_balance": "Il n'y a pas de solde à régler. Rafraîchissez les dossiers sélectionnés.",
    "invalid_allocation": "Examiner les cibles et les montants sélectionnés avant de poursuivre.",
    "invalid_allocation_target": "Examiner les cibles et les montants sélectionnés avant de poursuivre.",
    "ap_payment_not_found": "Ce paiement n'est pas disponible. Rafraîchissez l'historique des paiements.",
    "payment_not_found": "Ce paiement n'est pas disponible. Rafraîchissez l'historique des paiements.",
    "ap_refund_create_failed": "Le remboursement n'a pas pu être enregistré. Vérifiez l'historique des paiements avant la rentrée.",
    "refund_payment_create_failed": "Le remboursement n'a pas pu être enregistré. Vérifiez l'historique des paiements avant la rentrée.",
    "accounting_settings_fetch_failed": "Examiner les paramètres comptables et certains comptes de contrôle, de revenus et de paiement.",
    "invalid_accounting_settings_value": "Examiner les paramètres comptables et certains comptes de contrôle, de revenus et de paiement.",
    "invalid_accounting_settings_accounts": "Examiner les paramètres comptables et certains comptes de contrôle, de revenus et de paiement.",
    "invalid_fiscal_year_start_month": "Sélectionnez un mois de début d'exercice de 1 à 12.",
    "tax_profile_fetch_failed": "La configuration fiscale ne pouvait pas être chargée ou sauvegardée. Examinez les paramètres fiscaux du club et réessayez.",
    "tax_profile_update_failed": "La configuration fiscale ne pouvait pas être chargée ou sauvegardée. Examinez les paramètres fiscaux du club et réessayez.",
    "tax_defaults_apply_failed": "La configuration fiscale ne pouvait pas être chargée ou sauvegardée. Examinez les paramètres fiscaux du club et réessayez.",
    "tax_codes_fetch_failed": "L'opération de code fiscal n'a pas pu être complétée. Examinez le code fiscal et ses références avant la rentrée.",
    "tax_codes_create_failed": "L'opération de code fiscal n'a pas pu être complétée. Examinez le code fiscal et ses références avant la rentrée.",
    "tax_codes_update_failed": "L'opération de code fiscal n'a pas pu être complétée. Examinez le code fiscal et ses références avant la rentrée.",
    "tax_codes_delete_failed": "L'opération de code fiscal n'a pas pu être complétée. Examinez le code fiscal et ses références avant la rentrée.",
    "invalid_tax_rate": "Inscrivez un taux d'imposition valide sans modifier le traitement fiscal prévu.",
    "invalid_effective_dates": "La date de fin effective ne doit pas précéder la date de début effective.",
    "invalid_category": "Sélectionnez une catégorie d'impôt disponible.",
    "tax_code_exists": "Ce code fiscal existe déjà. Choisissez un code unique.",
    "tax_code_not_found": "Ce code fiscal n'est pas disponible. Rafraîchissez la liste des codes fiscaux.",
    "invoice_layout_fetch_failed": "La mise en page de la facture n'a pas pu être chargée ou sauvegardée. Révisez ses paramètres et réessayez.",
    "invoice_layout_save_failed": "La mise en page de la facture n'a pas pu être chargée ou sauvegardée. Révisez ses paramètres et réessayez.",
    "invalid_billing_email": "Entrez une adresse e-mail de facturation valide ou laissez-la vierge.",
    "invalid_accent_hex_color": "Entrez une couleur HEX valide.",
    "member_not_found": "Le compte membre ou membre n'est pas disponible. Rafraîchissez la sélection des membres.",
    "member_account_not_found": "Le compte membre ou membre n'est pas disponible. Rafraîchissez la sélection des membres.",
    "member_membership_type_missing": "Définir un type d'adhésion pour ce membre avant de les inscrire.",
    "membership_type_frequency_ambiguous": "Choisissez une fréquence de facturation explicite pendant l'inscription.",
    "membership_type_dues_required": "Entrez un montant de cotisation supérieur à zéro, ou configurez les cotisations de type membre.",
    "membership_type_frequency_required": "Sélectionnez une fréquence mensuelle, trimestrielle ou annuelle avant d'activer la facturation récurrente.",
    "membership_type_quarterly_dues_unsupported": "Inscrivez un montant trimestriel explicite ou utilisez un mandat mensuel ou annuel.",
    "missing_vat_gl_account": "Configurer le compte de sortie VAT GL pour les codes fiscaux touchés avant l'affichage.",
    "journal_entry_create_failed": "La revue n'a pas pu être créée. Vérifiez l'histoire de l'affichage et les cartographies avant la rentrée.",
    "missing_recipient_email": "Définir une adresse email du destinataire avant d'envoyer la facture.",
    "missing_resend_api_key": "La livraison par courriel n'est pas configurée. La facture reste disponible; contactez un administrateur.",
    "statement_total_zero": "Il n'y a pas de montants impayables pour cette déclaration. Examiner la période choisie.",
    "invoice_create_failed": "La facture n'a pas pu être générée. Vérifiez la liste des factures avant de réessayer pour éviter les doubles emplois.",
    "generate_invoice_failed": "La facture n'a pas pu être générée. Vérifiez la liste des factures avant de réessayer pour éviter les doubles emplois.",
    "recurring_billing_settings_fetch_failed": "Les paramètres de facturation récurrents ne pouvaient pas être chargés ou sauvegardés. Révisez les paramètres et réessayez.",
    "recurring_billing_settings_update_failed": "Les paramètres de facturation récurrents ne pouvaient pas être chargés ou sauvegardés. Révisez les paramètres et réessayez.",
    "recurring_billing_runs_fetch_failed": "La course de facturation n'a pas pu être chargée. Rafraîchissez la liste d'exécution ou les détails.",
    "recurring_billing_run_detail_failed": "La course de facturation n'a pas pu être chargée. Rafraîchissez la liste d'exécution ou les détails.",
    "run_not_found": "Cette course est indisponible. Rafraîchissez la liste d'exécution.",
    "payroll_run_not_found": "Cette course est indisponible. Rafraîchissez la liste d'exécution.",
    "invalid_payment_date": "Entrez une date de paiement valide.",
    "record_run_payments_failed": "Exécuter les paiements ne pouvait pas être enregistré. Réviser l'historique des paiements avant la rentrée.",
    "recurring_billing_templates_fetch_failed": "Les inscriptions en facturation n'ont pas pu être chargées ou mises à jour. Rafraîchissez la sélection et réessayez seulement les articles échoués.",
    "recurring_billing_enrollments_fetch_failed": "Les inscriptions en facturation n'ont pas pu être chargées ou mises à jour. Rafraîchissez la sélection et réessayez seulement les articles échoués.",
    "recurring_billing_enrollments_bulk_failed": "Les inscriptions en facturation n'ont pas pu être chargées ou mises à jour. Rafraîchissez la sélection et réessayez seulement les articles échoués.",
    "invalid_period": "Sélectionnez une période de facturation valide.",
    "invalid_billing_period": "Sélectionnez une période de facturation valide.",
    "recurring_billing_member_detail_fetch_failed": "L'aperçu de facturation membre ne pouvait pas être chargé. Rafraîchissez l'énoncé sélectionné.",
    "recurring_billing_invoice_preview_failed": "L'aperçu de facturation membre ne pouvait pas être chargé. Rafraîchissez l'énoncé sélectionné.",
    "recurring_billing_current_run_preview_failed": "L'aperçu de facturation membre ne pouvait pas être chargé. Rafraîchissez l'énoncé sélectionné.",
    "generate_and_send_invoice_failed": "La génération ou la livraison des factures ont échoué. Vérifiez la facturation et l'état de livraison avant de réessayer.",
    "generate_club_run_failed": "La course de facturation du club n'a pas pu se terminer. Réviser les factures générées et les échecs par membre avant la rentrée.",
    "recurring_billing_run_due_failed": "La course de facturation du club n'a pas pu se terminer. Réviser les factures générées et les échecs par membre avant la rentrée.",
    "charge_cannot_change_billing_run": "Cette charge ne peut pas passer à une autre course de facturation dans son état actuel.",
    "charge_not_found": "Cette charge n'est pas disponible. Rafraîchissez la déclaration.",
    "charge_billing_run_update_failed": "Le placement en facturation de cette charge n'a pas pu être mis à jour. Rafraîchissez la déclaration avant la rentrée.",
    "charge_exclude_failed": "Le placement en facturation de cette charge n'a pas pu être mis à jour. Rafraîchissez la déclaration avant la rentrée.",
    "charge_defer_failed": "Le placement en facturation de cette charge n'a pas pu être mis à jour. Rafraîchissez la déclaration avant la rentrée.",
    "charge_include_failed": "Le placement en facturation de cette charge n'a pas pu être mis à jour. Rafraîchissez la déclaration avant la rentrée.",
    "confirmation_required": "Remplissez la confirmation requise avant de poursuivre.",
    "recurring_template_validation_failed": "Examiner le modèle récurrent, le montant des cotisations positives, l'état actif et la fréquence de facturation.",
    "template_not_found": "Examiner le modèle récurrent, le montant des cotisations positives, l'état actif et la fréquence de facturation.",
    "template_not_active": "Examiner le modèle récurrent, le montant des cotisations positives, l'état actif et la fréquence de facturation.",
    "accounting_invoices_fetch_failed": "La facture n'a pas pu être chargée ou téléchargée. Rafraîchissez la liste des factures et réessayez.",
    "accounting_invoice_fetch_failed": "La facture n'a pas pu être chargée ou téléchargée. Rafraîchissez la liste des factures et réessayez.",
    "invoice_download_failed": "La facture n'a pas pu être chargée ou téléchargée. Rafraîchissez la liste des factures et réessayez.",
    "invoice_not_found": "Cette facture n'est pas disponible. Rafraîchissez la liste des factures.",
    "invoice_not_editable": "Cette facture ne peut pas être modifiée dans son état actuel. Utilisez le flux de travail de note de crédit ou de renversement existant, le cas échéant.",
    "invalid_invoice_status": "Cette facture ne peut pas être modifiée dans son état actuel. Utilisez le flux de travail de note de crédit ou de renversement existant, le cas échéant.",
    "missing_invoice_currency": "La facture n'a pas de monnaie. Révisez sa configuration de source avant l'affichage.",
    "invoice_missing_lines": "Ajouter les lignes de facture valides avant l'affichage.",
    "missing_accounting_settings": "Compléter les comptes de contrôle comptable et les cartes des revenus et des états de paie requis avant l'affichage.",
    "missing_mappings": "Compléter les comptes de contrôle comptable et les cartes des revenus et des états de paie requis avant l'affichage.",
    "missing_tax_code_on_taxable_line": "Sélectionnez un code fiscal efficace pour chaque ligne taxable avant l'affichage.",
    "invoice_amount_mismatch": "Les totaux de facturation ne correspondent pas aux lignes source. Rafraîchissez et examinez les lignes avant d'afficher.",
    "journal_not_balanced": "Les débits et les crédits ne sont pas équilibrés. Examinez les lignes de la revue et les cartographies avant l'affichage.",
    "payroll_finance_preview_not_balanced": "Les débits et les crédits ne sont pas équilibrés. Examinez les lignes de la revue et les cartographies avant l'affichage.",
    "refund_exceeds_allocated_amount": "Le remboursement dépasse le montant remboursable. Rafraîchissez le paiement et révisez ses allocations avant de réduire le remboursement.",
    "refund_exceeds_total_refundable": "Le remboursement dépasse le montant remboursable. Rafraîchissez le paiement et révisez ses allocations avant de réduire le remboursement.",
    "refund_exceeds_invoice_amount": "Le remboursement dépasse le montant remboursable. Rafraîchissez le paiement et révisez ses allocations avant de réduire le remboursement.",
    "refund_exceeds_unapplied_amount": "Le remboursement dépasse le montant remboursable. Rafraîchissez le paiement et révisez ses allocations avant de réduire le remboursement.",
    "invalid_bank_account": "Sélectionnez un compte bancaire disponible avec la cartographie GL requise.",
    "payment_create_failed": "Le paiement n'a pas pu être enregistré. Examiner les paiements existants avant la rentrée.",
    "accounting_member_summary_failed": "Les créances ne pouvaient pas être chargées. Revoir la liste des créances avant de continuer.",
    "receivables_summary_fetch_failed": "Les créances ne pouvaient pas être chargées. Revoir la liste des créances avant de continuer.",
    "receivables_fetch_failed": "Les créances ne pouvaient pas être chargées. Revoir la liste des créances avant de continuer.",
    "receivable_fetch_failed": "Les créances ne pouvaient pas être chargées. Revoir la liste des créances avant de continuer.",
    "member_ar_backfill_failed": "Impossible de charger le compte membre. Actualisez le compte et vérifiez son historique avant de continuer.",
    "member_ar_accounts_fetch_failed": "Impossible de charger le compte membre. Actualisez le compte et vérifiez son historique avant de continuer.",
    "member_ar_summary_fetch_failed": "Impossible de charger le compte membre. Actualisez le compte et vérifiez son historique avant de continuer.",
    "member_ar_account_resolve_failed": "Impossible de charger le compte membre. Actualisez le compte et vérifiez son historique avant de continuer.",
    "member_ar_transactions_fetch_failed": "Impossible de charger le compte membre. Actualisez le compte et vérifiez son historique avant de continuer.",
    "member_ar_open_invoices_fetch_failed": "Impossible de charger le compte membre. Actualisez le compte et vérifiez son historique avant de continuer.",
    "source_not_found": "La transaction d'origine n'est pas disponible. Examiner la référence de source ou contacter un administrateur.",
    "source_resolve_failed": "La transaction d'origine n'est pas disponible. Examiner la référence de source ou contacter un administrateur.",
    "member_statement_fetch_failed": "La déclaration de membre ne peut être chargée ou générée. Réviser l'intervalle de date et la rentrée.",
    "member_statement_generate_failed": "La déclaration de membre ne peut être chargée ou générée. Réviser l'intervalle de date et la rentrée.",
    "invoice_not_allocatable": "La facture ou la créance sélectionnée ne peut pas recevoir cette allocation. Rafraîchissez son solde et son état en souffrance.",
    "receivable_not_allocatable": "La facture ou la créance sélectionnée ne peut pas recevoir cette allocation. Rafraîchissez son solde et son état en souffrance.",
    "invalid_invoice_ids": "La facture ou la créance sélectionnée ne peut pas recevoir cette allocation. Rafraîchissez son solde et son état en souffrance.",
    "invoice_not_open": "La facture ou la créance sélectionnée ne peut pas recevoir cette allocation. Rafraîchissez son solde et son état en souffrance.",
    "invalid_parent_payment": "Sélectionnez le paiement original admissible à ce remboursement.",
    "invoice_required": "Sélectionnez la facture applicable avant de créer la note de crédit.",
    "credit_note_requires_invoice": "Sélectionnez la facture applicable avant de créer la note de crédit.",
    "credit_note_exceeds_invoice_amount": "Le crédit dépasse le montant disponible. Rafraîchissez le solde de facture ou de crédit et réduisez le montant.",
    "credit_exceeds_available": "Le crédit dépasse le montant disponible. Rafraîchissez le solde de facture ou de crédit et réduisez le montant.",
    "credit_note_missing_lines": "Ajouter au moins une ligne de crédit valide.",
    "credit_note_create_failed": "L'opération de la note de crédit a échoué. Rafraîchissez la liste de la note de crédit et examinez la facture avant la rentrée.",
    "credit_notes_fetch_failed": "L'opération de la note de crédit a échoué. Rafraîchissez la liste de la note de crédit et examinez la facture avant la rentrée.",
    "credit_note_fetch_failed": "L'opération de la note de crédit a échoué. Rafraîchissez la liste de la note de crédit et examinez la facture avant la rentrée.",
    "credit_note_not_found": "La note de crédit ou le crédit sélectionné n'est pas disponible. Rafraîchissez le compte.",
    "credit_not_found": "La note de crédit ou le crédit sélectionné n'est pas disponible. Rafraîchissez le compte.",
    "invalid_credit_note_status": "Cette note de crédit ne peut pas être utilisée dans son état actuel. Examiner son historique d'affichage et d'application.",
    "credit_note_void_not_allowed": "Cette note de crédit ne peut pas être utilisée dans son état actuel. Examiner son historique d'affichage et d'application.",
    "credit_note_not_posted": "Cette note de crédit ne peut pas être utilisée dans son état actuel. Examiner son historique d'affichage et d'application.",
    "credit_note_void_failed": "La note de crédit n'a pas pu être annulée. Réviser ses applications avant la rentrée.",
    "credit_application_create_failed": "La demande de crédit ne peut pas être modifiée comme demandé. Rafraîchissez l'état actuel avant la rentrée.",
    "credit_application_not_found": "La demande de crédit ne peut pas être modifiée comme demandé. Rafraîchissez l'état actuel avant la rentrée.",
    "credit_application_already_void": "La demande de crédit ne peut pas être modifiée comme demandé. Rafraîchissez l'état actuel avant la rentrée.",
    "credit_application_not_applied": "La demande de crédit ne peut pas être modifiée comme demandé. Rafraîchissez l'état actuel avant la rentrée.",
    "period_locked": "Cette date d'affichage tombe dans une période verrouillée ou fermée. Changez la date ou demandez un déverrouillage autorisé.",
    "gl_period_locked": "Cette date d'affichage tombe dans une période verrouillée ou fermée. Changez la date ou demandez un déverrouillage autorisé.",
    "locked_period": "Cette date d'affichage tombe dans une période verrouillée ou fermée. Changez la date ou demandez un déverrouillage autorisé.",
    "period_closed": "Cette date d'affichage tombe dans une période verrouillée ou fermée. Changez la date ou demandez un déverrouillage autorisé.",
    "payroll_request_failed": "La demande de paye a échoué. Rafraîchissez la course et examinez son état avant la rentrée.",
    "invalid_id": "Le dossier de paie sélectionné n'est pas disponible. Rafraîchissez la sélection.",
    "not_found": "Le dossier de paie sélectionné n'est pas disponible. Rafraîchissez la sélection.",
    "profile_not_found": "Le dossier de paie sélectionné n'est pas disponible. Rafraîchissez la sélection.",
    "department_not_found": "Le dossier de paie sélectionné n'est pas disponible. Rafraîchissez la sélection.",
    "name_required": "Entrez un nom avant d'enregistrer.",
    "unsupported_payment_jurisdiction": "Les détails de paiement ne sont pas pris en charge pour la compétence configurée. Réviser les paramètres de la paie.",
    "replacement_reason_required": "Entrez une raison avant de remplacer les détails de paiement.",
    "invalid_rate_type": "Choisissez un type de tarif ou un statut pris en charge avant d'enregistrer.",
    "invalid_status": "Choisissez un type de tarif ou un statut pris en charge avant d'enregistrer.",
    "invalid_verification_status": "Choisissez un type de tarif ou un statut pris en charge avant d'enregistrer.",
    "payment_details_not_found": "Enregistrer les détails de paiement avant de les vérifier.",
    "timesheet_locked": "Cette feuille de temps est verrouillée. Utilisez le workflow de réouverture autorisé avant d'éditer.",
    "timesheet_lines_required": "Ajouter des lignes de feuille de temps valides ou l'explication de zéro heure requise.",
    "zero_hours_note_required": "Ajouter des lignes de feuille de temps valides ou l'explication de zéro heure requise.",
    "run_not_recalculable": "Cette course de la paie ne peut pas être changée dans son état actuel. Réviser le retour autorisé ou rouvrir les actions.",
    "run_not_mutable": "Cette course de la paie ne peut pas être changée dans son état actuel. Réviser le retour autorisé ou rouvrir les actions.",
    "payroll_not_editable": "Cette course de la paie ne peut pas être changée dans son état actuel. Réviser le retour autorisé ou rouvrir les actions.",
    "payroll_locked": "Cette course de la paie ne peut pas être changée dans son état actuel. Réviser le retour autorisé ou rouvrir les actions.",
    "payroll_period_id_required": "Sélectionnez une période de paye ouverte disponible.",
    "period_not_found": "Sélectionnez une période de paye ouverte disponible.",
    "period_not_open": "Sélectionnez une période de paye ouverte disponible.",
    "duplicate_active_run": "Une course active existe déjà pour cette période. Ouvrez la course existante au lieu de créer un duplicata.",
    "blocker_not_found": "Ce bloqueur ou décision n'est plus disponible. Rafraîchissez l'examen des états de paie.",
    "decision_not_allowed": "Ce bloqueur ou décision n'est plus disponible. Rafraîchissez l'examen des états de paie.",
    "provider_deductions_not_required": "Les déductions du fournisseur ne sont pas requises dans ce mode de paie. Examinez la source légale configurée.",
    "no_payroll_run_lines": "Rafraîchissez les lignes calculées des employés avant d'économiser les intrants légaux.",
    "duplicate_payroll_run_line_id": "Rafraîchissez les lignes calculées des employés avant d'économiser les intrants légaux.",
    "unknown_payroll_run_line_id": "Rafraîchissez les lignes calculées des employés avant d'économiser les intrants légaux.",
    "legacy_run_level_statutory_totals": "Les totaux réglementaires du cycle ne sont pas des bulletins de paie individuels. Saisissez les valeurs de chaque salarié avant de générer les bulletins définitifs.",
    "statutory_inputs_stale": "La paie a été recalculée après que les valeurs légales ont été sauvegardées. Examiner et réintégrer les intrants légaux des employés.",
    "payroll_run_not_review_stage": "Déplacer la masse salariale à son stade d'examen avant d'entrer dans les valeurs légales.",
    "payroll_blockers_unresolved": "Résoudre les bloqueurs de paie avant de passer à la prochaine étape.",
    "run_has_blockers": "Résoudre les bloqueurs de paie avant de passer à la prochaine étape.",
    "employee_statutory_rows_missing": "Terminé PAYE, Employé NI et Employeur NI pour chaque employé inclus avant de continuer.",
    "employee_statutory_row_missing": "Terminé PAYE, Employé NI et Employeur NI pour chaque employé inclus avant de continuer.",
    "payroll_line_incomplete": "Terminé PAYE, Employé NI et Employeur NI pour chaque employé inclus avant de continuer.",
    "employee_statutory_row_incomplete": "Terminé PAYE, Employé NI et Employeur NI pour chaque employé inclus avant de continuer.",
    "payroll_line_final_values_missing": "Terminé PAYE, Employé NI et Employeur NI pour chaque employé inclus avant de continuer.",
    "payslip_totals_do_not_reconcile": "Les totaux de Payslip ne se réconcilieront pas avec la paye. Réviser les valeurs légales des employés et les totaux d'exécution.",
    "invalid_status_transition": "Ce changement d'étape de la paie n'est pas autorisé. Rafraîchissez la course et utilisez sa prochaine action disponible.",
    "finance_posting_required": "Postez le journal de paie à la comptabilité avant d'enregistrer le paiement.",
    "gl_post_required": "Postez le journal de paie à la comptabilité avant d'enregistrer le paiement.",
    "payroll_not_ready_to_lock": "Postes financiers complets, payables et paiement du personnel avant le verrouillage des états de paie.",
    "provider_deductions_required": "Entrez les valeurs légales fournies par le fournisseur avant de continuer.",
    "payroll_already_posted": "Payroll est déjà posté. Examiner la revue existante et utiliser les actions réversives autorisées lorsque disponibles.",
    "tenant_schema_out_of_date": "La base de données du club n'est pas prête pour cette opération de paie. Support de contact avec la référence de la demande.",
    "payslip_snapshot_locked": "Les snapshots de paylip émis sont verrouillés et ne peuvent être régénérés silencieusement.",
    "final_payslips_pdf_not_ready": "Générer des PDFs finaux valides avant d'être publiés sur le portail du personnel.",
    "invalid_calculation_mode": "Examinez le mode de calcul des états de paie, la fréquence et les dates du calendrier avant d'enregistrer.",
    "invalid_payroll_frequency": "Examinez le mode de calcul des états de paie, la fréquence et les dates du calendrier avant d'enregistrer.",
    "invalid_default_payment_day": "Examinez le mode de calcul des états de paie, la fréquence et les dates du calendrier avant d'enregistrer.",
    "invalid_approval_deadline_days": "Examinez le mode de calcul des états de paie, la fréquence et les dates du calendrier avant d'enregistrer.",
    "invalid_next_run_date": "Examinez le mode de calcul des états de paie, la fréquence et les dates du calendrier avant d'enregistrer.",
    "accounting_reports_fetch_failed": "L'opération de rapport n'a pas pu être terminée. Rafraîchissez les rapports sauvegardés et examinez la configuration.",
    "accounting_reports_create_failed": "L'opération de rapport n'a pas pu être terminée. Rafraîchissez les rapports sauvegardés et examinez la configuration.",
    "accounting_reports_update_failed": "L'opération de rapport n'a pas pu être terminée. Rafraîchissez les rapports sauvegardés et examinez la configuration.",
    "accounting_reports_delete_failed": "L'opération de rapport n'a pas pu être terminée. Rafraîchissez les rapports sauvegardés et examinez la configuration.",
    "missing_budget_version": "Sélectionnez un budget et une version disponibles avant d'exécuter ce rapport.",
    "missing_budget_params": "Sélectionnez un budget et une version disponibles avant d'exécuter ce rapport.",
    "budget_not_found": "Sélectionnez un budget et une version disponibles avant d'exécuter ce rapport.",
    "report_not_found": "Ce rapport n'est pas disponible ou son type n'est pas reconnu. Sélectionnez un rapport supporté.",
    "report_type_not_supported": "Ce rapport n'est pas disponible ou son type n'est pas reconnu. Sélectionnez un rapport supporté.",
    "invalid_date_range": "Entrez une date de début et de fin valide dans l'ordre correct.",
    "accounting_gl_month_end_tasks_fetch_failed": "La liste de vérification de fin de mois n'a pas pu être chargée. Rafraîchissez la période avant de continuer.",
    "invalid_entry_class": "Sélectionnez une classe d'entrée supportée pour cette exception.",
    "member_receivables_balance_unresolved": "Le solde à recevoir du membre n’a pas pu être réglé. Rafraîchissez le compte membre avant d’attribuer un paiement.",
    "payroll_payment_encryption_config_invalid": "Impossible de traiter les coordonnées bancaires de paie en toute sécurité. Demandez à un administrateur de vérifier la configuration du chiffrement de la paie avant de réessayer.",
    "payroll_payment_kms_client_unavailable": "Impossible de traiter les coordonnées bancaires de paie en toute sécurité. Demandez à un administrateur de vérifier la configuration du chiffrement de la paie avant de réessayer.",
    "payroll_payment_kms_key_not_configured": "Impossible de traiter les coordonnées bancaires de paie en toute sécurité. Demandez à un administrateur de vérifier la configuration du chiffrement de la paie avant de réessayer.",
    "payroll_payment_kms_data_key_failed": "Impossible de traiter les coordonnées bancaires de paie en toute sécurité. Demandez à un administrateur de vérifier la configuration du chiffrement de la paie avant de réessayer.",
    "payroll_payment_kms_decrypt_failed": "Impossible de traiter les coordonnées bancaires de paie en toute sécurité. Demandez à un administrateur de vérifier la configuration du chiffrement de la paie avant de réessayer.",
    "account_holder_name_required": "Entrez le nom du titulaire du compte bancaire.",
    "invalid_sort_code": "Entrez un code de tri valide de six chiffres.",
    "invalid_account_number": "Entrez un numéro de compte bancaire valide pour le système de paiement sélectionné.",
    "invalid_routing_number": "Entrez un numéro de routage américain valide de neuf chiffres.",
    "account_number_required": "Entrez le numéro de compte bancaire.",
    "invalid_account_type": "Choisissez un type de compte bancaire pris en charge.",
    "invalid_iban": "Entrez un IBAN valide.",
    "unsupported_payment_scheme": "Ce système de paiement n’est pas pris en charge pour la compétence configurée du club. Réviser les paramètres de la paie.",
    "payment_file_decryption_not_wired_until_approved_run_generation": "Le décryptage de fichier bancaire n'est disponible qu'au cours de la génération approuvée de payroll-run. Approuvez la course avant de générer le fichier.",
    "invalid_billable_recurring_receivables_args": "Sélectionnez un club valide, un membre et une période de facturation, puis rechargez la déclaration.",
    "invalid_current_statement_args": "Sélectionnez un club valide, un membre et une période de facturation, puis rechargez la déclaration.",
    "tax_code_required": "Sélectionnez un code fiscal pour chaque ligne taxable avant d'afficher.",
    "invalid_tax_code": "Un code fiscal sélectionné est invalide ou indisponible pour la date d'affichage. Examiner les lignes concernées et la configuration du code fiscal.",
    "unsupported_revenue_source": "Cette source de revenus n'appuie pas l'affichage demandé. Ouvrez sa transaction source et examinez le flux de travail supporté.",
    "posting_source_not_found": "La transaction source pour cet affichage n'a pas été trouvée. Rafraîchissez l'enregistrement source avant la rentrée.",
    "original_batch_not_found": "On n'a pas trouvé le lot original d'affichage. Révisez le journal source avant de demander un renversement."
  },
  "documents": {
    "invoice": "Facture",
    "date": "Date {date}",
    "due": "{date}",
    "billedTo": "Facturé à",
    "member": "Membre",
    "club": "Club",
    "description": "Description",
    "quantity": "Qté",
    "unit": "Unité",
    "total": "Total",
    "charge": "Charge",
    "subtotal": "Sous-total",
    "tax": "Taxe",
    "amountDue": "Montant dû",
    "thankYou": "Merci pour vos affaires !",
    "greeting": "Bonjour {name},",
    "attached": "Votre dernière facture de {club} est jointe.",
    "ready": "Votre facture de facturation récurrente {number} est prête.",
    "amount": "Montant: {amount}",
    "dueDate": "Date limite: {date}",
    "contact": "Si vous avez des questions, veuillez contacter {club} à {contact} .",
    "thanks": "Merci.",
    "subject": "Facture de {club} – {number}",
    "subjectWithoutNumber": "Votre facture à partir de {club}",
    "unavailable": "Non disponible",
    "draft": "BROUILLON",
    "payslipPayslip": "Paylip",
    "payslipEmployee": "Employé",
    "payslipReference": "Référence",
    "payslipJobtitle": "Titre d ' emploi",
    "payslipDepartment": "Département",
    "payslipPayrollrun": "Cycle de paie",
    "payslipPayrollsourcereference": "Source/référence de la masse salariale",
    "payslipPayment": "Paiement",
    "payslipEarnings": "Gains",
    "payslipBasepaysalary": "Indemnité de base / salaire",
    "payslipOvertimepay": "Indemnités supplémentaires",
    "payslipHolidaypay": "Paye de vacances",
    "payslipSickpay": "Indemnités",
    "payslipGrosspay": "Montant brut",
    "payslipDeductions": "Déductions",
    "payslipPAYEIncomeTax": "Impôt sur le revenu",
    "payslipEmployeeNationalInsurance": "Assurance nationale",
    "payslipEmployeePension": "Pension des employés",
    "payslipOtherEmployeeDeductions": "Autres déductions des employés",
    "payslipTotalDeductions": "Total des déductions",
    "payslipNetpay": "Solde net",
    "payslipEmployercontributions": "Contributions des employeurs",
    "payslipEmployerNationalInsurance": "Employeur Assurance nationale",
    "payslipEmployerPension": "Pension d ' employeur",
    "payslipOtherEmployerCosts": "Autres coûts de l'employeur",
    "payslipTotalEmployerContributions": "Total des contributions de l ' employeur",
    "payslipThisisyourpayslipfortheperiodshownabove": "C'est votre fiche de paie pour la période indiquée ci-dessus.",
    "payslipPeriod": "Période de paye {start} à {end}",
    "payslipPayDate": "Date de paye {date}",
    "payslipBank": "Transfert bancaire se terminant {last4}",
    "payslipTitle": "Bulletin de paie {run}"
  },
  "lifecycle": {
    "included": "Inclus dans {run}",
    "paidVia": "Payé via {source}",
    "billingRun": "Cour de facturation: {run}",
    "settledBy": "Réglé par {source}"
  },
  "debtorTypes": {
    "member": "Membre",
    "guest": "Invité",
    "ad_hoc": "Ad-hoc",
    "supplier": "Fournisseur",
    "company": "Société"
  },
  "confirmations": {
    "yearEnd": "Cela ferme l'exercice et ne peut être dupliqué. Type {confirmation} à confirmer."
  },
  "batch": {
    "memberResult": "Membre {member} : articles sautés : {skipped} ; articles cartographiés : {mapped} .",
    "failure": "Membre {member} : {reason}",
    "recovery": "Réviser les factures générées et chaque échec de membre avant la rentrée."
  },
  "csv": {
    "column": "Colonne {number}",
    "parse": "Les CSV ne pouvaient pas être parsés. Vérifiez les cotes et les nombres de colonnes.",
    "quotes": "Le CSV contient des citations invalides. Vérifiez la ligne {row} .",
    "delimiter": "Le délimiteur de CSV n'a pas pu être détecté.",
    "fields": "Le nombre de champs ne correspond pas aux colonnes de la rangée {row} .",
    "read": "Le fichier CSV ne peut pas être lu. Sélectionnez un fichier valide.",
    "date": "Row {row} : valeur de date invalide.",
    "description": "Row {row} : description manquante.",
    "amount": "Row {row} : montant invalide."
  },
  "enums": {
    "accountType": {
      "asset": "Actif",
      "liability": "Responsabilité",
      "equity": "Équité",
      "revenue": "Chiffre d’affaires",
      "expense": "Dépense"
    },
    "period": {
      "open": "Ouvrir",
      "closed": "Fermé",
      "locked": "Verrouillés",
      "ready": "Prêt",
      "blocked": "Bloqué",
      "pass": "Pas.",
      "fail": "Échec",
      "warning": "Attention",
      "not_applicable": "Sans objet"
    },
    "payment": {
      "received": "Reçus",
      "paid": "Payé",
      "pending": "En attente",
      "failed": "Échec",
      "completed": "Terminé",
      "refunded": "Remboursé",
      "partially_refunded": "Remboursés partiellement",
      "void": "Annulé",
      "voided": "Annulés",
      "allocated": "Affecté",
      "unapplied": "Non appliquée",
      "partially_applied": "Partiellement appliquée",
      "fully_applied": "Entièrement appliquée"
    },
    "source": {
      "membership_dues": "Frais d ' admission",
      "membership": "Adhésion",
      "pos": "Restauration et bar",
      "dining": "Restauration et bar",
      "bar": "Restauration et bar",
      "events": "Évènements",
      "golf": "Golf",
      "spa": "Spa",
      "fitness": "Fitness",
      "polo": "Polo",
      "marina": "Marina",
      "racquet": "Raquette",
      "hotel": "Hôtel",
      "rooms": "Hôtel / Chambres",
      "lessons": "Enseignements",
      "pro_shop": "Détail / Pro Shop",
      "retail": "Détail / Pro Shop",
      "weddings": "Mariages",
      "member_account": "Compte membre",
      "invoice": "Facture",
      "charge": "Charge",
      "ad_hoc": "Ad-hoc",
      "supplier": "Fournisseur",
      "member": "Membre",
      "guest": "Invité",
      "payroll": "Solde"
    },
    "frequency": {
      "weekly": "Semaine",
      "fortnightly": "Bonne nuit.",
      "monthly": "mensuel",
      "quarterly": "Trimestre",
      "annual": "Annuelle",
      "annually": "annuellement",
      "yearly": "Année"
    },
    "payroll": {
      "draft": "Brouillon",
      "review": "Examen",
      "calculated": "Calculé",
      "awaiting_approval": "Attendant l ' approbation",
      "approved": "Postes approuvés",
      "posted": "Comptabilisé",
      "paid": "Payé",
      "locked": "Verrouillés",
      "ready": "Prêt",
      "active": "Actif",
      "inactive": "Inactif",
      "missing_details": "Détails manquants",
      "on_hold": "En attente",
      "leaver": "Levain",
      "verified": "Vérifié",
      "unverified": "Non vérifié",
      "pending": "En attente",
      "missing": "Portée disparue",
      "not_ready": "Pas prêt.",
      "preview_ready": "Aperçu prêt",
      "not_required": "Non requis",
      "enrolled": "Inscription",
      "opted_out": "Opté pour",
      "salary": "Salaire",
      "hourly": "Heureux",
      "casual": "Occasionnels",
      "contractor": "Entrepreneur",
      "hybrid": "Traitement + ajustements",
      "submitted": "Soumis",
      "rejected": "Rejetée",
      "regular": "ordinaire",
      "overtime": "Heures supplémentaires",
      "holiday": "Vacances",
      "sick": "Malades",
      "training": "Formation",
      "adjustment": "Ajustement",
      "checking": "Vérification",
      "savings": "Soldes",
      "fixed_day_of_month": "Jour fixe du mois",
      "last_day_of_month": "Dernier jour du mois",
      "last_working_day_of_month": "Dernier jour ouvrable du mois",
      "days_after_period_end": "Jours après la fin de la période"
    },
    "billing": {
      "not_enrolled": "Non inscrits",
      "enrolled": "Inscription",
      "active": "Actif",
      "paused": "Pause",
      "unbilled": "Non facturé",
      "invoiced": "Facturé",
      "draft": "Brouillon",
      "pending": "En attente",
      "issued": "Délivré",
      "posted": "Comptabilisé",
      "open": "Ouvrir",
      "paid": "Payé",
      "part_paid": "Partie payée",
      "partially_paid": "Partiellement payé",
      "overdue": "En retard",
      "sent": "Envoyé",
      "failed": "Échec",
      "skipped": "Ignoré",
      "scheduled": "Planifié",
      "excluded": "Exclus",
      "deferred": "Déferré",
      "generated": "Générée",
      "included_current": "Inclus dans le courant de la facturation",
      "included_future": "Inclus dans la future série de facturation",
      "latest_dues_invoice_paid": "Dernières factures payées",
      "latest_dues_invoice_open": "Dernières factures ouvertes",
      "latest_dues_invoice_overdue": "Dernières factures en retard",
      "projected_not_generated": "Projecté, non généré"
    },
    "bank": {
      "unmatched": "Inégalé",
      "partially_matched": "Partiellement assortie",
      "matched": "Associés",
      "reconciled": "Reconciliés",
      "ignored": "Ignorée"
    },
    "reportStatus": {
      "draft": "Brouillon",
      "open": "Ouvert",
      "posted": "Comptabilisé",
      "paid": "Payé",
      "partially_paid": "Partiellement payé",
      "void": "Annulé",
      "refunded": "Remboursé",
      "unpaid": "Non payé",
      "overdue": "En retard",
      "reconciled": "Reconciliés",
      "pending": "En attente",
      "approved": "Postes approuvés",
      "closed": "Fermé"
    }
  },
  "match": {
    "supplier": "Fournisseur: {name}",
    "member": "Membre: {name}"
  },
  "payroll": {
    "pensionSummary": "Fournisseur {provider} • Employé {employee} • Club {club}",
    "multiplier": "{value} x multiplicateur",
    "periodRange": "{name} — {start} – {end}",
    "periodRangeWithPay": "{name} — {start} – {end} — Pay {pay}"
  },
  "glMemo": {
    "memberSale": "Vente de SP {sale} — {member}",
    "guestSale": "POS vente {sale} — Invité",
    "sale": "Pos vente {sale}",
    "golf": "Frais de réservation de golf"
  },
  "validation": {
    "paymentRange": "Le montant doit être compris entre 0 et {amount} ."
  },
  "billing": {
    "itemCountOne": "Articles : {count}",
    "itemCountOther": "Articles : {count}",
    "currentStatement": "État actuel ( {period} )",
    "moveBack": "Retour à cette déclaration",
    "nextRun": "Prochaine course de facturation",
    "futureRun": "Fuite future de facturation",
    "deferredFrom": "Reporté à partir de {period}",
    "deferredEarlier": "Reporté à la facturation antérieure",
    "mappingWarning": "Une charge n'a pas de cartographie des revenus (clé de mappage: {key} ). Configurer la cartographie avant l'affichage.",
    "warning": "Examiner cet avertissement de facturation avant de continuer."
  },
  "final": {
    "rows": "Rangées",
    "schedule": "Planning",
    "saveSettings": "Sauvegarder les paramètres",
    "required": "Obligatoire",
    "yearReadiness": "{year} état de préparation"
  },
  "yearEnd": {
    "closedBy": "Fin de l'exercice clos le {date} par {person}",
    "closed": "Fin de l'exercice clos le {date}"
  },
  "payrollExceptions": {
    "missing_calendar": {
      "title": "Calendrier des états de paie manquant",
      "description": "Attribuez cet employé actif à un calendrier de paie."
    },
    "missing_rate": {
      "title": "Manque de taux actif",
      "description": "Ajouter un taux de paye actif couvrant cette période de paye."
    },
    "profile_readiness": {
      "title": "Bloqueur de préparation de profil",
      "description": "Examiner les détails de la banque, de l’impôt et de la pension de l’employé."
    },
    "missing_approved_timesheet": {
      "title": "Feuille de temps approuvée manquante",
      "description": "Approuver la feuille de temps de l’employé ou réviser la confirmation permise pour cette course avant de procéder."
    },
    "invalid_rate": {
      "title": "Taux de rémunération fixe invalide",
      "description": "Le salaire fixe et les profils hybrides ont besoin d'un taux de salaire pour leur composante fixe."
    },
    "holiday_unpaid": {
      "title": "Heures de vacances exclues",
      "description": "Les règles de paye actuelles ne permettent pas la paye des vacances."
    },
    "sick_unpaid": {
      "title": "Heures de maladie exclues",
      "description": "Les règles de paye actuelles ne permettent pas de payer les malades."
    },
    "missing_mapping": {
      "title": "Manquement de la cartographie des états de paie",
      "description": "Configurer les comptes de débit et de crédit pour ce coût ou responsabilité de la paie dans les paramètres des états de paie."
    },
    "provider_deductions_required": {
      "title": "Contributions statutaires nécessaires",
      "description": "Évaluer et économiser les montants de PAYE et d'assurance nationale des employés et des employés/employeurs pour chaque employé avant l'approbation."
    },
    "employer_social_security_review": {
      "title": "Examen par l'employeur NI requis",
      "description": "Examiner la configuration de la contribution de l'employeur avant la paie peut procéder."
    }
  },
  "timesheets": {
    "missing": "Les employés qui manquent de feuilles de temps pour cette période de paye: {count} .",
    "awaiting": "Feuilles de temps soumises en attente d'approbation pour cette période de paye: {count} .",
    "overtime": "Les heures supplémentaires sont concentrées pour la période de paye choisie.",
    "approved": "Toutes les feuilles de temps soumises sont approuvées pour la période de paye choisie."
  },
  "periods": {
    "closeEarlier": "Fermer {periods} avant de fermer {period} .",
    "earlierRequired": "Les périodes comptables antérieures doivent être fermées en premier.",
    "fiscalMonth": "FY {year} Mois {month}"
  },
  "defaults": {
    "summary": "Compétence : {jurisdiction} . Revenu, VAT , cartes de paie et comptes de contrôle vérifiés. VAT cartes mises à jour : {tax} . Politiques de paye examinées : {policies} . Personnalisations existantes conservées.",
    "uk": "Royaume-Uni",
    "us": "États-Unis",
    "region": "Région des états de paie du Club"
  },
  "portalCategories": {
    "membership": "Adhésion",
    "dining": "Restauration et bar",
    "golf": "Golf",
    "spa": "Spa",
    "racquet": "Raquette",
    "fitness": "Fitness",
    "rooms": "Hôtel / Chambres",
    "events": "Évènements",
    "other": "Autres frais de compte"
  }
};
